var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _g2, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _g3, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _g4, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _g5, _rect, _path530, _path531, _path532, _g6, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _rect2, _rect3, _rect4, _path541, _g7, _path542, _g8, _path543, _path544, _g9, _path545, _g0, _path546, _path547, _path548, _path549, _g1, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _g10, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _g11, _path573, _path574, _g12, _path575, _path576, _path577, _path578, _path579, _path580, _g13, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _g14, _path593, _path594, _g15, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _g16, _path610, _path611, _path612, _path613, _path614, _rect5, _path615, _path616, _g17, _path617, _path618, _path619, _g18, _path620, _path621, _path622, _g19, _g20, _path623, _path624, _path625, _path626, _g21, _g22, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _rect6, _rect7, _rect8, _rect9, _rect0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerImg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10392",
    "data-name": "Group 10392",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 779.461,
    height: 644.513,
    viewBox: "0 0 779.461 644.513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2355",
    "data-name": "Rectangle 2355",
    width: 779.461,
    height: 644.513,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2316",
    "data-name": "Rectangle 2316",
    width: 42.084,
    height: 260.249,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2317",
    "data-name": "Rectangle 2317",
    width: 41.322,
    height: 219.423,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2318",
    "data-name": "Rectangle 2318",
    width: 42.567,
    height: 280.643,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2319",
    "data-name": "Rectangle 2319",
    width: 59.195,
    height: 298.213,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2320",
    "data-name": "Rectangle 2320",
    width: 76.149,
    height: 189.574,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29188",
    "data-name": "Path 29188",
    d: "M24.205,8.575a19.265,19.265,0,0,0-3.468,11.062V316.358H191.472V19.637A19.265,19.265,0,0,0,188,8.575Z",
    transform: "translate(-20.737 -8.575)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.278,
    y1: 2.03,
    x2: -0.264,
    y2: 2.03,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaedfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#aed1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aed1fc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2327",
    "data-name": "Rectangle 2327",
    width: 34.018,
    height: 34.017,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2331",
    "data-name": "Rectangle 2331",
    width: 43.19,
    height: 154.006,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2332",
    "data-name": "Rectangle 2332",
    width: 179.172,
    height: 25.878,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2333",
    "data-name": "Rectangle 2333",
    width: 20.674,
    height: 28.491,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29294",
    "data-name": "Path 29294",
    d: "M243.011,107.262a1.953,1.953,0,1,0,3.905,0c0-1.08-.874-3.908-1.954-3.908s-1.952,2.828-1.952,3.908",
    transform: "translate(-243.011 -103.354)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -142.361,
    y1: 69.613,
    x2: -141.776,
    y2: 69.613,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8957e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d36cf9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2336",
    "data-name": "Rectangle 2336",
    width: 7.511,
    height: 25.819,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29312",
    "data-name": "Path 29312",
    d: "M290.854,109.868a22.436,22.436,0,0,0-22.774,22.886l7.136,54.638-6.39,51.528a65.474,65.474,0,0,0,47.918,4.649l15.578-4.649L328.5,178.087l11.019-44.875c.837-12.336-9.527-23.344-21.982-23.344Z",
    transform: "translate(-268.08 -109.868)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -8.475,
    y1: 2.842,
    x2: -8.443,
    y2: 2.842,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5956f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#615fe3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2339",
    "data-name": "Rectangle 2339",
    width: 27.965,
    height: 29.573,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29331",
    "data-name": "Path 29331",
    d: "M304.813,110.495c-2.1.6-5.56-1.862-21,51.553,0,0,18.72,9.98,23.119,9.065.934-.837,10.923-33.937,12.105-37.144,5.354-14.5-10.648-23.511-13.922-23.511a1.093,1.093,0,0,0-.307.037",
    transform: "translate(-283.817 -110.458)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -9.22,
    y1: 7.761,
    x2: -9.187,
    y2: 7.761,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2343",
    "data-name": "Rectangle 2343",
    width: 106.196,
    height: 54.593,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2344",
    "data-name": "Rectangle 2344",
    width: 158.019,
    height: 81.235,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2345",
    "data-name": "Rectangle 2345",
    width: 60.616,
    height: 29.266,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2346",
    "data-name": "Rectangle 2346",
    width: 375.018,
    height: 111.662,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2347",
    "data-name": "Rectangle 2347",
    width: 105.255,
    height: 47.834,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2348",
    "data-name": "Rectangle 2348",
    width: 96.827,
    height: 71.627,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10391",
    "data-name": "Group 10391",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10329",
    "data-name": "Group 10329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10328",
    "data-name": "Group 10328",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10315",
    "data-name": "Group 10315",
    transform: "translate(158.213 250.844)",
    opacity: 0.64,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10314",
    "data-name": "Group 10314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10313",
    "data-name": "Group 10313",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28400",
    "data-name": "Path 28400",
    d: "M109.267,136.381H97.725V111.6a1.959,1.959,0,0,0-1.958-1.958H69.151v260.25h42.086V138.326a1.959,1.959,0,0,0-1.97-1.945",
    transform: "translate(-69.153 -109.64)",
    fill: "#a5d9fa"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_28401",
    "data-name": "Path 28401",
    d: "M318.909,347.1V129.27a1.6,1.6,0,0,0-1.608-1.588l-98.474,0a1.6,1.6,0,0,0-1.608,1.59V347.1Z",
    transform: "translate(279.757 164.44)",
    fill: "#eff1fd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28402",
    "data-name": "Path 28402",
    d: "M319.079,347.1V129.27a1.6,1.6,0,0,0-1.608-1.588l-77.306,0a1.6,1.6,0,0,0-1.608,1.59V347.1Z",
    transform: "translate(307.238 164.44)",
    fill: "#a5d9fa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28403",
    "data-name": "Path 28403",
    d: "M246.466,170.926h0a5.386,5.386,0,0,1-5.386-5.386V135.233a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(310.489 167.231)",
    fill: "#e5e7f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28404",
    "data-name": "Path 28404",
    d: "M245.67,129.847h-1.293a1.937,1.937,0,0,1,1.938,1.938v37.206a1.937,1.937,0,0,1-1.938,1.936h1.293a1.937,1.937,0,0,0,1.938-1.936V131.785a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(314.735 167.231)",
    fill: "#f8f9fd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28405",
    "data-name": "Path 28405",
    d: "M306.672,154.631H243.837a2.759,2.759,0,0,1,0-5.518h62.835a2.759,2.759,0,0,1,0,5.518",
    transform: "translate(310.489 192.044)",
    fill: "#e5e7f2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28406",
    "data-name": "Path 28406",
    d: "M270.836,149.113h-1.293a1.937,1.937,0,0,1,1.938,1.938v1.643a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938v-1.643a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(347.147 192.044)",
    fill: "#f8f9fd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28407",
    "data-name": "Path 28407",
    d: "M254.884,170.926h0a5.386,5.386,0,0,1-5.386-5.386V135.233a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(321.331 167.231)",
    fill: "#e5e7f2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28408",
    "data-name": "Path 28408",
    d: "M254.088,129.847H252.8a1.939,1.939,0,0,1,1.938,1.938v37.206a1.938,1.938,0,0,1-1.938,1.936h1.293a1.938,1.938,0,0,0,1.938-1.936V131.785a1.939,1.939,0,0,0-1.938-1.938",
    transform: "translate(325.577 167.231)",
    fill: "#f8f9fd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28409",
    "data-name": "Path 28409",
    d: "M254.884,170.926h0a5.386,5.386,0,0,1-5.386-5.386V135.233a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(321.331 167.231)",
    fill: "#e5e7f2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28410",
    "data-name": "Path 28410",
    d: "M254.088,129.847H252.8a1.939,1.939,0,0,1,1.938,1.938v37.206a1.938,1.938,0,0,1-1.938,1.936h1.293a1.938,1.938,0,0,0,1.938-1.936V131.785a1.939,1.939,0,0,0-1.938-1.938",
    transform: "translate(325.577 167.231)",
    fill: "#f8f9fd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28411",
    "data-name": "Path 28411",
    d: "M263.3,170.926h0a5.386,5.386,0,0,1-5.386-5.386V135.233a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(332.172 167.231)",
    fill: "#e5e7f2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28412",
    "data-name": "Path 28412",
    d: "M262.506,129.847h-1.293a1.937,1.937,0,0,1,1.938,1.938v37.206a1.937,1.937,0,0,1-1.938,1.936h1.293a1.937,1.937,0,0,0,1.938-1.936V131.785a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(336.418 167.231)",
    fill: "#f8f9fd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28413",
    "data-name": "Path 28413",
    d: "M271.72,170.926h0a5.386,5.386,0,0,1-5.386-5.386V135.233a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(343.014 167.231)",
    fill: "#e5e7f2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28414",
    "data-name": "Path 28414",
    d: "M270.924,129.847h-1.293a1.937,1.937,0,0,1,1.938,1.938v37.206a1.937,1.937,0,0,1-1.938,1.936h1.293a1.937,1.937,0,0,0,1.938-1.936V131.785a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(347.26 167.231)",
    fill: "#f8f9fd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28415",
    "data-name": "Path 28415",
    d: "M246.466,194.538h0a5.386,5.386,0,0,1-5.386-5.386V158.845a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(310.489 197.641)",
    fill: "#e5e7f2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28416",
    "data-name": "Path 28416",
    d: "M245.67,153.459h-1.293a1.937,1.937,0,0,1,1.938,1.938V192.6a1.937,1.937,0,0,1-1.938,1.936h1.293a1.937,1.937,0,0,0,1.938-1.936V155.4a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(314.735 197.641)",
    fill: "#f8f9fd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28417",
    "data-name": "Path 28417",
    d: "M306.672,178.243H243.837a2.759,2.759,0,0,1,0-5.518h62.835a2.759,2.759,0,0,1,0,5.518",
    transform: "translate(310.489 222.454)",
    fill: "#e5e7f2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28418",
    "data-name": "Path 28418",
    d: "M270.836,172.725h-1.293a1.937,1.937,0,0,1,1.938,1.938v1.643a1.937,1.937,0,0,1-1.938,1.938h1.293a1.937,1.937,0,0,0,1.938-1.938v-1.643a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(347.147 222.454)",
    fill: "#f8f9fd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28419",
    "data-name": "Path 28419",
    d: "M254.885,194.538h0a5.388,5.388,0,0,1-5.388-5.386V158.845a5.387,5.387,0,0,1,10.774,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(321.329 197.641)",
    fill: "#e5e7f2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28420",
    "data-name": "Path 28420",
    d: "M254.088,153.459H252.8a1.937,1.937,0,0,1,1.938,1.938V192.6a1.937,1.937,0,0,1-1.938,1.936h1.293a1.937,1.937,0,0,0,1.938-1.936V155.4a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(325.577 197.641)",
    fill: "#f8f9fd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28421",
    "data-name": "Path 28421",
    d: "M254.885,194.538h0a5.388,5.388,0,0,1-5.388-5.386V158.845a5.387,5.387,0,0,1,10.774,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(321.329 197.641)",
    fill: "#e5e7f2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28422",
    "data-name": "Path 28422",
    d: "M254.088,153.459H252.8a1.937,1.937,0,0,1,1.938,1.938V192.6a1.937,1.937,0,0,1-1.938,1.936h1.293a1.937,1.937,0,0,0,1.938-1.936V155.4a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(325.577 197.641)",
    fill: "#f8f9fd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28423",
    "data-name": "Path 28423",
    d: "M263.3,194.538h0a5.386,5.386,0,0,1-5.386-5.386V158.845a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(332.172 197.641)",
    fill: "#e5e7f2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28424",
    "data-name": "Path 28424",
    d: "M262.506,153.459h-1.293a1.937,1.937,0,0,1,1.938,1.938V192.6a1.937,1.937,0,0,1-1.938,1.936h1.293a1.937,1.937,0,0,0,1.938-1.936V155.4a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(336.418 197.641)",
    fill: "#f8f9fd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28425",
    "data-name": "Path 28425",
    d: "M271.72,194.54h0a5.386,5.386,0,0,1-5.386-5.386V158.846a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(343.014 197.64)",
    fill: "#e5e7f2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28426",
    "data-name": "Path 28426",
    d: "M270.924,153.459h-1.293a1.937,1.937,0,0,1,1.938,1.938V192.6a1.935,1.935,0,0,1-1.938,1.936l1.293,0a1.939,1.939,0,0,0,1.938-1.938V155.4a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(347.26 197.641)",
    fill: "#f8f9fd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28427",
    "data-name": "Path 28427",
    d: "M246.466,194.538h0a5.386,5.386,0,0,1-5.386-5.386V158.845a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(310.489 197.641)",
    fill: "#e5e7f2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28428",
    "data-name": "Path 28428",
    d: "M245.67,153.459h-1.293a1.937,1.937,0,0,1,1.938,1.938V192.6a1.937,1.937,0,0,1-1.938,1.936h1.293a1.937,1.937,0,0,0,1.938-1.936V155.4a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(314.735 197.641)",
    fill: "#f8f9fd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28429",
    "data-name": "Path 28429",
    d: "M306.672,178.243H243.837a2.759,2.759,0,0,1,0-5.518h62.835a2.759,2.759,0,0,1,0,5.518",
    transform: "translate(310.489 222.454)",
    fill: "#e5e7f2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28430",
    "data-name": "Path 28430",
    d: "M270.836,172.725h-1.293a1.937,1.937,0,0,1,1.938,1.938v1.643a1.937,1.937,0,0,1-1.938,1.938h1.293a1.937,1.937,0,0,0,1.938-1.938v-1.643a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(347.147 222.454)",
    fill: "#f8f9fd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28431",
    "data-name": "Path 28431",
    d: "M254.885,194.538h0a5.388,5.388,0,0,1-5.388-5.386V158.845a5.387,5.387,0,0,1,10.774,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(321.329 197.641)",
    fill: "#e5e7f2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28432",
    "data-name": "Path 28432",
    d: "M254.088,153.459H252.8a1.937,1.937,0,0,1,1.938,1.938V192.6a1.937,1.937,0,0,1-1.938,1.936h1.293a1.937,1.937,0,0,0,1.938-1.936V155.4a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(325.577 197.641)",
    fill: "#f8f9fd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28433",
    "data-name": "Path 28433",
    d: "M254.885,194.538h0a5.388,5.388,0,0,1-5.388-5.386V158.845a5.387,5.387,0,0,1,10.774,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(321.329 197.641)",
    fill: "#e5e7f2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28434",
    "data-name": "Path 28434",
    d: "M254.088,153.459H252.8a1.937,1.937,0,0,1,1.938,1.938V192.6a1.937,1.937,0,0,1-1.938,1.936h1.293a1.937,1.937,0,0,0,1.938-1.936V155.4a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(325.577 197.641)",
    fill: "#f8f9fd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28435",
    "data-name": "Path 28435",
    d: "M263.3,194.538h0a5.386,5.386,0,0,1-5.386-5.386V158.845a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(332.172 197.641)",
    fill: "#e5e7f2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28436",
    "data-name": "Path 28436",
    d: "M262.506,153.459h-1.293a1.937,1.937,0,0,1,1.938,1.938V192.6a1.937,1.937,0,0,1-1.938,1.936h1.293a1.937,1.937,0,0,0,1.938-1.936V155.4a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(336.418 197.641)",
    fill: "#f8f9fd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28437",
    "data-name": "Path 28437",
    d: "M271.72,194.54h0a5.386,5.386,0,0,1-5.386-5.386V158.846a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(343.014 197.64)",
    fill: "#e5e7f2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28438",
    "data-name": "Path 28438",
    d: "M270.924,153.459h-1.293a1.937,1.937,0,0,1,1.938,1.938V192.6a1.935,1.935,0,0,1-1.938,1.936l1.293,0a1.939,1.939,0,0,0,1.938-1.938V155.4a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(347.26 197.641)",
    fill: "#f8f9fd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28439",
    "data-name": "Path 28439",
    d: "M246.466,218.153h0a5.386,5.386,0,0,1-5.386-5.386V182.459a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(310.489 228.051)",
    fill: "#e5e7f2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28440",
    "data-name": "Path 28440",
    d: "M245.67,177.071h-1.293a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V179.009a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(314.735 228.051)",
    fill: "#f8f9fd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28441",
    "data-name": "Path 28441",
    d: "M306.672,201.854H243.837a2.758,2.758,0,0,1,0-5.516h62.835a2.758,2.758,0,1,1,0,5.516",
    transform: "translate(310.489 252.865)",
    fill: "#e5e7f2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28442",
    "data-name": "Path 28442",
    d: "M270.836,196.337h-1.293a1.937,1.937,0,0,1,1.938,1.938v1.643a1.937,1.937,0,0,1-1.938,1.936h1.293a1.937,1.937,0,0,0,1.938-1.936v-1.643a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(347.147 252.864)",
    fill: "#f8f9fd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28443",
    "data-name": "Path 28443",
    d: "M254.884,218.153h0a5.386,5.386,0,0,1-5.386-5.386V182.459a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(321.331 228.051)",
    fill: "#e5e7f2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28444",
    "data-name": "Path 28444",
    d: "M254.088,177.071H252.8a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V179.009a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(325.577 228.051)",
    fill: "#f8f9fd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28445",
    "data-name": "Path 28445",
    d: "M254.884,218.153h0a5.386,5.386,0,0,1-5.386-5.386V182.459a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(321.331 228.051)",
    fill: "#e5e7f2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28446",
    "data-name": "Path 28446",
    d: "M254.088,177.071H252.8a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V179.009a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(325.577 228.051)",
    fill: "#f8f9fd"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28447",
    "data-name": "Path 28447",
    d: "M263.3,218.153h0a5.386,5.386,0,0,1-5.386-5.386V182.459a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(332.172 228.051)",
    fill: "#e5e7f2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28448",
    "data-name": "Path 28448",
    d: "M262.506,177.071h-1.293a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V179.009a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(336.418 228.051)",
    fill: "#f8f9fd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28449",
    "data-name": "Path 28449",
    d: "M271.72,218.153h0a5.386,5.386,0,0,1-5.386-5.386V182.459a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(343.014 228.051)",
    fill: "#e5e7f2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28450",
    "data-name": "Path 28450",
    d: "M270.924,177.071h-1.293a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V179.009a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(347.26 228.051)",
    fill: "#f8f9fd"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28451",
    "data-name": "Path 28451",
    d: "M246.466,241.765h0a5.386,5.386,0,0,1-5.386-5.386V206.071a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(310.489 258.461)",
    fill: "#e5e7f2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28452",
    "data-name": "Path 28452",
    d: "M245.67,200.683h-1.293a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V202.621a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(314.735 258.461)",
    fill: "#f8f9fd"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28453",
    "data-name": "Path 28453",
    d: "M306.672,225.467H243.837a2.759,2.759,0,0,1,0-5.518l62.835,0a2.758,2.758,0,1,1,0,5.516",
    transform: "translate(310.489 283.274)",
    fill: "#e5e7f2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28454",
    "data-name": "Path 28454",
    d: "M270.836,219.949h-1.293a1.937,1.937,0,0,1,1.938,1.938v1.643a1.937,1.937,0,0,1-1.938,1.936h1.293a1.937,1.937,0,0,0,1.938-1.936v-1.643a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(347.147 283.274)",
    fill: "#f8f9fd"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28455",
    "data-name": "Path 28455",
    d: "M254.885,241.765h0a5.388,5.388,0,0,1-5.388-5.386V206.071a5.387,5.387,0,1,1,10.774,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(321.329 258.461)",
    fill: "#e5e7f2"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28456",
    "data-name": "Path 28456",
    d: "M254.088,200.683H252.8a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V202.621a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(325.577 258.461)",
    fill: "#f8f9fd"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28457",
    "data-name": "Path 28457",
    d: "M254.885,241.765h0a5.388,5.388,0,0,1-5.388-5.386V206.071a5.387,5.387,0,1,1,10.774,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(321.329 258.461)",
    fill: "#e5e7f2"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28458",
    "data-name": "Path 28458",
    d: "M254.088,200.683H252.8a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V202.621a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(325.577 258.461)",
    fill: "#f8f9fd"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28459",
    "data-name": "Path 28459",
    d: "M263.3,241.765h0a5.386,5.386,0,0,1-5.386-5.386V206.071a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(332.172 258.461)",
    fill: "#e5e7f2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28460",
    "data-name": "Path 28460",
    d: "M262.506,200.683h-1.293a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V202.621a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(336.418 258.461)",
    fill: "#f8f9fd"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28461",
    "data-name": "Path 28461",
    d: "M271.72,241.765h0a5.386,5.386,0,0,1-5.386-5.386V206.071a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(343.014 258.461)",
    fill: "#e5e7f2"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28462",
    "data-name": "Path 28462",
    d: "M270.924,200.683h-1.293a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V202.621a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(347.26 258.461)",
    fill: "#f8f9fd"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28463",
    "data-name": "Path 28463",
    d: "M234.722,170.928h0a5.386,5.386,0,0,0,5.386-5.386V135.234a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(295.364 167.23)",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28464",
    "data-name": "Path 28464",
    d: "M231.273,129.847h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.939,1.939,0,0,0,1.938,1.938h-1.293a1.939,1.939,0,0,1-1.938-1.938V131.785a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(295.363 167.231)",
    fill: "#a5d9fa"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28465",
    "data-name": "Path 28465",
    d: "M223.582,154.63h24.73a2.759,2.759,0,0,0,0-5.518h-24.73a2.759,2.759,0,1,0,0,5.518",
    transform: "translate(284.4 192.043)",
    fill: "#fff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28466",
    "data-name": "Path 28466",
    d: "M222.761,149.113h1.293a1.937,1.937,0,0,0-1.938,1.938v1.643a1.937,1.937,0,0,0,1.938,1.938h-1.293a1.937,1.937,0,0,1-1.938-1.938v-1.643a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(284.4 192.044)",
    fill: "#a5d9fa"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28467",
    "data-name": "Path 28467",
    d: "M226.3,170.928h0a5.388,5.388,0,0,0,5.388-5.386V135.234a5.387,5.387,0,1,0-10.774,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(284.522 167.23)",
    fill: "#e5e7f2"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28468",
    "data-name": "Path 28468",
    d: "M222.855,129.847h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.939,1.939,0,0,0,1.938,1.938h-1.293a1.939,1.939,0,0,1-1.938-1.938V131.785a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(284.521 167.231)",
    fill: "#f8f9fd"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28469",
    "data-name": "Path 28469",
    d: "M226.3,170.928h0a5.388,5.388,0,0,0,5.388-5.386V135.234a5.387,5.387,0,1,0-10.774,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(284.522 167.23)",
    fill: "#fff"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28470",
    "data-name": "Path 28470",
    d: "M222.855,129.847h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.939,1.939,0,0,0,1.938,1.938h-1.293a1.939,1.939,0,0,1-1.938-1.938V131.785a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(284.521 167.231)",
    fill: "#a5d9fa"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28471",
    "data-name": "Path 28471",
    d: "M234.722,194.614h0a5.386,5.386,0,0,0,5.386-5.386V158.92a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(295.364 197.735)",
    fill: "#fff"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28472",
    "data-name": "Path 28472",
    d: "M231.273,153.533h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.939,1.939,0,0,0,1.938,1.938h-1.293a1.939,1.939,0,0,1-1.938-1.938V155.471a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(295.363 197.737)",
    fill: "#a5d9fa"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28473",
    "data-name": "Path 28473",
    d: "M223.582,178.315h24.73a2.758,2.758,0,1,0,0-5.516h-24.73a2.758,2.758,0,1,0,0,5.516",
    transform: "translate(284.4 222.549)",
    fill: "#fff"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28474",
    "data-name": "Path 28474",
    d: "M222.761,172.8h1.293a1.937,1.937,0,0,0-1.938,1.938v1.643a1.937,1.937,0,0,0,1.938,1.936h-1.293a1.937,1.937,0,0,1-1.938-1.936v-1.643a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(284.4 222.549)",
    fill: "#a5d9fa"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28475",
    "data-name": "Path 28475",
    d: "M226.3,194.614h0a5.386,5.386,0,0,0,5.386-5.386V158.92a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(284.522 197.735)",
    fill: "#e5e7f2"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28476",
    "data-name": "Path 28476",
    d: "M222.855,153.533h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.939,1.939,0,0,0,1.938,1.938h-1.293a1.939,1.939,0,0,1-1.938-1.938V155.471a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(284.521 197.737)",
    fill: "#f8f9fd"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28477",
    "data-name": "Path 28477",
    d: "M226.3,194.614h0a5.386,5.386,0,0,0,5.386-5.386V158.92a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(284.522 197.735)",
    fill: "#fff"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28478",
    "data-name": "Path 28478",
    d: "M222.855,153.533h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.939,1.939,0,0,0,1.938,1.938h-1.293a1.939,1.939,0,0,1-1.938-1.938V155.471a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(284.521 197.737)",
    fill: "#a5d9fa"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28479",
    "data-name": "Path 28479",
    d: "M234.722,194.614h0a5.386,5.386,0,0,0,5.386-5.386V158.92a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(295.364 197.735)",
    fill: "#fff"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28480",
    "data-name": "Path 28480",
    d: "M231.273,153.533h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.939,1.939,0,0,0,1.938,1.938h-1.293a1.939,1.939,0,0,1-1.938-1.938V155.471a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(295.363 197.737)",
    fill: "#a5d9fa"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28481",
    "data-name": "Path 28481",
    d: "M223.582,178.315h24.73a2.758,2.758,0,1,0,0-5.516h-24.73a2.758,2.758,0,1,0,0,5.516",
    transform: "translate(284.4 222.549)",
    fill: "#fff"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28482",
    "data-name": "Path 28482",
    d: "M222.761,172.8h1.293a1.937,1.937,0,0,0-1.938,1.938v1.643a1.937,1.937,0,0,0,1.938,1.936h-1.293a1.937,1.937,0,0,1-1.938-1.936v-1.643a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(284.4 222.549)",
    fill: "#a5d9fa"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28483",
    "data-name": "Path 28483",
    d: "M226.3,194.614h0a5.386,5.386,0,0,0,5.386-5.386V158.92a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(284.522 197.735)",
    fill: "#e5e7f2"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28484",
    "data-name": "Path 28484",
    d: "M222.855,153.533h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.939,1.939,0,0,0,1.938,1.938h-1.293a1.939,1.939,0,0,1-1.938-1.938V155.471a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(284.521 197.737)",
    fill: "#f8f9fd"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28485",
    "data-name": "Path 28485",
    d: "M226.3,194.614h0a5.386,5.386,0,0,0,5.386-5.386V158.92a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(284.522 197.735)",
    fill: "#fff"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28486",
    "data-name": "Path 28486",
    d: "M222.855,153.533h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.939,1.939,0,0,0,1.938,1.938h-1.293a1.939,1.939,0,0,1-1.938-1.938V155.471a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(284.521 197.737)",
    fill: "#a5d9fa"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28487",
    "data-name": "Path 28487",
    d: "M234.722,218.3h0a5.386,5.386,0,0,0,5.386-5.386V182.6a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(295.364 228.242)",
    fill: "#fff"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28488",
    "data-name": "Path 28488",
    d: "M231.273,177.219h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.937,1.937,0,0,0,1.938,1.936h-1.293a1.937,1.937,0,0,1-1.938-1.936V179.157a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(295.363 228.242)",
    fill: "#a5d9fa"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28489",
    "data-name": "Path 28489",
    d: "M223.582,202h24.73a2.758,2.758,0,1,0,0-5.516h-24.73a2.758,2.758,0,1,0,0,5.516",
    transform: "translate(284.4 253.055)",
    fill: "#fff"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28490",
    "data-name": "Path 28490",
    d: "M222.761,196.485h1.293a1.937,1.937,0,0,0-1.938,1.938v1.643A1.937,1.937,0,0,0,224.053,202h-1.293a1.937,1.937,0,0,1-1.938-1.936v-1.643a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(284.4 253.055)",
    fill: "#a5d9fa"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28491",
    "data-name": "Path 28491",
    d: "M226.3,218.3h0a5.386,5.386,0,0,0,5.386-5.386V182.6a5.386,5.386,0,0,0-10.771,0v30.308A5.386,5.386,0,0,0,226.3,218.3",
    transform: "translate(284.522 228.242)",
    fill: "#e5e7f2"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28492",
    "data-name": "Path 28492",
    d: "M222.855,177.219h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.937,1.937,0,0,0,1.938,1.936h-1.293a1.937,1.937,0,0,1-1.938-1.936V179.157a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(284.521 228.242)",
    fill: "#f8f9fd"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28493",
    "data-name": "Path 28493",
    d: "M226.3,218.3h0a5.386,5.386,0,0,0,5.386-5.386V182.6a5.386,5.386,0,0,0-10.771,0v30.308A5.386,5.386,0,0,0,226.3,218.3",
    transform: "translate(284.522 228.242)",
    fill: "#fff"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28494",
    "data-name": "Path 28494",
    d: "M222.855,177.219h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.937,1.937,0,0,0,1.938,1.936h-1.293a1.937,1.937,0,0,1-1.938-1.936V179.157a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(284.521 228.242)",
    fill: "#a5d9fa"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28495",
    "data-name": "Path 28495",
    d: "M234.722,241.986h0a5.386,5.386,0,0,0,5.386-5.386V206.292a5.386,5.386,0,1,0-10.771,0V236.6a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(295.364 258.746)",
    fill: "#fff"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28496",
    "data-name": "Path 28496",
    d: "M231.273,200.9h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.937,1.937,0,0,0,1.938,1.938h-1.293a1.939,1.939,0,0,1-1.938-1.938V202.843a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(295.363 258.747)",
    fill: "#a5d9fa"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28497",
    "data-name": "Path 28497",
    d: "M223.582,225.687h24.73a2.758,2.758,0,1,0,0-5.516h-24.73a2.758,2.758,0,1,0,0,5.516",
    transform: "translate(284.4 283.56)",
    fill: "#fff"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28498",
    "data-name": "Path 28498",
    d: "M222.761,220.171h1.293a1.937,1.937,0,0,0-1.938,1.938v1.643a1.935,1.935,0,0,0,1.938,1.936h-1.293a1.935,1.935,0,0,1-1.938-1.936v-1.643a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(284.4 283.56)",
    fill: "#a5d9fa"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28499",
    "data-name": "Path 28499",
    d: "M226.3,241.986h0a5.386,5.386,0,0,0,5.386-5.386V206.292a5.386,5.386,0,1,0-10.771,0V236.6a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(284.522 258.746)",
    fill: "#e5e7f2"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28500",
    "data-name": "Path 28500",
    d: "M222.855,200.9h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.939,1.939,0,0,0,1.938,1.938h-1.293a1.939,1.939,0,0,1-1.938-1.938V202.843a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(284.521 258.747)",
    fill: "#f8f9fd"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28501",
    "data-name": "Path 28501",
    d: "M226.3,241.986h0a5.386,5.386,0,0,0,5.386-5.386V206.292a5.386,5.386,0,1,0-10.771,0V236.6a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(284.522 258.746)",
    fill: "#fff"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28502",
    "data-name": "Path 28502",
    d: "M222.855,200.9h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.939,1.939,0,0,0,1.938,1.938h-1.293a1.939,1.939,0,0,1-1.938-1.938V202.843a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(284.521 258.747)",
    fill: "#a5d9fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10318",
    "data-name": "Group 10318",
    transform: "translate(488.967 292.12)",
    opacity: 0.64,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10317",
    "data-name": "Group 10317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10316",
    "data-name": "Group 10316",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28503",
    "data-name": "Path 28503",
    d: "M255.04,127.68H215.324a1.6,1.6,0,0,0-1.606,1.59V347.1H255.04Z",
    transform: "translate(-213.718 -127.68)",
    fill: "#a5d9fa"
  }))))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28504",
    "data-name": "Path 28504",
    d: "M276.658,381.719V102.553a1.756,1.756,0,0,0-1.766-1.746H166.783a1.754,1.754,0,0,0-1.766,1.746V381.719Z",
    transform: "translate(212.527 129.83)",
    fill: "#eff1fd"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28505",
    "data-name": "Path 28505",
    d: "M276.844,381.719V102.553a1.754,1.754,0,0,0-1.766-1.746h-84.87a1.754,1.754,0,0,0-1.764,1.746l0,279.166Z",
    transform: "translate(242.696 129.83)",
    fill: "#a5d9fa"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28506",
    "data-name": "Path 28506",
    d: "M255.2,110.817H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.125h58.7a2.128,2.128,0,0,1,2.128,2.125v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 134.923)",
    fill: "#e5e7f2"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28507",
    "data-name": "Path 28507",
    d: "M221.755,104.761h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.126,2.126,0,0,1-2.125,2.125h1.418a2.128,2.128,0,0,0,2.128-2.125v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 134.923)",
    fill: "#f8f9fd"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28508",
    "data-name": "Path 28508",
    d: "M255.2,116.493H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.13,2.13,0,0,1,2.128-2.128h58.7a2.13,2.13,0,0,1,2.128,2.128v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 142.23)",
    fill: "#e5e7f2"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28509",
    "data-name": "Path 28509",
    d: "M221.755,110.436h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.128,2.128,0,0,1-2.125,2.128h1.418a2.13,2.13,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 142.231)",
    fill: "#f8f9fd"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28510",
    "data-name": "Path 28510",
    d: "M255.2,116.493H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.13,2.13,0,0,1,2.128-2.128h58.7a2.13,2.13,0,0,1,2.128,2.128v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 142.23)",
    fill: "#e5e7f2"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28511",
    "data-name": "Path 28511",
    d: "M221.755,110.436h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.128,2.128,0,0,1-2.125,2.128h1.418a2.13,2.13,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 142.231)",
    fill: "#f8f9fd"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28512",
    "data-name": "Path 28512",
    d: "M255.2,122.167H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.125h58.7a2.128,2.128,0,0,1,2.128,2.125v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 149.54)",
    fill: "#e5e7f2"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28513",
    "data-name": "Path 28513",
    d: "M221.755,116.111h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.126,2.126,0,0,1-2.125,2.125h1.418a2.128,2.128,0,0,0,2.128-2.125v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 149.54)",
    fill: "#f8f9fd"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28514",
    "data-name": "Path 28514",
    d: "M255.2,127.843H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.13,2.13,0,0,1,2.128-2.128h58.7a2.13,2.13,0,0,1,2.128,2.128v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 156.848)",
    fill: "#e5e7f2"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28515",
    "data-name": "Path 28515",
    d: "M221.755,121.786h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.128,2.128,0,0,1-2.125,2.128h1.418a2.13,2.13,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 156.849)",
    fill: "#f8f9fd"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28516",
    "data-name": "Path 28516",
    d: "M255.2,133.518H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.13,2.13,0,0,1,2.128-2.128h58.7a2.13,2.13,0,0,1,2.128,2.128v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 164.157)",
    fill: "#e5e7f2"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28517",
    "data-name": "Path 28517",
    d: "M221.755,127.46h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.128,2.128,0,0,1-2.125,2.128h1.418a2.13,2.13,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 164.157)",
    fill: "#f8f9fd"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28518",
    "data-name": "Path 28518",
    d: "M255.2,139.192H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.125h58.7a2.128,2.128,0,0,1,2.128,2.125v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 171.467)",
    fill: "#e5e7f2"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28519",
    "data-name": "Path 28519",
    d: "M221.755,133.135h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.126,2.126,0,0,1-2.125,2.125h1.418a2.128,2.128,0,0,0,2.128-2.125v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 171.466)",
    fill: "#f8f9fd"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28520",
    "data-name": "Path 28520",
    d: "M255.2,144.867H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.125h58.7a2.128,2.128,0,0,1,2.128,2.125v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 178.776)",
    fill: "#e5e7f2"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28521",
    "data-name": "Path 28521",
    d: "M221.755,138.81h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.126,2.126,0,0,1-2.125,2.125h1.418a2.128,2.128,0,0,0,2.128-2.125v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 178.775)",
    fill: "#f8f9fd"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28522",
    "data-name": "Path 28522",
    d: "M255.2,150.542H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.125h58.7a2.128,2.128,0,0,1,2.128,2.125v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 186.085)",
    fill: "#e5e7f2"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28523",
    "data-name": "Path 28523",
    d: "M221.755,144.485h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.128,2.128,0,0,1-2.125,2.128h1.418a2.13,2.13,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 186.083)",
    fill: "#f8f9fd"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28524",
    "data-name": "Path 28524",
    d: "M255.2,156.218H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.13,2.13,0,0,1,2.128-2.128h58.7a2.13,2.13,0,0,1,2.128,2.128v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 193.392)",
    fill: "#e5e7f2"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28525",
    "data-name": "Path 28525",
    d: "M221.755,150.16h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.128,2.128,0,0,1-2.125,2.128h1.418a2.13,2.13,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 193.392)",
    fill: "#f8f9fd"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28526",
    "data-name": "Path 28526",
    d: "M255.2,161.891H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.125h58.7a2.128,2.128,0,0,1,2.128,2.125v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 200.701)",
    fill: "#e5e7f2"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28527",
    "data-name": "Path 28527",
    d: "M221.755,155.835h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.126,2.126,0,0,1-2.125,2.125h1.418a2.128,2.128,0,0,0,2.128-2.125v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 200.701)",
    fill: "#f8f9fd"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28528",
    "data-name": "Path 28528",
    d: "M255.2,167.567H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.13,2.13,0,0,1,2.128-2.128h58.7a2.13,2.13,0,0,1,2.128,2.128v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 208.009)",
    fill: "#e5e7f2"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28529",
    "data-name": "Path 28529",
    d: "M221.755,161.51h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.128,2.128,0,0,1-2.125,2.128h1.418a2.13,2.13,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 208.01)",
    fill: "#f8f9fd"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28530",
    "data-name": "Path 28530",
    d: "M255.2,173.242H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.13,2.13,0,0,1,2.128-2.128h58.7a2.13,2.13,0,0,1,2.128,2.128v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 215.318)",
    fill: "#e5e7f2"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28531",
    "data-name": "Path 28531",
    d: "M221.755,167.185h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.128,2.128,0,0,1-2.125,2.128h1.418a2.13,2.13,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 215.319)",
    fill: "#f8f9fd"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28532",
    "data-name": "Path 28532",
    d: "M255.2,178.916H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.125h58.7a2.128,2.128,0,0,1,2.128,2.125v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 222.628)",
    fill: "#e5e7f2"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28533",
    "data-name": "Path 28533",
    d: "M221.755,172.86h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.126,2.126,0,0,1-2.125,2.125h1.418a2.128,2.128,0,0,0,2.128-2.125v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 222.628)",
    fill: "#f8f9fd"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28534",
    "data-name": "Path 28534",
    d: "M255.2,184.592H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.13,2.13,0,0,1,2.128-2.128h58.7a2.13,2.13,0,0,1,2.128,2.128v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 229.935)",
    fill: "#e5e7f2"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28535",
    "data-name": "Path 28535",
    d: "M221.755,178.535h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.128,2.128,0,0,1-2.125,2.128h1.418a2.13,2.13,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 229.937)",
    fill: "#f8f9fd"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28536",
    "data-name": "Path 28536",
    d: "M255.2,190.267H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.13,2.13,0,0,1,2.128-2.128h58.7a2.13,2.13,0,0,1,2.128,2.128v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 237.244)",
    fill: "#e5e7f2"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28537",
    "data-name": "Path 28537",
    d: "M221.755,184.21h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.128,2.128,0,0,1-2.125,2.128h1.418a2.13,2.13,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 237.246)",
    fill: "#f8f9fd"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28538",
    "data-name": "Path 28538",
    d: "M255.2,195.942H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.13,2.13,0,0,1,2.128-2.128h58.7a2.13,2.13,0,0,1,2.128,2.128v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 244.553)",
    fill: "#e5e7f2"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28539",
    "data-name": "Path 28539",
    d: "M221.755,189.884h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.128,2.128,0,0,1-2.125,2.128h1.418a2.13,2.13,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 244.553)",
    fill: "#f8f9fd"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28540",
    "data-name": "Path 28540",
    d: "M255.2,201.616H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.125h58.7a2.128,2.128,0,0,1,2.128,2.125v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 251.863)",
    fill: "#e5e7f2"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28541",
    "data-name": "Path 28541",
    d: "M221.755,195.559h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.126,2.126,0,0,1-2.125,2.125h1.418a2.128,2.128,0,0,0,2.128-2.125v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 251.862)",
    fill: "#f8f9fd"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28542",
    "data-name": "Path 28542",
    d: "M255.2,207.292H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.13,2.13,0,0,1,2.128-2.128h58.7a2.13,2.13,0,0,1,2.128,2.128v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 259.171)",
    fill: "#e5e7f2"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28543",
    "data-name": "Path 28543",
    d: "M221.755,201.234h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.128,2.128,0,0,1-2.125,2.128h1.418a2.13,2.13,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 259.171)",
    fill: "#f8f9fd"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28544",
    "data-name": "Path 28544",
    d: "M255.2,212.966H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.125h58.7a2.128,2.128,0,0,1,2.128,2.125v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 266.481)",
    fill: "#e5e7f2"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28545",
    "data-name": "Path 28545",
    d: "M221.755,206.909h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.126,2.126,0,0,1-2.125,2.125h1.418a2.128,2.128,0,0,0,2.128-2.125v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 266.48)",
    fill: "#f8f9fd"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28546",
    "data-name": "Path 28546",
    d: "M255.2,218.642H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.13,2.13,0,0,1,2.128-2.128h58.7a2.13,2.13,0,0,1,2.128,2.128v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 273.789)",
    fill: "#e5e7f2"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28547",
    "data-name": "Path 28547",
    d: "M221.755,212.584h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.128,2.128,0,0,1-2.125,2.128h1.418a2.13,2.13,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 273.789)",
    fill: "#f8f9fd"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28548",
    "data-name": "Path 28548",
    d: "M255.2,224.317H196.5a2.128,2.128,0,0,1-2.128-2.128v-1.8a2.13,2.13,0,0,1,2.128-2.128h58.7a2.13,2.13,0,0,1,2.128,2.128v1.8a2.128,2.128,0,0,1-2.128,2.128",
    transform: "translate(250.331 281.098)",
    fill: "#e5e7f2"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28549",
    "data-name": "Path 28549",
    d: "M221.755,218.259h-1.418a2.126,2.126,0,0,1,2.125,2.128v1.8a2.128,2.128,0,0,1-2.125,2.128h1.418a2.13,2.13,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128",
    transform: "translate(283.774 281.098)",
    fill: "#f8f9fd"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28550",
    "data-name": "Path 28550",
    d: "M170.522,110.817h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.126,2.126,0,0,0-2.128-2.125h-35.46a2.128,2.128,0,0,0-2.128,2.125v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 134.923)",
    fill: "#fff"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28551",
    "data-name": "Path 28551",
    d: "M170.522,104.761h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.126,2.126,0,0,0,2.125,2.125h-1.418a2.128,2.128,0,0,1-2.128-2.125v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 134.923)",
    fill: "#a5d9fa"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28552",
    "data-name": "Path 28552",
    d: "M170.522,116.493h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128h-35.46a2.13,2.13,0,0,0-2.128,2.128v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 142.23)",
    fill: "#fff"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28553",
    "data-name": "Path 28553",
    d: "M170.522,110.436h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.128,2.128,0,0,0,2.125,2.128h-1.418a2.13,2.13,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 142.231)",
    fill: "#a5d9fa"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28554",
    "data-name": "Path 28554",
    d: "M170.522,116.493h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128h-35.46a2.13,2.13,0,0,0-2.128,2.128v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 142.23)",
    fill: "#fff"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28555",
    "data-name": "Path 28555",
    d: "M170.522,110.436h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.128,2.128,0,0,0,2.125,2.128h-1.418a2.13,2.13,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 142.231)",
    fill: "#a5d9fa"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28556",
    "data-name": "Path 28556",
    d: "M170.522,122.167h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.126,2.126,0,0,0-2.128-2.125h-35.46a2.128,2.128,0,0,0-2.128,2.125v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 149.54)",
    fill: "#fff"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28557",
    "data-name": "Path 28557",
    d: "M170.522,116.111h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.126,2.126,0,0,0,2.125,2.125h-1.418a2.128,2.128,0,0,1-2.128-2.125v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 149.54)",
    fill: "#a5d9fa"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28558",
    "data-name": "Path 28558",
    d: "M170.522,127.843h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128h-35.46a2.13,2.13,0,0,0-2.128,2.128v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 156.848)",
    fill: "#fff"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28559",
    "data-name": "Path 28559",
    d: "M170.522,121.786h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.128,2.128,0,0,0,2.125,2.128h-1.418a2.13,2.13,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 156.849)",
    fill: "#a5d9fa"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28560",
    "data-name": "Path 28560",
    d: "M170.522,133.518h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128h-35.46a2.13,2.13,0,0,0-2.128,2.128v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 164.157)",
    fill: "#fff"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28561",
    "data-name": "Path 28561",
    d: "M170.522,127.46h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.128,2.128,0,0,0,2.125,2.128h-1.418a2.13,2.13,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 164.157)",
    fill: "#a5d9fa"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28562",
    "data-name": "Path 28562",
    d: "M170.522,139.192h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.126,2.126,0,0,0-2.128-2.125h-35.46a2.128,2.128,0,0,0-2.128,2.125v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 171.467)",
    fill: "#fff"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28563",
    "data-name": "Path 28563",
    d: "M170.522,133.135h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.126,2.126,0,0,0,2.125,2.125h-1.418a2.128,2.128,0,0,1-2.128-2.125v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 171.466)",
    fill: "#a5d9fa"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28564",
    "data-name": "Path 28564",
    d: "M170.522,144.867h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.126,2.126,0,0,0-2.128-2.125h-35.46a2.128,2.128,0,0,0-2.128,2.125v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 178.776)",
    fill: "#fff"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28565",
    "data-name": "Path 28565",
    d: "M170.522,138.81h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.126,2.126,0,0,0,2.125,2.125h-1.418a2.128,2.128,0,0,1-2.128-2.125v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 178.775)",
    fill: "#a5d9fa"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28566",
    "data-name": "Path 28566",
    d: "M170.522,150.542h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.126,2.126,0,0,0-2.128-2.125h-35.46a2.128,2.128,0,0,0-2.128,2.125v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 186.085)",
    fill: "#fff"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28567",
    "data-name": "Path 28567",
    d: "M170.522,144.485h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.128,2.128,0,0,0,2.125,2.128h-1.418a2.13,2.13,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 186.083)",
    fill: "#a5d9fa"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28568",
    "data-name": "Path 28568",
    d: "M170.522,156.218h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128h-35.46a2.13,2.13,0,0,0-2.128,2.128v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 193.392)",
    fill: "#fff"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28569",
    "data-name": "Path 28569",
    d: "M170.522,150.16h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.128,2.128,0,0,0,2.125,2.128h-1.418a2.13,2.13,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 193.392)",
    fill: "#a5d9fa"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28570",
    "data-name": "Path 28570",
    d: "M170.522,161.891h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.126,2.126,0,0,0-2.128-2.125h-35.46a2.128,2.128,0,0,0-2.128,2.125v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 200.701)",
    fill: "#fff"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28571",
    "data-name": "Path 28571",
    d: "M170.522,155.835h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.126,2.126,0,0,0,2.125,2.125h-1.418a2.128,2.128,0,0,1-2.128-2.125v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 200.701)",
    fill: "#a5d9fa"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28572",
    "data-name": "Path 28572",
    d: "M170.522,167.567h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128h-35.46a2.13,2.13,0,0,0-2.128,2.128v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 208.009)",
    fill: "#fff"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28573",
    "data-name": "Path 28573",
    d: "M170.522,161.51h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.128,2.128,0,0,0,2.125,2.128h-1.418a2.13,2.13,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 208.01)",
    fill: "#a5d9fa"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28574",
    "data-name": "Path 28574",
    d: "M170.522,173.242h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128h-35.46a2.13,2.13,0,0,0-2.128,2.128v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 215.318)",
    fill: "#fff"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28575",
    "data-name": "Path 28575",
    d: "M170.522,167.185h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.128,2.128,0,0,0,2.125,2.128h-1.418a2.13,2.13,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 215.319)",
    fill: "#a5d9fa"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28576",
    "data-name": "Path 28576",
    d: "M170.522,178.916h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.126,2.126,0,0,0-2.128-2.125h-35.46a2.128,2.128,0,0,0-2.128,2.125v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 222.628)",
    fill: "#fff"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28577",
    "data-name": "Path 28577",
    d: "M170.522,172.86h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.126,2.126,0,0,0,2.125,2.125h-1.418a2.128,2.128,0,0,1-2.128-2.125v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 222.628)",
    fill: "#a5d9fa"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28578",
    "data-name": "Path 28578",
    d: "M170.522,184.592h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128h-35.46a2.13,2.13,0,0,0-2.128,2.128v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 229.935)",
    fill: "#fff"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28579",
    "data-name": "Path 28579",
    d: "M170.522,178.535h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.128,2.128,0,0,0,2.125,2.128h-1.418a2.13,2.13,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 229.937)",
    fill: "#a5d9fa"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28580",
    "data-name": "Path 28580",
    d: "M170.522,190.267h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128h-35.46a2.13,2.13,0,0,0-2.128,2.128v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 237.244)",
    fill: "#fff"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28581",
    "data-name": "Path 28581",
    d: "M170.522,184.21h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.128,2.128,0,0,0,2.125,2.128h-1.418a2.13,2.13,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 237.246)",
    fill: "#a5d9fa"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28582",
    "data-name": "Path 28582",
    d: "M170.522,195.942h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128h-35.46a2.13,2.13,0,0,0-2.128,2.128v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 244.553)",
    fill: "#fff"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28583",
    "data-name": "Path 28583",
    d: "M170.522,189.884h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.128,2.128,0,0,0,2.125,2.128h-1.418a2.13,2.13,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 244.553)",
    fill: "#a5d9fa"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28584",
    "data-name": "Path 28584",
    d: "M170.522,201.616h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.126,2.126,0,0,0-2.128-2.125h-35.46a2.128,2.128,0,0,0-2.128,2.125v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 251.863)",
    fill: "#fff"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28585",
    "data-name": "Path 28585",
    d: "M170.522,195.559h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.126,2.126,0,0,0,2.125,2.125h-1.418a2.128,2.128,0,0,1-2.128-2.125v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 251.862)",
    fill: "#a5d9fa"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28586",
    "data-name": "Path 28586",
    d: "M170.522,207.292h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128h-35.46a2.13,2.13,0,0,0-2.128,2.128v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 259.171)",
    fill: "#fff"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28587",
    "data-name": "Path 28587",
    d: "M170.522,201.234h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.128,2.128,0,0,0,2.125,2.128h-1.418a2.13,2.13,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 259.171)",
    fill: "#a5d9fa"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28588",
    "data-name": "Path 28588",
    d: "M170.522,212.966h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.126,2.126,0,0,0-2.128-2.125h-35.46a2.128,2.128,0,0,0-2.128,2.125v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 266.481)",
    fill: "#fff"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28589",
    "data-name": "Path 28589",
    d: "M170.522,206.909h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.126,2.126,0,0,0,2.125,2.125h-1.418a2.128,2.128,0,0,1-2.128-2.125v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 266.48)",
    fill: "#a5d9fa"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28590",
    "data-name": "Path 28590",
    d: "M170.522,218.642h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128h-35.46a2.13,2.13,0,0,0-2.128,2.128v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 273.789)",
    fill: "#fff"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28591",
    "data-name": "Path 28591",
    d: "M170.522,212.584h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.128,2.128,0,0,0,2.125,2.128h-1.418a2.13,2.13,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 273.789)",
    fill: "#a5d9fa"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28592",
    "data-name": "Path 28592",
    d: "M170.522,224.317h35.46a2.127,2.127,0,0,0,2.128-2.128v-1.8a2.128,2.128,0,0,0-2.128-2.128h-35.46a2.13,2.13,0,0,0-2.128,2.128v1.8a2.128,2.128,0,0,0,2.128,2.128",
    transform: "translate(216.876 281.098)",
    fill: "#fff"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28593",
    "data-name": "Path 28593",
    d: "M170.522,218.259h1.418a2.126,2.126,0,0,0-2.125,2.128v1.8a2.128,2.128,0,0,0,2.125,2.128h-1.418a2.13,2.13,0,0,1-2.128-2.128v-1.8a2.128,2.128,0,0,1,2.128-2.128",
    transform: "translate(216.876 281.098)",
    fill: "#a5d9fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10321",
    "data-name": "Group 10321",
    transform: "translate(377.544 230.637)",
    opacity: 0.64,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10320",
    "data-name": "Group 10320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10319",
    "data-name": "Group 10319",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28594",
    "data-name": "Path 28594",
    d: "M207.584,381.45V100.808h-40.8a1.753,1.753,0,0,0-1.764,1.743v278.9Z",
    transform: "translate(-165.017 -100.806)",
    fill: "#a5d9fa"
  }))))), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28595",
    "data-name": "Path 28595",
    d: "M175.844,391.259V94.636a1.6,1.6,0,0,0-1.608-1.59H75.761a1.6,1.6,0,0,0-1.608,1.588V391.259Z",
    transform: "translate(95.502 119.835)",
    fill: "#eff1fd"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28596",
    "data-name": "Path 28596",
    d: "M176.015,391.259V94.636a1.6,1.6,0,0,0-1.608-1.59H97.1a1.6,1.6,0,0,0-1.608,1.588V391.259Z",
    transform: "translate(122.985 119.835)",
    fill: "#a5d9fa"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28597",
    "data-name": "Path 28597",
    d: "M103.4,136.294h0a5.386,5.386,0,0,1-5.386-5.386V100.6a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(126.236 122.624)",
    fill: "#e5e7f2"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28598",
    "data-name": "Path 28598",
    d: "M102.6,95.212h-1.293a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938H102.6a1.939,1.939,0,0,0,1.938-1.938V97.15a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(130.481 122.624)",
    fill: "#f8f9fd"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28599",
    "data-name": "Path 28599",
    d: "M163.608,120H100.773a2.759,2.759,0,0,1,0-5.518h62.835a2.759,2.759,0,1,1,0,5.518",
    transform: "translate(126.236 147.437)",
    fill: "#e5e7f2"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28600",
    "data-name": "Path 28600",
    d: "M127.772,114.478h-1.293a1.937,1.937,0,0,1,1.938,1.938v1.643A1.939,1.939,0,0,1,126.479,120h1.293a1.939,1.939,0,0,0,1.938-1.938v-1.643a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(162.893 147.437)",
    fill: "#f8f9fd"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28601",
    "data-name": "Path 28601",
    d: "M111.82,136.294h0a5.386,5.386,0,0,1-5.386-5.386V100.6a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(137.077 122.624)",
    fill: "#e5e7f2"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28602",
    "data-name": "Path 28602",
    d: "M111.023,95.212H109.73a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V97.15a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(141.322 122.624)",
    fill: "#f8f9fd"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28603",
    "data-name": "Path 28603",
    d: "M111.82,136.294h0a5.386,5.386,0,0,1-5.386-5.386V100.6a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(137.077 122.624)",
    fill: "#e5e7f2"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28604",
    "data-name": "Path 28604",
    d: "M111.023,95.212H109.73a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V97.15a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(141.322 122.624)",
    fill: "#f8f9fd"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28605",
    "data-name": "Path 28605",
    d: "M120.238,136.294h0a5.386,5.386,0,0,1-5.386-5.386V100.6a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(147.919 122.624)",
    fill: "#e5e7f2"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28606",
    "data-name": "Path 28606",
    d: "M119.441,95.212h-1.293a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V97.15a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(152.164 122.624)",
    fill: "#f8f9fd"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28607",
    "data-name": "Path 28607",
    d: "M128.656,136.294h0a5.386,5.386,0,0,1-5.386-5.386V100.6a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(158.76 122.624)",
    fill: "#e5e7f2"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28608",
    "data-name": "Path 28608",
    d: "M127.859,95.212h-1.293A1.937,1.937,0,0,1,128.5,97.15v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V97.15a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(163.005 122.624)",
    fill: "#f8f9fd"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28609",
    "data-name": "Path 28609",
    d: "M103.4,159.906h0a5.386,5.386,0,0,1-5.386-5.386V124.212a5.386,5.386,0,1,1,10.771,0V154.52a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(126.236 153.034)",
    fill: "#e5e7f2"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28610",
    "data-name": "Path 28610",
    d: "M102.6,118.824h-1.293a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938H102.6a1.939,1.939,0,0,0,1.938-1.938V120.762a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(130.481 153.034)",
    fill: "#f8f9fd"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28611",
    "data-name": "Path 28611",
    d: "M163.608,143.608H100.773a2.759,2.759,0,0,1,0-5.518h62.835a2.759,2.759,0,0,1,0,5.518",
    transform: "translate(126.236 177.847)",
    fill: "#e5e7f2"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28612",
    "data-name": "Path 28612",
    d: "M127.772,138.09h-1.293a1.937,1.937,0,0,1,1.938,1.938v1.643a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938v-1.643a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(162.893 177.847)",
    fill: "#f8f9fd"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28613",
    "data-name": "Path 28613",
    d: "M111.82,159.906h0a5.386,5.386,0,0,1-5.386-5.386V124.212a5.386,5.386,0,1,1,10.771,0V154.52a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(137.077 153.034)",
    fill: "#e5e7f2"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28614",
    "data-name": "Path 28614",
    d: "M111.023,118.824H109.73a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V120.762a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(141.322 153.034)",
    fill: "#f8f9fd"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28615",
    "data-name": "Path 28615",
    d: "M111.82,159.906h0a5.386,5.386,0,0,1-5.386-5.386V124.212a5.386,5.386,0,1,1,10.771,0V154.52a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(137.077 153.034)",
    fill: "#e5e7f2"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28616",
    "data-name": "Path 28616",
    d: "M111.023,118.824H109.73a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V120.762a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(141.322 153.034)",
    fill: "#f8f9fd"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28617",
    "data-name": "Path 28617",
    d: "M120.238,159.906h0a5.386,5.386,0,0,1-5.386-5.386V124.212a5.386,5.386,0,1,1,10.771,0V154.52a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(147.919 153.034)",
    fill: "#e5e7f2"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28618",
    "data-name": "Path 28618",
    d: "M119.441,118.824h-1.293a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V120.762a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(152.164 153.034)",
    fill: "#f8f9fd"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28619",
    "data-name": "Path 28619",
    d: "M128.655,159.906h0a5.386,5.386,0,0,1-5.386-5.386V124.212a5.387,5.387,0,1,1,10.774,0l0,30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(158.759 153.034)",
    fill: "#e5e7f2"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28620",
    "data-name": "Path 28620",
    d: "M127.859,118.824h-1.293a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V120.762a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(163.005 153.034)",
    fill: "#f8f9fd"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28621",
    "data-name": "Path 28621",
    d: "M103.4,159.906h0a5.386,5.386,0,0,1-5.386-5.386V124.212a5.386,5.386,0,1,1,10.771,0V154.52a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(126.236 153.034)",
    fill: "#e5e7f2"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28622",
    "data-name": "Path 28622",
    d: "M102.6,118.824h-1.293a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938H102.6a1.939,1.939,0,0,0,1.938-1.938V120.762a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(130.481 153.034)",
    fill: "#f8f9fd"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28623",
    "data-name": "Path 28623",
    d: "M163.608,143.608H100.773a2.759,2.759,0,0,1,0-5.518h62.835a2.759,2.759,0,0,1,0,5.518",
    transform: "translate(126.236 177.847)",
    fill: "#e5e7f2"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28624",
    "data-name": "Path 28624",
    d: "M127.772,138.09h-1.293a1.937,1.937,0,0,1,1.938,1.938v1.643a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938v-1.643a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(162.893 177.847)",
    fill: "#f8f9fd"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28625",
    "data-name": "Path 28625",
    d: "M111.82,159.906h0a5.386,5.386,0,0,1-5.386-5.386V124.212a5.386,5.386,0,1,1,10.771,0V154.52a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(137.077 153.034)",
    fill: "#e5e7f2"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28626",
    "data-name": "Path 28626",
    d: "M111.023,118.824H109.73a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V120.762a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(141.322 153.034)",
    fill: "#f8f9fd"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28627",
    "data-name": "Path 28627",
    d: "M111.82,159.906h0a5.386,5.386,0,0,1-5.386-5.386V124.212a5.386,5.386,0,1,1,10.771,0V154.52a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(137.077 153.034)",
    fill: "#e5e7f2"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28628",
    "data-name": "Path 28628",
    d: "M111.023,118.824H109.73a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V120.762a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(141.322 153.034)",
    fill: "#f8f9fd"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28629",
    "data-name": "Path 28629",
    d: "M120.238,159.906h0a5.386,5.386,0,0,1-5.386-5.386V124.212a5.386,5.386,0,1,1,10.771,0V154.52a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(147.919 153.034)",
    fill: "#e5e7f2"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28630",
    "data-name": "Path 28630",
    d: "M119.441,118.824h-1.293a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V120.762a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(152.164 153.034)",
    fill: "#f8f9fd"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28631",
    "data-name": "Path 28631",
    d: "M128.655,159.906h0a5.386,5.386,0,0,1-5.386-5.386V124.212a5.387,5.387,0,1,1,10.774,0l0,30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(158.759 153.034)",
    fill: "#e5e7f2"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28632",
    "data-name": "Path 28632",
    d: "M127.859,118.824h-1.293a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V120.762a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(163.005 153.034)",
    fill: "#f8f9fd"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28633",
    "data-name": "Path 28633",
    d: "M103.4,183.516h0a5.386,5.386,0,0,1-5.386-5.386V147.823a5.386,5.386,0,0,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(126.236 183.446)",
    fill: "#e5e7f2"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28634",
    "data-name": "Path 28634",
    d: "M102.6,142.436h-1.293a1.937,1.937,0,0,1,1.938,1.938V181.58a1.937,1.937,0,0,1-1.938,1.936H102.6a1.937,1.937,0,0,0,1.938-1.936V144.374a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(130.481 183.445)",
    fill: "#f8f9fd"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28635",
    "data-name": "Path 28635",
    d: "M163.609,167.22H100.772a2.759,2.759,0,0,1,0-5.518h62.837a2.759,2.759,0,0,1,0,5.518",
    transform: "translate(126.234 208.257)",
    fill: "#e5e7f2"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28636",
    "data-name": "Path 28636",
    d: "M127.772,161.7h-1.293a1.937,1.937,0,0,1,1.938,1.938v1.643a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938v-1.643a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(162.893 208.259)",
    fill: "#f8f9fd"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28637",
    "data-name": "Path 28637",
    d: "M111.82,183.516h0a5.386,5.386,0,0,1-5.386-5.386V147.823a5.386,5.386,0,0,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(137.077 183.446)",
    fill: "#e5e7f2"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28638",
    "data-name": "Path 28638",
    d: "M111.023,142.436H109.73a1.937,1.937,0,0,1,1.938,1.938V181.58a1.937,1.937,0,0,1-1.938,1.936h1.293a1.937,1.937,0,0,0,1.938-1.936V144.374a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(141.322 183.445)",
    fill: "#f8f9fd"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28639",
    "data-name": "Path 28639",
    d: "M111.82,183.516h0a5.386,5.386,0,0,1-5.386-5.386V147.823a5.386,5.386,0,0,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(137.077 183.446)",
    fill: "#e5e7f2"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28640",
    "data-name": "Path 28640",
    d: "M111.023,142.436H109.73a1.937,1.937,0,0,1,1.938,1.938V181.58a1.937,1.937,0,0,1-1.938,1.936h1.293a1.937,1.937,0,0,0,1.938-1.936V144.374a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(141.322 183.445)",
    fill: "#f8f9fd"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28641",
    "data-name": "Path 28641",
    d: "M120.238,183.516h0a5.386,5.386,0,0,1-5.386-5.386V147.823a5.386,5.386,0,0,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(147.919 183.446)",
    fill: "#e5e7f2"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28642",
    "data-name": "Path 28642",
    d: "M119.441,142.436h-1.293a1.937,1.937,0,0,1,1.938,1.938V181.58a1.937,1.937,0,0,1-1.938,1.936h1.293a1.937,1.937,0,0,0,1.938-1.936V144.374a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(152.164 183.445)",
    fill: "#f8f9fd"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28643",
    "data-name": "Path 28643",
    d: "M128.656,183.516h0a5.386,5.386,0,0,1-5.386-5.386V147.823a5.386,5.386,0,0,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(158.76 183.446)",
    fill: "#e5e7f2"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28644",
    "data-name": "Path 28644",
    d: "M127.859,142.436h-1.293a1.937,1.937,0,0,1,1.938,1.938V181.58a1.937,1.937,0,0,1-1.938,1.936h1.293a1.937,1.937,0,0,0,1.938-1.936V144.374a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(163.005 183.445)",
    fill: "#f8f9fd"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28645",
    "data-name": "Path 28645",
    d: "M103.4,207.13h0a5.386,5.386,0,0,1-5.388-5.386V171.436a5.387,5.387,0,1,1,10.774,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(126.234 213.855)",
    fill: "#e5e7f2"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28646",
    "data-name": "Path 28646",
    d: "M102.6,166.048h-1.293a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938H102.6a1.939,1.939,0,0,0,1.938-1.938V167.986a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(130.481 213.855)",
    fill: "#f8f9fd"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28647",
    "data-name": "Path 28647",
    d: "M163.608,190.832H100.775a2.759,2.759,0,1,1,0-5.518l62.833,0a2.758,2.758,0,1,1,0,5.516",
    transform: "translate(126.236 238.667)",
    fill: "#e5e7f2"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28648",
    "data-name": "Path 28648",
    d: "M127.772,185.315h-1.293a1.937,1.937,0,0,1,1.938,1.938V188.9a1.937,1.937,0,0,1-1.938,1.936h1.293a1.937,1.937,0,0,0,1.938-1.936v-1.643a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(162.893 238.669)",
    fill: "#f8f9fd"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28649",
    "data-name": "Path 28649",
    d: "M111.82,207.13h0a5.386,5.386,0,0,1-5.386-5.386V171.436a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(137.077 213.855)",
    fill: "#e5e7f2"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28650",
    "data-name": "Path 28650",
    d: "M111.023,166.048H109.73a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V167.986a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(141.322 213.855)",
    fill: "#f8f9fd"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28651",
    "data-name": "Path 28651",
    d: "M111.82,207.13h0a5.386,5.386,0,0,1-5.386-5.386V171.436a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(137.077 213.855)",
    fill: "#e5e7f2"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28652",
    "data-name": "Path 28652",
    d: "M111.023,166.048H109.73a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V167.986a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(141.322 213.855)",
    fill: "#f8f9fd"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28653",
    "data-name": "Path 28653",
    d: "M120.238,207.13h0a5.386,5.386,0,0,1-5.386-5.386V171.436a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(147.919 213.855)",
    fill: "#e5e7f2"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28654",
    "data-name": "Path 28654",
    d: "M119.441,166.048h-1.293a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V167.986a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(152.164 213.855)",
    fill: "#f8f9fd"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28655",
    "data-name": "Path 28655",
    d: "M128.656,207.13h0a5.386,5.386,0,0,1-5.386-5.386V171.436a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(158.76 213.855)",
    fill: "#e5e7f2"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28656",
    "data-name": "Path 28656",
    d: "M127.859,166.048h-1.293a1.937,1.937,0,0,1,1.938,1.938v37.206a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V167.986a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(163.005 213.855)",
    fill: "#f8f9fd"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28657",
    "data-name": "Path 28657",
    d: "M103.4,230.74h0a5.386,5.386,0,0,1-5.386-5.386V195.047a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(126.236 244.266)",
    fill: "#e5e7f2"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28658",
    "data-name": "Path 28658",
    d: "M102.6,189.661h-1.293a1.937,1.937,0,0,1,1.938,1.938V228.8a1.937,1.937,0,0,1-1.938,1.936H102.6a1.937,1.937,0,0,0,1.938-1.936V191.6a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(130.481 244.266)",
    fill: "#f8f9fd"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28659",
    "data-name": "Path 28659",
    d: "M163.608,214.443H100.775a2.758,2.758,0,1,1,0-5.516h62.833a2.758,2.758,0,1,1,0,5.516",
    transform: "translate(126.236 269.079)",
    fill: "#e5e7f2"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28660",
    "data-name": "Path 28660",
    d: "M127.772,208.927h-1.293a1.937,1.937,0,0,1,1.938,1.938v1.643a1.935,1.935,0,0,1-1.938,1.936h1.293a1.935,1.935,0,0,0,1.938-1.936v-1.643a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(162.893 269.079)",
    fill: "#f8f9fd"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28661",
    "data-name": "Path 28661",
    d: "M111.82,230.742h0a5.386,5.386,0,0,1-5.386-5.386V195.048a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(137.077 244.265)",
    fill: "#e5e7f2"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28662",
    "data-name": "Path 28662",
    d: "M111.023,189.661H109.73a1.937,1.937,0,0,1,1.938,1.938V228.8a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V191.6a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(141.322 244.266)",
    fill: "#f8f9fd"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28663",
    "data-name": "Path 28663",
    d: "M111.82,230.742h0a5.386,5.386,0,0,1-5.386-5.386V195.048a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(137.077 244.265)",
    fill: "#e5e7f2"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28664",
    "data-name": "Path 28664",
    d: "M111.023,189.661H109.73a1.937,1.937,0,0,1,1.938,1.938V228.8a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V191.6a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(141.322 244.266)",
    fill: "#f8f9fd"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28665",
    "data-name": "Path 28665",
    d: "M120.238,230.742h0a5.386,5.386,0,0,1-5.386-5.386V195.048a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(147.919 244.265)",
    fill: "#e5e7f2"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28666",
    "data-name": "Path 28666",
    d: "M119.441,189.661h-1.293a1.937,1.937,0,0,1,1.938,1.938V228.8a1.939,1.939,0,0,1-1.938,1.938h1.293a1.939,1.939,0,0,0,1.938-1.938V191.6a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(152.164 244.266)",
    fill: "#f8f9fd"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28667",
    "data-name": "Path 28667",
    d: "M128.655,230.742h0a5.386,5.386,0,0,1-5.386-5.386V195.048a5.386,5.386,0,1,1,10.771,0v30.308a5.386,5.386,0,0,1-5.386,5.386",
    transform: "translate(158.759 244.265)",
    fill: "#e5e7f2"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28668",
    "data-name": "Path 28668",
    d: "M127.859,189.661h-1.293A1.937,1.937,0,0,1,128.5,191.6V228.8a1.939,1.939,0,0,1-1.938,1.938h1.293A1.939,1.939,0,0,0,129.8,228.8V191.6a1.937,1.937,0,0,0-1.938-1.938",
    transform: "translate(163.005 244.266)",
    fill: "#f8f9fd"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28669",
    "data-name": "Path 28669",
    d: "M91.657,136.294h0a5.386,5.386,0,0,0,5.386-5.386V100.6a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(111.109 122.624)",
    fill: "#fff"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28670",
    "data-name": "Path 28670",
    d: "M88.209,95.212H89.5a1.937,1.937,0,0,0-1.938,1.938v37.206a1.939,1.939,0,0,0,1.938,1.938H88.209a1.939,1.939,0,0,1-1.938-1.938V97.15a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(111.109 122.624)",
    fill: "#a5d9fa"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28671",
    "data-name": "Path 28671",
    d: "M80.517,120h24.73a2.759,2.759,0,0,0,0-5.518H80.517a2.759,2.759,0,1,0,0,5.518",
    transform: "translate(100.145 147.437)",
    fill: "#fff"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28672",
    "data-name": "Path 28672",
    d: "M79.7,114.478h1.293a1.937,1.937,0,0,0-1.938,1.938v1.643A1.939,1.939,0,0,0,80.989,120H79.7a1.939,1.939,0,0,1-1.938-1.938v-1.643a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(100.145 147.437)",
    fill: "#a5d9fa"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28673",
    "data-name": "Path 28673",
    d: "M83.239,136.294h0a5.386,5.386,0,0,0,5.386-5.386V100.6a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(100.268 122.624)",
    fill: "#e5e7f2"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28674",
    "data-name": "Path 28674",
    d: "M79.791,95.212h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.939,1.939,0,0,0,1.938,1.938H79.791a1.939,1.939,0,0,1-1.938-1.938V97.15a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(100.268 122.624)",
    fill: "#f8f9fd"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28675",
    "data-name": "Path 28675",
    d: "M83.239,136.294h0a5.386,5.386,0,0,0,5.386-5.386V100.6a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(100.268 122.624)",
    fill: "#fff"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28676",
    "data-name": "Path 28676",
    d: "M79.791,95.212h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.939,1.939,0,0,0,1.938,1.938H79.791a1.939,1.939,0,0,1-1.938-1.938V97.15a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(100.268 122.624)",
    fill: "#a5d9fa"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28677",
    "data-name": "Path 28677",
    d: "M91.657,159.98h0a5.386,5.386,0,0,0,5.386-5.386V124.286a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(111.109 153.13)",
    fill: "#fff"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28678",
    "data-name": "Path 28678",
    d: "M88.209,118.9H89.5a1.937,1.937,0,0,0-1.938,1.938v37.206A1.939,1.939,0,0,0,89.5,159.98H88.209a1.939,1.939,0,0,1-1.938-1.938V120.836a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(111.109 153.13)",
    fill: "#a5d9fa"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28679",
    "data-name": "Path 28679",
    d: "M80.517,143.681h24.73a2.758,2.758,0,1,0,0-5.516H80.517a2.758,2.758,0,1,0,0,5.516",
    transform: "translate(100.145 177.944)",
    fill: "#fff"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28680",
    "data-name": "Path 28680",
    d: "M79.7,138.164h1.293a1.937,1.937,0,0,0-1.938,1.938v1.643a1.937,1.937,0,0,0,1.938,1.936H79.7a1.937,1.937,0,0,1-1.938-1.936V140.1a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(100.145 177.943)",
    fill: "#a5d9fa"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28681",
    "data-name": "Path 28681",
    d: "M83.239,159.98h0a5.386,5.386,0,0,0,5.386-5.386V124.286a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(100.268 153.13)",
    fill: "#e5e7f2"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28682",
    "data-name": "Path 28682",
    d: "M79.791,118.9h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.939,1.939,0,0,0,1.938,1.938H79.791a1.939,1.939,0,0,1-1.938-1.938V120.836a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(100.268 153.13)",
    fill: "#f8f9fd"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28683",
    "data-name": "Path 28683",
    d: "M83.239,159.98h0a5.386,5.386,0,0,0,5.386-5.386V124.286a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(100.268 153.13)",
    fill: "#fff"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28684",
    "data-name": "Path 28684",
    d: "M79.791,118.9h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.939,1.939,0,0,0,1.938,1.938H79.791a1.939,1.939,0,0,1-1.938-1.938V120.836a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(100.268 153.13)",
    fill: "#a5d9fa"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28685",
    "data-name": "Path 28685",
    d: "M91.657,159.98h0a5.386,5.386,0,0,0,5.386-5.386V124.286a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(111.109 153.13)",
    fill: "#fff"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28686",
    "data-name": "Path 28686",
    d: "M88.209,118.9H89.5a1.937,1.937,0,0,0-1.938,1.938v37.206A1.939,1.939,0,0,0,89.5,159.98H88.209a1.939,1.939,0,0,1-1.938-1.938V120.836a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(111.109 153.13)",
    fill: "#a5d9fa"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28687",
    "data-name": "Path 28687",
    d: "M80.517,143.681h24.73a2.758,2.758,0,1,0,0-5.516H80.517a2.758,2.758,0,1,0,0,5.516",
    transform: "translate(100.145 177.944)",
    fill: "#fff"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28688",
    "data-name": "Path 28688",
    d: "M79.7,138.164h1.293a1.937,1.937,0,0,0-1.938,1.938v1.643a1.937,1.937,0,0,0,1.938,1.936H79.7a1.937,1.937,0,0,1-1.938-1.936V140.1a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(100.145 177.943)",
    fill: "#a5d9fa"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28689",
    "data-name": "Path 28689",
    d: "M83.239,159.98h0a5.386,5.386,0,0,0,5.386-5.386V124.286a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(100.268 153.13)",
    fill: "#e5e7f2"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28690",
    "data-name": "Path 28690",
    d: "M79.791,118.9h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.939,1.939,0,0,0,1.938,1.938H79.791a1.939,1.939,0,0,1-1.938-1.938V120.836a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(100.268 153.13)",
    fill: "#f8f9fd"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28691",
    "data-name": "Path 28691",
    d: "M83.239,159.98h0a5.386,5.386,0,0,0,5.386-5.386V124.286a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(100.268 153.13)",
    fill: "#fff"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28692",
    "data-name": "Path 28692",
    d: "M79.791,118.9h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.939,1.939,0,0,0,1.938,1.938H79.791a1.939,1.939,0,0,1-1.938-1.938V120.836a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(100.268 153.13)",
    fill: "#a5d9fa"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28693",
    "data-name": "Path 28693",
    d: "M91.657,183.664h0a5.386,5.386,0,0,0,5.386-5.386V147.971a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(111.109 183.636)",
    fill: "#fff"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28694",
    "data-name": "Path 28694",
    d: "M88.209,142.584H89.5a1.937,1.937,0,0,0-1.938,1.938v37.206a1.937,1.937,0,0,0,1.938,1.936H88.209a1.937,1.937,0,0,1-1.938-1.936V144.522a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(111.109 183.635)",
    fill: "#a5d9fa"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28695",
    "data-name": "Path 28695",
    d: "M80.517,167.367h24.73a2.758,2.758,0,1,0,0-5.516H80.517a2.758,2.758,0,1,0,0,5.516",
    transform: "translate(100.145 208.449)",
    fill: "#fff"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28696",
    "data-name": "Path 28696",
    d: "M79.7,161.85h1.293a1.937,1.937,0,0,0-1.938,1.938v1.643a1.935,1.935,0,0,0,1.938,1.936H79.7a1.937,1.937,0,0,1-1.938-1.936v-1.643A1.937,1.937,0,0,1,79.7,161.85",
    transform: "translate(100.145 208.448)",
    fill: "#a5d9fa"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28697",
    "data-name": "Path 28697",
    d: "M83.239,183.664h0a5.386,5.386,0,0,0,5.386-5.386V147.971a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(100.268 183.636)",
    fill: "#e5e7f2"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28698",
    "data-name": "Path 28698",
    d: "M79.791,142.584h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.937,1.937,0,0,0,1.938,1.936H79.791a1.937,1.937,0,0,1-1.938-1.936V144.522a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(100.268 183.635)",
    fill: "#f8f9fd"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28699",
    "data-name": "Path 28699",
    d: "M83.239,183.664h0a5.386,5.386,0,0,0,5.386-5.386V147.971a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(100.268 183.636)",
    fill: "#fff"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28700",
    "data-name": "Path 28700",
    d: "M79.791,142.584h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.937,1.937,0,0,0,1.938,1.936H79.791a1.937,1.937,0,0,1-1.938-1.936V144.522a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(100.268 183.635)",
    fill: "#a5d9fa"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28701",
    "data-name": "Path 28701",
    d: "M91.657,207.352h0a5.386,5.386,0,0,0,5.386-5.386V171.658a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(111.109 214.141)",
    fill: "#fff"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28702",
    "data-name": "Path 28702",
    d: "M88.209,166.27H89.5a1.937,1.937,0,0,0-1.938,1.938v37.206a1.937,1.937,0,0,0,1.938,1.938H88.209a1.937,1.937,0,0,1-1.938-1.938V168.208a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(111.109 214.141)",
    fill: "#a5d9fa"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28703",
    "data-name": "Path 28703",
    d: "M80.517,191.053h24.73a2.758,2.758,0,1,0,0-5.516H80.517a2.758,2.758,0,1,0,0,5.516",
    transform: "translate(100.145 238.955)",
    fill: "#fff"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28704",
    "data-name": "Path 28704",
    d: "M79.7,185.536h1.293a1.937,1.937,0,0,0-1.938,1.938v1.643a1.935,1.935,0,0,0,1.938,1.936H79.7a1.935,1.935,0,0,1-1.938-1.936v-1.643a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(100.145 238.953)",
    fill: "#a5d9fa"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28705",
    "data-name": "Path 28705",
    d: "M83.239,207.352h0a5.386,5.386,0,0,0,5.386-5.386V171.658a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(100.268 214.141)",
    fill: "#e5e7f2"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28706",
    "data-name": "Path 28706",
    d: "M79.791,166.27h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.939,1.939,0,0,0,1.938,1.938H79.791a1.939,1.939,0,0,1-1.938-1.938V168.208a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(100.268 214.141)",
    fill: "#f8f9fd"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28707",
    "data-name": "Path 28707",
    d: "M83.239,207.352h0a5.386,5.386,0,0,0,5.386-5.386V171.658a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(100.268 214.141)",
    fill: "#fff"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28708",
    "data-name": "Path 28708",
    d: "M79.791,166.27h1.293a1.937,1.937,0,0,0-1.938,1.938v37.206a1.939,1.939,0,0,0,1.938,1.938H79.791a1.939,1.939,0,0,1-1.938-1.938V168.208a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(100.268 214.141)",
    fill: "#a5d9fa"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28709",
    "data-name": "Path 28709",
    d: "M91.657,231.036h0a5.386,5.386,0,0,0,5.386-5.386V195.343a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(111.109 244.647)",
    fill: "#fff"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28710",
    "data-name": "Path 28710",
    d: "M88.209,189.956H89.5a1.937,1.937,0,0,0-1.938,1.938V229.1a1.937,1.937,0,0,0,1.938,1.936H88.209a1.937,1.937,0,0,1-1.938-1.936V191.894a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(111.109 244.646)",
    fill: "#a5d9fa"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28711",
    "data-name": "Path 28711",
    d: "M80.519,214.74h24.728a2.758,2.758,0,1,0,0-5.516l-24.728,0a2.759,2.759,0,1,0,0,5.518",
    transform: "translate(100.145 269.459)",
    fill: "#fff"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28712",
    "data-name": "Path 28712",
    d: "M79.7,209.222h1.293a1.937,1.937,0,0,0-1.938,1.938V212.8a1.937,1.937,0,0,0,1.938,1.938H79.7a1.937,1.937,0,0,1-1.938-1.938V211.16a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(100.145 269.459)",
    fill: "#a5d9fa"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28713",
    "data-name": "Path 28713",
    d: "M83.239,231.036h0a5.386,5.386,0,0,0,5.386-5.386V195.343a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(100.268 244.647)",
    fill: "#e5e7f2"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28714",
    "data-name": "Path 28714",
    d: "M79.791,189.956h1.293a1.937,1.937,0,0,0-1.938,1.938V229.1a1.939,1.939,0,0,0,1.938,1.938H79.791a1.939,1.939,0,0,1-1.938-1.938V191.894a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(100.268 244.646)",
    fill: "#f8f9fd"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28715",
    "data-name": "Path 28715",
    d: "M83.239,231.036h0a5.386,5.386,0,0,0,5.386-5.386V195.343a5.386,5.386,0,1,0-10.771,0v30.308a5.386,5.386,0,0,0,5.386,5.386",
    transform: "translate(100.268 244.647)",
    fill: "#fff"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28716",
    "data-name": "Path 28716",
    d: "M79.791,189.956h1.293a1.937,1.937,0,0,0-1.938,1.938V229.1a1.939,1.939,0,0,0,1.938,1.938H79.791a1.939,1.939,0,0,1-1.938-1.938V191.894a1.937,1.937,0,0,1,1.938-1.938",
    transform: "translate(100.268 244.646)",
    fill: "#a5d9fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10324",
    "data-name": "Group 10324",
    transform: "translate(239.805 212.881)",
    opacity: 0.64,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10323",
    "data-name": "Group 10323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10322",
    "data-name": "Group 10322",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28717",
    "data-name": "Path 28717",
    d: "M104.814,391.259h59.2V94.636a1.6,1.6,0,0,0-1.608-1.59H104.814Z",
    transform: "translate(-104.814 -93.046)",
    fill: "#a5d9fa"
  }))))), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28718",
    "data-name": "Path 28718",
    d: "M212.7,72.592H115.222V29.664a6.735,6.735,0,0,1,6.736-6.736h84.01a6.735,6.735,0,0,1,6.736,6.736Z",
    transform: "translate(148.395 29.529)",
    fill: "#eff1fd"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28719",
    "data-name": "Path 28719",
    d: "M212.911,72.592H141.348V29.664a6.735,6.735,0,0,1,6.736-6.736h58.092a6.735,6.735,0,0,1,6.736,6.733Z",
    transform: "translate(182.043 29.529)",
    fill: "#a5d9fa"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28720",
    "data-name": "Path 28720",
    d: "M233.822,469.153V36.562a1.956,1.956,0,0,0-1.97-1.945H111.286a1.957,1.957,0,0,0-1.97,1.945V469.153Z",
    transform: "translate(140.789 44.584)",
    fill: "#eff1fd"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28721",
    "data-name": "Path 28721",
    d: "M234.03,469.153V36.562a1.956,1.956,0,0,0-1.97-1.945H137.412a1.956,1.956,0,0,0-1.97,1.945V469.153Z",
    transform: "translate(174.437 44.584)",
    fill: "#a5d9fa"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28722",
    "data-name": "Path 28722",
    d: "M145.126,53.872h0a6.6,6.6,0,0,1-6.594-6.6V43.863a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(178.417 47.999)",
    fill: "#e5e7f2"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28723",
    "data-name": "Path 28723",
    d: "M144.151,37.269h-1.583a2.372,2.372,0,0,1,2.373,2.373V51.5a2.372,2.372,0,0,1-2.373,2.373h1.583a2.373,2.373,0,0,0,2.373-2.373V39.642a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(183.615 47.999)",
    fill: "#f8f9fd"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28724",
    "data-name": "Path 28724",
    d: "M155.434,53.872h0a6.6,6.6,0,0,1-6.6-6.6V43.863a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.594,6.6",
    transform: "translate(191.69 47.999)",
    fill: "#e5e7f2"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28725",
    "data-name": "Path 28725",
    d: "M154.458,37.269h-1.583a2.372,2.372,0,0,1,2.373,2.373V51.5a2.372,2.372,0,0,1-2.373,2.373h1.583a2.372,2.372,0,0,0,2.373-2.373V39.642a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 47.999)",
    fill: "#f8f9fd"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28726",
    "data-name": "Path 28726",
    d: "M155.434,53.872h0a6.6,6.6,0,0,1-6.6-6.6V43.863a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.594,6.6",
    transform: "translate(191.69 47.999)",
    fill: "#e5e7f2"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28727",
    "data-name": "Path 28727",
    d: "M154.458,37.269h-1.583a2.372,2.372,0,0,1,2.373,2.373V51.5a2.372,2.372,0,0,1-2.373,2.373h1.583a2.372,2.372,0,0,0,2.373-2.373V39.642a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 47.999)",
    fill: "#f8f9fd"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28728",
    "data-name": "Path 28728",
    d: "M165.74,53.872h0a6.6,6.6,0,0,1-6.6-6.6V43.863a6.6,6.6,0,0,1,13.192,0v3.414a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(204.963 47.999)",
    fill: "#e5e7f2"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28729",
    "data-name": "Path 28729",
    d: "M164.764,37.269h-1.583a2.372,2.372,0,0,1,2.373,2.373V51.5a2.372,2.372,0,0,1-2.373,2.373h1.583a2.372,2.372,0,0,0,2.373-2.373V39.642a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(210.162 47.999)",
    fill: "#f8f9fd"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28730",
    "data-name": "Path 28730",
    d: "M176.047,53.872h0a6.6,6.6,0,0,1-6.6-6.6V43.863a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.594,6.6",
    transform: "translate(218.237 47.999)",
    fill: "#e5e7f2"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28731",
    "data-name": "Path 28731",
    d: "M175.071,37.269h-1.583a2.372,2.372,0,0,1,2.373,2.373V51.5a2.372,2.372,0,0,1-2.373,2.373h1.583a2.373,2.373,0,0,0,2.373-2.373V39.642a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(223.437 47.999)",
    fill: "#f8f9fd"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28732",
    "data-name": "Path 28732",
    d: "M145.126,68.4h0a6.6,6.6,0,0,1-6.594-6.6V58.388a6.595,6.595,0,0,1,13.19,0V61.8a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(178.417 66.706)",
    fill: "#e5e7f2"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28733",
    "data-name": "Path 28733",
    d: "M144.151,51.794h-1.583a2.372,2.372,0,0,1,2.373,2.373V66.027a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37V54.167a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(183.615 66.706)",
    fill: "#f8f9fd"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28734",
    "data-name": "Path 28734",
    d: "M155.434,68.4h0a6.6,6.6,0,0,1-6.6-6.6V58.388a6.595,6.595,0,0,1,13.19,0V61.8a6.6,6.6,0,0,1-6.594,6.6",
    transform: "translate(191.69 66.706)",
    fill: "#e5e7f2"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28735",
    "data-name": "Path 28735",
    d: "M154.458,51.794h-1.583a2.372,2.372,0,0,1,2.373,2.373V66.027a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V54.167a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 66.706)",
    fill: "#f8f9fd"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28736",
    "data-name": "Path 28736",
    d: "M155.434,68.4h0a6.6,6.6,0,0,1-6.6-6.6V58.388a6.595,6.595,0,0,1,13.19,0V61.8a6.6,6.6,0,0,1-6.594,6.6",
    transform: "translate(191.69 66.706)",
    fill: "#e5e7f2"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28737",
    "data-name": "Path 28737",
    d: "M154.458,51.794h-1.583a2.372,2.372,0,0,1,2.373,2.373V66.027a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V54.167a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 66.706)",
    fill: "#f8f9fd"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28738",
    "data-name": "Path 28738",
    d: "M165.74,68.4h0a6.6,6.6,0,0,1-6.6-6.6V58.388a6.6,6.6,0,0,1,13.192,0V61.8a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(204.963 66.706)",
    fill: "#e5e7f2"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28739",
    "data-name": "Path 28739",
    d: "M164.764,51.794h-1.583a2.372,2.372,0,0,1,2.373,2.373V66.027a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V54.167a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(210.162 66.706)",
    fill: "#f8f9fd"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28740",
    "data-name": "Path 28740",
    d: "M176.046,68.4h0a6.6,6.6,0,0,1-6.594-6.6V58.388a6.595,6.595,0,0,1,13.19,0V61.8a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(218.239 66.706)",
    fill: "#e5e7f2"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28741",
    "data-name": "Path 28741",
    d: "M175.071,51.794h-1.583a2.372,2.372,0,0,1,2.373,2.373V66.027a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37V54.167a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(223.437 66.706)",
    fill: "#f8f9fd"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28742",
    "data-name": "Path 28742",
    d: "M145.126,68.4h0a6.6,6.6,0,0,1-6.594-6.6V58.388a6.595,6.595,0,0,1,13.19,0V61.8a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(178.417 66.706)",
    fill: "#e5e7f2"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28743",
    "data-name": "Path 28743",
    d: "M144.151,51.794h-1.583a2.372,2.372,0,0,1,2.373,2.373V66.027a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37V54.167a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(183.615 66.706)",
    fill: "#f8f9fd"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28744",
    "data-name": "Path 28744",
    d: "M155.434,68.4h0a6.6,6.6,0,0,1-6.6-6.6V58.388a6.595,6.595,0,0,1,13.19,0V61.8a6.6,6.6,0,0,1-6.594,6.6",
    transform: "translate(191.69 66.706)",
    fill: "#e5e7f2"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28745",
    "data-name": "Path 28745",
    d: "M154.458,51.794h-1.583a2.372,2.372,0,0,1,2.373,2.373V66.027a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V54.167a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 66.706)",
    fill: "#f8f9fd"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28746",
    "data-name": "Path 28746",
    d: "M155.434,68.4h0a6.6,6.6,0,0,1-6.6-6.6V58.388a6.595,6.595,0,0,1,13.19,0V61.8a6.6,6.6,0,0,1-6.594,6.6",
    transform: "translate(191.69 66.706)",
    fill: "#e5e7f2"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28747",
    "data-name": "Path 28747",
    d: "M154.458,51.794h-1.583a2.372,2.372,0,0,1,2.373,2.373V66.027a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V54.167a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 66.706)",
    fill: "#f8f9fd"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28748",
    "data-name": "Path 28748",
    d: "M165.74,68.4h0a6.6,6.6,0,0,1-6.6-6.6V58.388a6.6,6.6,0,0,1,13.192,0V61.8a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(204.963 66.706)",
    fill: "#e5e7f2"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28749",
    "data-name": "Path 28749",
    d: "M164.764,51.794h-1.583a2.372,2.372,0,0,1,2.373,2.373V66.027a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V54.167a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(210.162 66.706)",
    fill: "#f8f9fd"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28750",
    "data-name": "Path 28750",
    d: "M176.046,68.4h0a6.6,6.6,0,0,1-6.594-6.6V58.388a6.595,6.595,0,0,1,13.19,0V61.8a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(218.239 66.706)",
    fill: "#e5e7f2"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28751",
    "data-name": "Path 28751",
    d: "M175.071,51.794h-1.583a2.372,2.372,0,0,1,2.373,2.373V66.027a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37V54.167a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(223.437 66.706)",
    fill: "#f8f9fd"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28752",
    "data-name": "Path 28752",
    d: "M145.126,82.923h0a6.594,6.594,0,0,1-6.594-6.594V72.914a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(178.417 85.414)",
    fill: "#e5e7f2"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28753",
    "data-name": "Path 28753",
    d: "M144.151,66.319h-1.583a2.372,2.372,0,0,1,2.373,2.373V80.552a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37V68.692a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(183.615 85.413)",
    fill: "#f8f9fd"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28754",
    "data-name": "Path 28754",
    d: "M155.434,82.923h0a6.6,6.6,0,0,1-6.6-6.6V72.914a6.595,6.595,0,0,1,13.19,0V76.33a6.594,6.594,0,0,1-6.594,6.594",
    transform: "translate(191.69 85.414)",
    fill: "#e5e7f2"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28755",
    "data-name": "Path 28755",
    d: "M154.458,66.319h-1.583a2.372,2.372,0,0,1,2.373,2.373V80.552a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V68.692a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 85.413)",
    fill: "#f8f9fd"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28756",
    "data-name": "Path 28756",
    d: "M155.434,82.923h0a6.6,6.6,0,0,1-6.6-6.6V72.914a6.595,6.595,0,0,1,13.19,0V76.33a6.594,6.594,0,0,1-6.594,6.594",
    transform: "translate(191.69 85.414)",
    fill: "#e5e7f2"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28757",
    "data-name": "Path 28757",
    d: "M154.458,66.319h-1.583a2.372,2.372,0,0,1,2.373,2.373V80.552a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V68.692a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 85.413)",
    fill: "#f8f9fd"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28758",
    "data-name": "Path 28758",
    d: "M165.74,82.923h0a6.6,6.6,0,0,1-6.6-6.6V72.914a6.6,6.6,0,0,1,13.192,0V76.33a6.6,6.6,0,0,1-6.6,6.594",
    transform: "translate(204.963 85.414)",
    fill: "#e5e7f2"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28759",
    "data-name": "Path 28759",
    d: "M164.764,66.319h-1.583a2.372,2.372,0,0,1,2.373,2.373V80.552a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V68.692a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(210.162 85.413)",
    fill: "#f8f9fd"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28760",
    "data-name": "Path 28760",
    d: "M176.047,82.923h0a6.6,6.6,0,0,1-6.6-6.6V72.914a6.595,6.595,0,0,1,13.19,0V76.33a6.594,6.594,0,0,1-6.594,6.594",
    transform: "translate(218.237 85.414)",
    fill: "#e5e7f2"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28761",
    "data-name": "Path 28761",
    d: "M175.071,66.319h-1.583a2.372,2.372,0,0,1,2.373,2.373V80.552a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37V68.692a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(223.437 85.413)",
    fill: "#f8f9fd"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28762",
    "data-name": "Path 28762",
    d: "M145.126,97.448h0a6.6,6.6,0,0,1-6.594-6.6V87.439a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(178.417 104.121)",
    fill: "#e5e7f2"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28763",
    "data-name": "Path 28763",
    d: "M144.151,80.845h-1.583a2.372,2.372,0,0,1,2.373,2.373V95.076a2.372,2.372,0,0,1-2.373,2.373h1.583a2.373,2.373,0,0,0,2.373-2.373V83.218a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(183.615 104.121)",
    fill: "#f8f9fd"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28764",
    "data-name": "Path 28764",
    d: "M155.434,97.448h0a6.6,6.6,0,0,1-6.6-6.6V87.439a6.6,6.6,0,0,1,13.192,0v3.414a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(191.69 104.121)",
    fill: "#e5e7f2"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28765",
    "data-name": "Path 28765",
    d: "M154.458,80.845h-1.583a2.372,2.372,0,0,1,2.373,2.373V95.076a2.372,2.372,0,0,1-2.373,2.373h1.583a2.372,2.372,0,0,0,2.373-2.373V83.218a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 104.121)",
    fill: "#f8f9fd"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28766",
    "data-name": "Path 28766",
    d: "M155.434,97.448h0a6.6,6.6,0,0,1-6.6-6.6V87.439a6.6,6.6,0,0,1,13.192,0v3.414a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(191.69 104.121)",
    fill: "#e5e7f2"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28767",
    "data-name": "Path 28767",
    d: "M154.458,80.845h-1.583a2.372,2.372,0,0,1,2.373,2.373V95.076a2.372,2.372,0,0,1-2.373,2.373h1.583a2.372,2.372,0,0,0,2.373-2.373V83.218a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 104.121)",
    fill: "#f8f9fd"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28768",
    "data-name": "Path 28768",
    d: "M165.74,97.448h0a6.6,6.6,0,0,1-6.6-6.6V87.439a6.6,6.6,0,0,1,13.192,0v3.414a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(204.963 104.121)",
    fill: "#e5e7f2"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28769",
    "data-name": "Path 28769",
    d: "M164.764,80.845h-1.583a2.372,2.372,0,0,1,2.373,2.373V95.076a2.372,2.372,0,0,1-2.373,2.373h1.583a2.372,2.372,0,0,0,2.373-2.373V83.218a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(210.162 104.121)",
    fill: "#f8f9fd"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28770",
    "data-name": "Path 28770",
    d: "M176.046,97.448h0a6.6,6.6,0,0,1-6.594-6.6V87.439a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(218.239 104.121)",
    fill: "#e5e7f2"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28771",
    "data-name": "Path 28771",
    d: "M175.071,80.845h-1.583a2.372,2.372,0,0,1,2.373,2.373V95.076a2.372,2.372,0,0,1-2.373,2.373h1.583a2.373,2.373,0,0,0,2.373-2.373V83.218a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(223.437 104.121)",
    fill: "#f8f9fd"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28772",
    "data-name": "Path 28772",
    d: "M145.127,111.973h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.594,6.6",
    transform: "translate(178.415 122.828)",
    fill: "#e5e7f2"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28773",
    "data-name": "Path 28773",
    d: "M144.151,95.37h-1.583a2.372,2.372,0,0,1,2.373,2.373V109.6a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37V97.743a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(183.615 122.828)",
    fill: "#f8f9fd"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28774",
    "data-name": "Path 28774",
    d: "M155.434,111.973h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.594,6.6",
    transform: "translate(191.69 122.828)",
    fill: "#e5e7f2"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28775",
    "data-name": "Path 28775",
    d: "M154.458,95.37h-1.583a2.372,2.372,0,0,1,2.373,2.373V109.6a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V97.743a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 122.828)",
    fill: "#f8f9fd"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28776",
    "data-name": "Path 28776",
    d: "M155.434,111.973h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.594,6.6",
    transform: "translate(191.69 122.828)",
    fill: "#e5e7f2"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28777",
    "data-name": "Path 28777",
    d: "M154.458,95.37h-1.583a2.372,2.372,0,0,1,2.373,2.373V109.6a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V97.743a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 122.828)",
    fill: "#f8f9fd"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28778",
    "data-name": "Path 28778",
    d: "M165.74,111.973h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.6,6.6,0,0,1,13.192,0v3.414a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(204.963 122.828)",
    fill: "#e5e7f2"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28779",
    "data-name": "Path 28779",
    d: "M164.764,95.37h-1.583a2.372,2.372,0,0,1,2.373,2.373V109.6a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V97.743a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(210.162 122.828)",
    fill: "#f8f9fd"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28780",
    "data-name": "Path 28780",
    d: "M176.047,111.973h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.594,6.6",
    transform: "translate(218.237 122.828)",
    fill: "#e5e7f2"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28781",
    "data-name": "Path 28781",
    d: "M175.071,95.37h-1.583a2.372,2.372,0,0,1,2.373,2.373V109.6a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37V97.743a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(223.437 122.828)",
    fill: "#f8f9fd"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28782",
    "data-name": "Path 28782",
    d: "M145.126,126.5h0a6.593,6.593,0,0,1-6.594-6.594v-3.416a6.595,6.595,0,0,1,13.19,0V119.9a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(178.417 141.535)",
    fill: "#e5e7f2"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28783",
    "data-name": "Path 28783",
    d: "M144.151,109.895h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37V112.268a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(183.615 141.535)",
    fill: "#f8f9fd"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28784",
    "data-name": "Path 28784",
    d: "M155.434,126.5h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.595,6.595,0,0,1,13.19,0V119.9a6.593,6.593,0,0,1-6.594,6.594",
    transform: "translate(191.69 141.535)",
    fill: "#e5e7f2"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28785",
    "data-name": "Path 28785",
    d: "M154.458,109.895h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V112.268a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 141.535)",
    fill: "#f8f9fd"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28786",
    "data-name": "Path 28786",
    d: "M155.434,126.5h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.595,6.595,0,0,1,13.19,0V119.9a6.593,6.593,0,0,1-6.594,6.594",
    transform: "translate(191.69 141.535)",
    fill: "#e5e7f2"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28787",
    "data-name": "Path 28787",
    d: "M154.458,109.895h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V112.268a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 141.535)",
    fill: "#f8f9fd"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28788",
    "data-name": "Path 28788",
    d: "M165.74,126.5h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.6,6.6,0,0,1,13.192,0V119.9a6.6,6.6,0,0,1-6.6,6.594",
    transform: "translate(204.963 141.535)",
    fill: "#e5e7f2"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28789",
    "data-name": "Path 28789",
    d: "M164.764,109.895h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V112.268a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(210.162 141.535)",
    fill: "#f8f9fd"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28790",
    "data-name": "Path 28790",
    d: "M176.047,126.5h0a6.6,6.6,0,0,1-6.6-6.594v-3.416a6.595,6.595,0,0,1,13.19,0V119.9a6.593,6.593,0,0,1-6.594,6.594",
    transform: "translate(218.237 141.535)",
    fill: "#e5e7f2"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28791",
    "data-name": "Path 28791",
    d: "M175.071,109.895h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37V112.268a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(223.437 141.535)",
    fill: "#f8f9fd"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28792",
    "data-name": "Path 28792",
    d: "M145.127,141.024h0a6.6,6.6,0,0,1-6.6-6.594v-3.416a6.595,6.595,0,0,1,13.19,0v3.416a6.593,6.593,0,0,1-6.594,6.594",
    transform: "translate(178.415 160.243)",
    fill: "#e5e7f2"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28793",
    "data-name": "Path 28793",
    d: "M144.151,124.42h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37V126.793a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(183.615 160.242)",
    fill: "#f8f9fd"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28794",
    "data-name": "Path 28794",
    d: "M155.434,141.024h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.595,6.595,0,0,1,13.19,0v3.416a6.593,6.593,0,0,1-6.594,6.594",
    transform: "translate(191.69 160.243)",
    fill: "#e5e7f2"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28795",
    "data-name": "Path 28795",
    d: "M154.458,124.42h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V126.793a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 160.242)",
    fill: "#f8f9fd"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28796",
    "data-name": "Path 28796",
    d: "M155.434,141.024h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.595,6.595,0,0,1,13.19,0v3.416a6.593,6.593,0,0,1-6.594,6.594",
    transform: "translate(191.69 160.243)",
    fill: "#e5e7f2"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28797",
    "data-name": "Path 28797",
    d: "M154.458,124.42h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V126.793a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 160.242)",
    fill: "#f8f9fd"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28798",
    "data-name": "Path 28798",
    d: "M165.74,141.024h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.6,6.6,0,0,1,13.192,0v3.416a6.6,6.6,0,0,1-6.6,6.594",
    transform: "translate(204.963 160.243)",
    fill: "#e5e7f2"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28799",
    "data-name": "Path 28799",
    d: "M164.764,124.42h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V126.793a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(210.162 160.242)",
    fill: "#f8f9fd"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28800",
    "data-name": "Path 28800",
    d: "M176.047,141.024h0a6.6,6.6,0,0,1-6.6-6.594v-3.416a6.595,6.595,0,0,1,13.19,0v3.416a6.593,6.593,0,0,1-6.594,6.594",
    transform: "translate(218.237 160.243)",
    fill: "#e5e7f2"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28801",
    "data-name": "Path 28801",
    d: "M175.071,124.42h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37V126.793a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(223.437 160.242)",
    fill: "#f8f9fd"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28802",
    "data-name": "Path 28802",
    d: "M145.126,155.549h0a6.593,6.593,0,0,1-6.594-6.6V145.54a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(178.417 178.95)",
    fill: "#e5e7f2"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28803",
    "data-name": "Path 28803",
    d: "M144.151,138.946h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37V141.319a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(183.615 178.95)",
    fill: "#f8f9fd"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28804",
    "data-name": "Path 28804",
    d: "M155.434,155.549h0a6.6,6.6,0,0,1-6.6-6.6V145.54a6.595,6.595,0,0,1,13.19,0v3.414a6.593,6.593,0,0,1-6.594,6.6",
    transform: "translate(191.69 178.95)",
    fill: "#e5e7f2"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28805",
    "data-name": "Path 28805",
    d: "M154.458,138.946h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V141.319a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 178.95)",
    fill: "#f8f9fd"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28806",
    "data-name": "Path 28806",
    d: "M155.434,155.549h0a6.6,6.6,0,0,1-6.6-6.6V145.54a6.595,6.595,0,0,1,13.19,0v3.414a6.593,6.593,0,0,1-6.594,6.6",
    transform: "translate(191.69 178.95)",
    fill: "#e5e7f2"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28807",
    "data-name": "Path 28807",
    d: "M154.458,138.946h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V141.319a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 178.95)",
    fill: "#f8f9fd"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28808",
    "data-name": "Path 28808",
    d: "M165.74,155.549h0a6.6,6.6,0,0,1-6.6-6.6V145.54a6.6,6.6,0,0,1,13.192,0v3.414a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(204.963 178.95)",
    fill: "#e5e7f2"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28809",
    "data-name": "Path 28809",
    d: "M164.764,138.946h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V141.319a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(210.162 178.95)",
    fill: "#f8f9fd"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28810",
    "data-name": "Path 28810",
    d: "M176.047,155.549h0a6.6,6.6,0,0,1-6.6-6.6V145.54a6.595,6.595,0,0,1,13.19,0v3.414a6.593,6.593,0,0,1-6.594,6.6",
    transform: "translate(218.237 178.95)",
    fill: "#e5e7f2"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28811",
    "data-name": "Path 28811",
    d: "M175.071,138.946h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37V141.319a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(223.437 178.95)",
    fill: "#f8f9fd"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28812",
    "data-name": "Path 28812",
    d: "M145.127,170.074h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.594,6.6",
    transform: "translate(178.415 197.657)",
    fill: "#e5e7f2"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28813",
    "data-name": "Path 28813",
    d: "M144.151,153.471h-1.583a2.372,2.372,0,0,1,2.373,2.373V167.7a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37V155.844a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(183.615 197.657)",
    fill: "#f8f9fd"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28814",
    "data-name": "Path 28814",
    d: "M155.434,170.074h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.594,6.6",
    transform: "translate(191.69 197.657)",
    fill: "#e5e7f2"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28815",
    "data-name": "Path 28815",
    d: "M154.458,153.471h-1.583a2.372,2.372,0,0,1,2.373,2.373V167.7a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V155.844a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 197.657)",
    fill: "#f8f9fd"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28816",
    "data-name": "Path 28816",
    d: "M155.434,170.074h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.594,6.6",
    transform: "translate(191.69 197.657)",
    fill: "#e5e7f2"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28817",
    "data-name": "Path 28817",
    d: "M154.458,153.471h-1.583a2.372,2.372,0,0,1,2.373,2.373V167.7a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V155.844a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 197.657)",
    fill: "#f8f9fd"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28818",
    "data-name": "Path 28818",
    d: "M165.74,170.074h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.6,6.6,0,0,1,13.192,0v3.414a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(204.963 197.657)",
    fill: "#e5e7f2"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28819",
    "data-name": "Path 28819",
    d: "M164.764,153.471h-1.583a2.372,2.372,0,0,1,2.373,2.373V167.7a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V155.844a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(210.162 197.657)",
    fill: "#f8f9fd"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28820",
    "data-name": "Path 28820",
    d: "M176.047,170.074h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.594,6.6",
    transform: "translate(218.237 197.657)",
    fill: "#e5e7f2"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28821",
    "data-name": "Path 28821",
    d: "M175.071,153.471h-1.583a2.372,2.372,0,0,1,2.373,2.373V167.7a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37V155.844a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(223.437 197.657)",
    fill: "#f8f9fd"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28822",
    "data-name": "Path 28822",
    d: "M145.127,214.941h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.594,6.6",
    transform: "translate(178.415 255.441)",
    fill: "#e5e7f2"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28823",
    "data-name": "Path 28823",
    d: "M144.151,198.338h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37V200.711a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(183.615 255.441)",
    fill: "#f8f9fd"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28824",
    "data-name": "Path 28824",
    d: "M155.434,214.941h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.594,6.6",
    transform: "translate(191.69 255.441)",
    fill: "#e5e7f2"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28825",
    "data-name": "Path 28825",
    d: "M154.458,198.338h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V200.711a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 255.441)",
    fill: "#f8f9fd"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28826",
    "data-name": "Path 28826",
    d: "M155.434,214.941h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.594,6.6",
    transform: "translate(191.69 255.441)",
    fill: "#e5e7f2"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28827",
    "data-name": "Path 28827",
    d: "M154.458,198.338h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V200.711a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 255.441)",
    fill: "#f8f9fd"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28828",
    "data-name": "Path 28828",
    d: "M165.74,214.941h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.6,6.6,0,0,1,13.192,0v3.414a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(204.963 255.441)",
    fill: "#e5e7f2"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28829",
    "data-name": "Path 28829",
    d: "M164.764,198.338h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V200.711a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(210.162 255.441)",
    fill: "#f8f9fd"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28830",
    "data-name": "Path 28830",
    d: "M176.047,214.941h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.594,6.6",
    transform: "translate(218.237 255.441)",
    fill: "#e5e7f2"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28831",
    "data-name": "Path 28831",
    d: "M175.071,198.338h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37V200.711a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(223.437 255.441)",
    fill: "#f8f9fd"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28832",
    "data-name": "Path 28832",
    d: "M130.654,53.872h0a6.6,6.6,0,0,0,6.6-6.6V43.863a6.6,6.6,0,0,0-13.192,0v3.414a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(159.775 47.999)",
    fill: "#fff"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28833",
    "data-name": "Path 28833",
    d: "M126.431,37.269h1.583a2.372,2.372,0,0,0-2.373,2.373V51.5a2.372,2.372,0,0,0,2.373,2.373h-1.583a2.372,2.372,0,0,1-2.373-2.373V39.642a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(159.775 47.999)",
    fill: "#a5d9fa"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28834",
    "data-name": "Path 28834",
    d: "M120.346,53.872h0a6.6,6.6,0,0,0,6.6-6.6V43.863a6.595,6.595,0,0,0-13.19,0v3.414a6.6,6.6,0,0,0,6.594,6.6",
    transform: "translate(146.502 47.999)",
    fill: "#e5e7f2"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28835",
    "data-name": "Path 28835",
    d: "M116.125,37.269h1.583a2.372,2.372,0,0,0-2.373,2.373V51.5a2.372,2.372,0,0,0,2.373,2.373h-1.583a2.372,2.372,0,0,1-2.373-2.373V39.642a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 47.999)",
    fill: "#f8f9fd"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28836",
    "data-name": "Path 28836",
    d: "M120.346,53.872h0a6.6,6.6,0,0,0,6.6-6.6V43.863a6.595,6.595,0,0,0-13.19,0v3.414a6.6,6.6,0,0,0,6.594,6.6",
    transform: "translate(146.502 47.999)",
    fill: "#fff"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28837",
    "data-name": "Path 28837",
    d: "M116.125,37.269h1.583a2.372,2.372,0,0,0-2.373,2.373V51.5a2.372,2.372,0,0,0,2.373,2.373h-1.583a2.372,2.372,0,0,1-2.373-2.373V39.642a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 47.999)",
    fill: "#a5d9fa"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28838",
    "data-name": "Path 28838",
    d: "M130.654,68.523h0a6.6,6.6,0,0,0,6.6-6.6V58.514a6.6,6.6,0,0,0-13.192,0V61.93a6.6,6.6,0,0,0,6.6,6.594",
    transform: "translate(159.775 66.868)",
    fill: "#fff"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28839",
    "data-name": "Path 28839",
    d: "M126.431,51.92h1.583a2.372,2.372,0,0,0-2.373,2.373V66.153a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V54.293a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(159.775 66.868)",
    fill: "#a5d9fa"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28840",
    "data-name": "Path 28840",
    d: "M120.348,68.523h0a6.6,6.6,0,0,0,6.6-6.594V58.514a6.6,6.6,0,0,0-13.192,0v3.414a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(146.502 66.868)",
    fill: "#e5e7f2"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28841",
    "data-name": "Path 28841",
    d: "M116.125,51.92h1.583a2.372,2.372,0,0,0-2.373,2.373V66.153a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V54.293a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 66.868)",
    fill: "#f8f9fd"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28842",
    "data-name": "Path 28842",
    d: "M120.348,68.523h0a6.6,6.6,0,0,0,6.6-6.594V58.514a6.6,6.6,0,0,0-13.192,0v3.414a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(146.502 66.868)",
    fill: "#fff"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28843",
    "data-name": "Path 28843",
    d: "M116.125,51.92h1.583a2.372,2.372,0,0,0-2.373,2.373V66.153a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V54.293a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 66.868)",
    fill: "#a5d9fa"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28844",
    "data-name": "Path 28844",
    d: "M130.654,68.523h0a6.6,6.6,0,0,0,6.6-6.6V58.514a6.6,6.6,0,0,0-13.192,0V61.93a6.6,6.6,0,0,0,6.6,6.594",
    transform: "translate(159.775 66.868)",
    fill: "#fff"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28845",
    "data-name": "Path 28845",
    d: "M126.431,51.92h1.583a2.372,2.372,0,0,0-2.373,2.373V66.153a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V54.293a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(159.775 66.868)",
    fill: "#a5d9fa"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28846",
    "data-name": "Path 28846",
    d: "M120.348,68.523h0a6.6,6.6,0,0,0,6.6-6.594V58.514a6.6,6.6,0,0,0-13.192,0v3.414a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(146.502 66.868)",
    fill: "#e5e7f2"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28847",
    "data-name": "Path 28847",
    d: "M116.125,51.92h1.583a2.372,2.372,0,0,0-2.373,2.373V66.153a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V54.293a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 66.868)",
    fill: "#f8f9fd"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28848",
    "data-name": "Path 28848",
    d: "M120.348,68.523h0a6.6,6.6,0,0,0,6.6-6.594V58.514a6.6,6.6,0,0,0-13.192,0v3.414a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(146.502 66.868)",
    fill: "#fff"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28849",
    "data-name": "Path 28849",
    d: "M116.125,51.92h1.583a2.372,2.372,0,0,0-2.373,2.373V66.153a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V54.293a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 66.868)",
    fill: "#a5d9fa"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28850",
    "data-name": "Path 28850",
    d: "M130.654,83.175h0a6.6,6.6,0,0,0,6.6-6.6V73.166a6.6,6.6,0,0,0-13.192,0v3.414a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(159.775 85.739)",
    fill: "#fff"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28851",
    "data-name": "Path 28851",
    d: "M126.431,66.571h1.583a2.372,2.372,0,0,0-2.373,2.373V80.8a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V68.944a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(159.775 85.737)",
    fill: "#a5d9fa"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28852",
    "data-name": "Path 28852",
    d: "M120.348,83.175h0a6.6,6.6,0,0,0,6.6-6.6V73.166a6.6,6.6,0,0,0-13.192,0v3.414a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(146.502 85.739)",
    fill: "#e5e7f2"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28853",
    "data-name": "Path 28853",
    d: "M116.125,66.571h1.583a2.372,2.372,0,0,0-2.373,2.373V80.8a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V68.944a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 85.737)",
    fill: "#f8f9fd"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28854",
    "data-name": "Path 28854",
    d: "M120.348,83.175h0a6.6,6.6,0,0,0,6.6-6.6V73.166a6.6,6.6,0,0,0-13.192,0v3.414a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(146.502 85.739)",
    fill: "#fff"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28855",
    "data-name": "Path 28855",
    d: "M116.125,66.571h1.583a2.372,2.372,0,0,0-2.373,2.373V80.8a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V68.944a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 85.737)",
    fill: "#a5d9fa"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28856",
    "data-name": "Path 28856",
    d: "M130.654,97.826h0a6.6,6.6,0,0,0,6.6-6.6V87.817a6.6,6.6,0,0,0-13.192,0v3.416a6.6,6.6,0,0,0,6.6,6.594",
    transform: "translate(159.775 104.608)",
    fill: "#fff"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28857",
    "data-name": "Path 28857",
    d: "M126.431,81.223h1.583a2.372,2.372,0,0,0-2.373,2.373V95.456a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V83.6a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(159.775 104.608)",
    fill: "#a5d9fa"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28858",
    "data-name": "Path 28858",
    d: "M120.348,97.826h0a6.6,6.6,0,0,0,6.6-6.594V87.817a6.6,6.6,0,0,0-13.192,0V91.23a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(146.502 104.608)",
    fill: "#e5e7f2"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28859",
    "data-name": "Path 28859",
    d: "M116.125,81.223h1.583a2.372,2.372,0,0,0-2.373,2.373V95.456a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V83.6a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 104.608)",
    fill: "#f8f9fd"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28860",
    "data-name": "Path 28860",
    d: "M120.348,97.826h0a6.6,6.6,0,0,0,6.6-6.594V87.817a6.6,6.6,0,0,0-13.192,0V91.23a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(146.502 104.608)",
    fill: "#fff"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28861",
    "data-name": "Path 28861",
    d: "M116.125,81.223h1.583a2.372,2.372,0,0,0-2.373,2.373V95.456a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V83.6a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 104.608)",
    fill: "#a5d9fa"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28862",
    "data-name": "Path 28862",
    d: "M130.654,112.477h0a6.6,6.6,0,0,0,6.6-6.6v-3.414a6.6,6.6,0,0,0-13.192,0v3.414a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(159.775 123.477)",
    fill: "#fff"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28863",
    "data-name": "Path 28863",
    d: "M126.431,95.874h1.583a2.372,2.372,0,0,0-2.373,2.373v11.861a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V98.247a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(159.775 123.477)",
    fill: "#a5d9fa"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28864",
    "data-name": "Path 28864",
    d: "M120.348,112.477h0a6.6,6.6,0,0,0,6.6-6.6v-3.414a6.6,6.6,0,0,0-13.192,0v3.414a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(146.502 123.477)",
    fill: "#e5e7f2"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28865",
    "data-name": "Path 28865",
    d: "M116.125,95.874h1.583a2.372,2.372,0,0,0-2.373,2.373v11.861a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V98.247a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 123.477)",
    fill: "#f8f9fd"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28866",
    "data-name": "Path 28866",
    d: "M120.348,112.477h0a6.6,6.6,0,0,0,6.6-6.6v-3.414a6.6,6.6,0,0,0-13.192,0v3.414a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(146.502 123.477)",
    fill: "#fff"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28867",
    "data-name": "Path 28867",
    d: "M116.125,95.874h1.583a2.372,2.372,0,0,0-2.373,2.373v11.861a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V98.247a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 123.477)",
    fill: "#a5d9fa"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28868",
    "data-name": "Path 28868",
    d: "M130.654,127.129h0a6.6,6.6,0,0,0,6.6-6.6V117.12a6.6,6.6,0,0,0-13.192,0v3.414a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(159.775 142.347)",
    fill: "#fff"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28869",
    "data-name": "Path 28869",
    d: "M126.431,110.525h1.583a2.372,2.372,0,0,0-2.373,2.373v11.858a2.372,2.372,0,0,0,2.373,2.373h-1.583a2.372,2.372,0,0,1-2.373-2.373V112.9a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(159.775 142.346)",
    fill: "#a5d9fa"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28870",
    "data-name": "Path 28870",
    d: "M120.348,127.129h0a6.6,6.6,0,0,0,6.6-6.6V117.12a6.6,6.6,0,0,0-13.192,0v3.414a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(146.502 142.347)",
    fill: "#e5e7f2"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28871",
    "data-name": "Path 28871",
    d: "M116.125,110.525h1.583a2.372,2.372,0,0,0-2.373,2.373v11.858a2.372,2.372,0,0,0,2.373,2.373h-1.583a2.372,2.372,0,0,1-2.373-2.373V112.9a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 142.346)",
    fill: "#f8f9fd"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28872",
    "data-name": "Path 28872",
    d: "M120.348,127.129h0a6.6,6.6,0,0,0,6.6-6.6V117.12a6.6,6.6,0,0,0-13.192,0v3.414a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(146.502 142.347)",
    fill: "#fff"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28873",
    "data-name": "Path 28873",
    d: "M116.125,110.525h1.583a2.372,2.372,0,0,0-2.373,2.373v11.858a2.372,2.372,0,0,0,2.373,2.373h-1.583a2.372,2.372,0,0,1-2.373-2.373V112.9a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 142.346)",
    fill: "#a5d9fa"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28874",
    "data-name": "Path 28874",
    d: "M130.654,141.78h0a6.6,6.6,0,0,0,6.6-6.6v-3.414a6.6,6.6,0,0,0-13.192,0v3.416a6.6,6.6,0,0,0,6.6,6.594",
    transform: "translate(159.775 161.217)",
    fill: "#fff"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28875",
    "data-name": "Path 28875",
    d: "M126.431,125.177h1.583a2.372,2.372,0,0,0-2.373,2.373V139.41a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V127.55a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(159.775 161.217)",
    fill: "#a5d9fa"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28876",
    "data-name": "Path 28876",
    d: "M120.346,141.78h0a6.6,6.6,0,0,0,6.6-6.594v-3.416a6.595,6.595,0,0,0-13.19,0v3.416a6.594,6.594,0,0,0,6.594,6.594",
    transform: "translate(146.502 161.217)",
    fill: "#e5e7f2"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28877",
    "data-name": "Path 28877",
    d: "M116.125,125.177h1.583a2.372,2.372,0,0,0-2.373,2.373V139.41a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V127.55a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 161.217)",
    fill: "#f8f9fd"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28878",
    "data-name": "Path 28878",
    d: "M120.346,141.78h0a6.6,6.6,0,0,0,6.6-6.594v-3.416a6.595,6.595,0,0,0-13.19,0v3.416a6.594,6.594,0,0,0,6.594,6.594",
    transform: "translate(146.502 161.217)",
    fill: "#fff"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28879",
    "data-name": "Path 28879",
    d: "M116.125,125.177h1.583a2.372,2.372,0,0,0-2.373,2.373V139.41a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V127.55a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 161.217)",
    fill: "#a5d9fa"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28880",
    "data-name": "Path 28880",
    d: "M130.654,156.431h0a6.6,6.6,0,0,0,6.6-6.6v-3.414a6.6,6.6,0,0,0-13.192,0v3.414a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(159.775 180.086)",
    fill: "#fff"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28881",
    "data-name": "Path 28881",
    d: "M126.431,139.828h1.583a2.372,2.372,0,0,0-2.373,2.373v11.86a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V142.2a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(159.775 180.086)",
    fill: "#a5d9fa"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28882",
    "data-name": "Path 28882",
    d: "M120.346,156.431h0a6.6,6.6,0,0,0,6.6-6.6v-3.414a6.595,6.595,0,0,0-13.19,0v3.414a6.593,6.593,0,0,0,6.594,6.6",
    transform: "translate(146.502 180.086)",
    fill: "#e5e7f2"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28883",
    "data-name": "Path 28883",
    d: "M116.125,139.828h1.583a2.372,2.372,0,0,0-2.373,2.373v11.86a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V142.2a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 180.086)",
    fill: "#f8f9fd"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28884",
    "data-name": "Path 28884",
    d: "M120.346,156.431h0a6.6,6.6,0,0,0,6.6-6.6v-3.414a6.595,6.595,0,0,0-13.19,0v3.414a6.593,6.593,0,0,0,6.594,6.6",
    transform: "translate(146.502 180.086)",
    fill: "#fff"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28885",
    "data-name": "Path 28885",
    d: "M116.125,139.828h1.583a2.372,2.372,0,0,0-2.373,2.373v11.86a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V142.2a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 180.086)",
    fill: "#a5d9fa"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28886",
    "data-name": "Path 28886",
    d: "M130.654,171.082h0a6.6,6.6,0,0,0,6.6-6.6v-3.414a6.6,6.6,0,0,0-13.192,0v3.414a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(159.775 198.955)",
    fill: "#fff"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28887",
    "data-name": "Path 28887",
    d: "M126.431,154.479h1.583a2.372,2.372,0,0,0-2.373,2.373v11.86a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37v-11.86a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(159.775 198.955)",
    fill: "#a5d9fa"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28888",
    "data-name": "Path 28888",
    d: "M120.346,171.082h0a6.6,6.6,0,0,0,6.6-6.6v-3.414a6.595,6.595,0,0,0-13.19,0v3.414a6.6,6.6,0,0,0,6.594,6.6",
    transform: "translate(146.502 198.955)",
    fill: "#e5e7f2"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28889",
    "data-name": "Path 28889",
    d: "M116.125,154.479h1.583a2.372,2.372,0,0,0-2.373,2.373v11.86a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37v-11.86a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 198.955)",
    fill: "#f8f9fd"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28890",
    "data-name": "Path 28890",
    d: "M120.346,171.082h0a6.6,6.6,0,0,0,6.6-6.6v-3.414a6.595,6.595,0,0,0-13.19,0v3.414a6.6,6.6,0,0,0,6.594,6.6",
    transform: "translate(146.502 198.955)",
    fill: "#fff"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28891",
    "data-name": "Path 28891",
    d: "M116.125,154.479h1.583a2.372,2.372,0,0,0-2.373,2.373v11.86a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37v-11.86a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 198.955)",
    fill: "#a5d9fa"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28892",
    "data-name": "Path 28892",
    d: "M130.654,215.1h0a6.6,6.6,0,0,0,6.6-6.6v-3.414a6.6,6.6,0,0,0-13.192,0V208.5a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(159.775 255.642)",
    fill: "#fff"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28893",
    "data-name": "Path 28893",
    d: "M126.431,198.494h1.583a2.372,2.372,0,0,0-2.373,2.373v11.86a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37v-11.86a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(159.775 255.642)",
    fill: "#a5d9fa"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28894",
    "data-name": "Path 28894",
    d: "M120.346,215.1h0a6.6,6.6,0,0,0,6.6-6.6v-3.414a6.595,6.595,0,0,0-13.19,0V208.5a6.6,6.6,0,0,0,6.594,6.6",
    transform: "translate(146.502 255.642)",
    fill: "#e5e7f2"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28895",
    "data-name": "Path 28895",
    d: "M116.125,198.494h1.583a2.372,2.372,0,0,0-2.373,2.373v11.86a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37v-11.86a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 255.642)",
    fill: "#f8f9fd"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28896",
    "data-name": "Path 28896",
    d: "M120.346,215.1h0a6.6,6.6,0,0,0,6.6-6.6v-3.414a6.595,6.595,0,0,0-13.19,0V208.5a6.6,6.6,0,0,0,6.594,6.6",
    transform: "translate(146.502 255.642)",
    fill: "#fff"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28897",
    "data-name": "Path 28897",
    d: "M116.125,198.494h1.583a2.372,2.372,0,0,0-2.373,2.373v11.86a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37v-11.86a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 255.642)",
    fill: "#a5d9fa"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28898",
    "data-name": "Path 28898",
    d: "M145.126,201.551h0a6.6,6.6,0,0,1-6.594-6.6v-3.414a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(178.417 238.196)",
    fill: "#e5e7f2"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28899",
    "data-name": "Path 28899",
    d: "M144.151,184.948h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37V187.321a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(183.615 238.196)",
    fill: "#f8f9fd"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28900",
    "data-name": "Path 28900",
    d: "M155.434,201.551h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.594,6.6",
    transform: "translate(191.69 238.196)",
    fill: "#e5e7f2"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28901",
    "data-name": "Path 28901",
    d: "M154.458,184.948h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V187.321a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 238.196)",
    fill: "#f8f9fd"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28902",
    "data-name": "Path 28902",
    d: "M155.434,201.551h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.594,6.6",
    transform: "translate(191.69 238.196)",
    fill: "#e5e7f2"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28903",
    "data-name": "Path 28903",
    d: "M154.458,184.948h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V187.321a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 238.196)",
    fill: "#f8f9fd"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28904",
    "data-name": "Path 28904",
    d: "M165.74,201.551h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.6,6.6,0,0,1,13.192,0v3.414a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(204.963 238.196)",
    fill: "#e5e7f2"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28905",
    "data-name": "Path 28905",
    d: "M164.764,184.948h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37V187.321a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(210.162 238.196)",
    fill: "#f8f9fd"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28906",
    "data-name": "Path 28906",
    d: "M176.046,201.551h0a6.6,6.6,0,0,1-6.594-6.6v-3.414a6.595,6.595,0,0,1,13.19,0v3.414a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(218.239 238.196)",
    fill: "#e5e7f2"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28907",
    "data-name": "Path 28907",
    d: "M175.071,184.948h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.861a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37V187.321a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(223.437 238.196)",
    fill: "#f8f9fd"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28908",
    "data-name": "Path 28908",
    d: "M130.654,201.707h0a6.6,6.6,0,0,0,6.6-6.6V191.7a6.6,6.6,0,0,0-13.192,0v3.414a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(159.775 238.397)",
    fill: "#fff"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28909",
    "data-name": "Path 28909",
    d: "M126.431,185.1h1.583a2.372,2.372,0,0,0-2.373,2.373v11.861a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V187.476a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(159.775 238.396)",
    fill: "#a5d9fa"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28910",
    "data-name": "Path 28910",
    d: "M120.348,201.707h0a6.6,6.6,0,0,0,6.6-6.6V191.7a6.6,6.6,0,0,0-13.192,0v3.414a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(146.502 238.397)",
    fill: "#e5e7f2"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28911",
    "data-name": "Path 28911",
    d: "M116.125,185.1h1.583a2.372,2.372,0,0,0-2.373,2.373v11.861a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V187.476a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 238.396)",
    fill: "#f8f9fd"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28912",
    "data-name": "Path 28912",
    d: "M120.348,201.707h0a6.6,6.6,0,0,0,6.6-6.6V191.7a6.6,6.6,0,0,0-13.192,0v3.414a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(146.502 238.397)",
    fill: "#fff"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28913",
    "data-name": "Path 28913",
    d: "M116.125,185.1h1.583a2.372,2.372,0,0,0-2.373,2.373v11.861a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V187.476a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 238.396)",
    fill: "#a5d9fa"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28914",
    "data-name": "Path 28914",
    d: "M145.127,186.5h0a6.6,6.6,0,0,1-6.6-6.594v-3.416a6.595,6.595,0,0,1,13.19,0V179.9a6.594,6.594,0,0,1-6.594,6.594",
    transform: "translate(178.415 218.809)",
    fill: "#e5e7f2"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28915",
    "data-name": "Path 28915",
    d: "M144.151,169.895h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.86a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37v-11.86a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(183.615 218.809)",
    fill: "#f8f9fd"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28916",
    "data-name": "Path 28916",
    d: "M155.434,186.5h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.595,6.595,0,0,1,13.19,0V179.9a6.593,6.593,0,0,1-6.594,6.594",
    transform: "translate(191.69 218.809)",
    fill: "#e5e7f2"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28917",
    "data-name": "Path 28917",
    d: "M154.458,169.895h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.86a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37v-11.86a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 218.809)",
    fill: "#f8f9fd"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28918",
    "data-name": "Path 28918",
    d: "M155.434,186.5h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.595,6.595,0,0,1,13.19,0V179.9a6.593,6.593,0,0,1-6.594,6.594",
    transform: "translate(191.69 218.809)",
    fill: "#e5e7f2"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28919",
    "data-name": "Path 28919",
    d: "M154.458,169.895h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.86a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37v-11.86a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(196.889 218.809)",
    fill: "#f8f9fd"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28920",
    "data-name": "Path 28920",
    d: "M165.74,186.5h0a6.6,6.6,0,0,1-6.6-6.6v-3.414a6.595,6.595,0,0,1,13.19,0V179.9a6.593,6.593,0,0,1-6.594,6.594",
    transform: "translate(204.963 218.809)",
    fill: "#e5e7f2"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28921",
    "data-name": "Path 28921",
    d: "M164.764,169.895h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.86a2.371,2.371,0,0,1-2.373,2.37h1.583a2.371,2.371,0,0,0,2.373-2.37v-11.86a2.372,2.372,0,0,0-2.373-2.373",
    transform: "translate(210.162 218.809)",
    fill: "#f8f9fd"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28922",
    "data-name": "Path 28922",
    d: "M176.046,186.5h0a6.6,6.6,0,0,1-6.594-6.6v-3.414a6.595,6.595,0,0,1,13.19,0V179.9a6.6,6.6,0,0,1-6.6,6.6",
    transform: "translate(218.239 218.809)",
    fill: "#e5e7f2"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28923",
    "data-name": "Path 28923",
    d: "M175.071,169.895h-1.583a2.372,2.372,0,0,1,2.373,2.373v11.86a2.371,2.371,0,0,1-2.373,2.37h1.583a2.373,2.373,0,0,0,2.373-2.37v-11.86a2.373,2.373,0,0,0-2.373-2.373",
    transform: "translate(223.437 218.809)",
    fill: "#f8f9fd"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28924",
    "data-name": "Path 28924",
    d: "M130.654,186.654h0a6.6,6.6,0,0,0,6.6-6.6v-3.414a6.6,6.6,0,0,0-13.192,0v3.416a6.6,6.6,0,0,0,6.6,6.594",
    transform: "translate(159.775 219.01)",
    fill: "#fff"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28925",
    "data-name": "Path 28925",
    d: "M126.431,170.051h1.583a2.372,2.372,0,0,0-2.373,2.373v11.861a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V172.424a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(159.775 219.01)",
    fill: "#a5d9fa"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28926",
    "data-name": "Path 28926",
    d: "M120.348,186.654h0a6.6,6.6,0,0,0,6.6-6.6v-3.414a6.6,6.6,0,0,0-13.192,0v3.414a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(146.502 219.01)",
    fill: "#e5e7f2"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28927",
    "data-name": "Path 28927",
    d: "M116.125,170.051h1.583a2.372,2.372,0,0,0-2.373,2.373v11.861a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V172.424a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 219.01)",
    fill: "#f8f9fd"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28928",
    "data-name": "Path 28928",
    d: "M120.348,186.654h0a6.6,6.6,0,0,0,6.6-6.6v-3.414a6.6,6.6,0,0,0-13.192,0v3.414a6.6,6.6,0,0,0,6.6,6.6",
    transform: "translate(146.502 219.01)",
    fill: "#fff"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28929",
    "data-name": "Path 28929",
    d: "M116.125,170.051h1.583a2.372,2.372,0,0,0-2.373,2.373v11.861a2.371,2.371,0,0,0,2.373,2.37h-1.583a2.371,2.371,0,0,1-2.373-2.37V172.424a2.372,2.372,0,0,1,2.373-2.373",
    transform: "translate(146.502 219.01)",
    fill: "#a5d9fa"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28930",
    "data-name": "Path 28930",
    d: "M138.383,90.48c-3.736,1.428-7.5,2.864-11.341,3.986-2.5.732-5.74,1.81-8.17.318a4.614,4.614,0,0,1-.558-.41q-1.562.429-3.134.819-7.766,2.725-15.535,5.454c-8.326,21.82-15.562,49.476-20.275,79.8-11.318,72.806-3.8,133.378,16.78,135.289s46.449-55.56,57.765-128.368c6.37-40.958,6.775-78.045,2.249-102.995-5.905,2.089-11.934,3.876-17.779,6.111",
    transform: "translate(95.432 108.66)",
    fill: "#ea9e7c"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28931",
    "data-name": "Path 28931",
    d: "M138.383,90.48c-3.736,1.428-7.5,2.864-11.341,3.986-2.5.732-5.74,1.81-8.17.318a4.614,4.614,0,0,1-.558-.41q-1.562.429-3.134.819-7.766,2.725-15.535,5.454c-8.326,21.82-15.562,49.476-20.275,79.8-11.318,72.806-3.8,133.378,16.78,135.289s46.449-55.56,57.765-128.368c6.37-40.958,6.775-78.045,2.249-102.995-5.905,2.089-11.934,3.876-17.779,6.111",
    transform: "translate(95.432 108.66)",
    fill: "#ea9e7c"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28932",
    "data-name": "Path 28932",
    d: "M174.44,75.936,123.454,148.5a24.552,24.552,0,1,1-40.6-27.622l50.986-72.566a24.552,24.552,0,0,1,40.6,27.622",
    transform: "translate(101.23 48.389)",
    fill: "#ea9e7c"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28933",
    "data-name": "Path 28933",
    d: "M36.217,273.419c.089-1.677,5.1-111.881-20.662-139.789S-1.62,79.242,24.142,77.812s60.826,39.359,60.826,39.359l21.467,68.7-4.459,44.3L102.144,256l-8.589,24.33-10.019,7.157Z",
    transform: "translate(0 100.167)",
    fill: "#ea9e7c"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28934",
    "data-name": "Path 28934",
    d: "M111.761,189.23a47.945,47.945,0,1,0-47.945,47.945,47.944,47.944,0,0,0,47.945-47.945",
    transform: "translate(20.439 181.962)",
    fill: "#ea9e7c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10327",
    "data-name": "Group 10327",
    transform: "translate(12.64 180.585)",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10326",
    "data-name": "Group 10326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10325",
    "data-name": "Group 10325",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28935",
    "data-name": "Path 28935",
    d: "M28.521,143.983a1.4,1.4,0,0,1-.135-.126l-.014.176.13.064a.834.834,0,0,1,.055.14l-.043-.252.007,0",
    transform: "translate(23.9 4.69)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28936",
    "data-name": "Path 28936",
    d: "M29.4,131.713l0,0-.007-.023,0,.021",
    transform: "translate(25.219 -10.976)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28937",
    "data-name": "Path 28937",
    d: "M20.277,134.269l-.13-.284-.032-.018-.021-.073-.03-.1-.188-.009c.137.236.27.467.407.7Z",
    transform: "translate(12.96 -8.283)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28938",
    "data-name": "Path 28938",
    d: "M31.744,135.873c-.254.023-.707.178-.883.94l.053.362a1.709,1.709,0,0,0,0,.471,1.779,1.779,0,0,0,.256.675c-.059,0-.112-.034-.176-.016l-.062.114a1.109,1.109,0,0,0-.311-.423.626.626,0,0,0-.856-.018.864.864,0,0,0-.2.7.332.332,0,0,0-.3-.156c-.119.016-.2.114-.245.288l.208.442a.371.371,0,0,1-.112-.217.844.844,0,0,0-.048.732l.3.2.142-.025a.5.5,0,0,1,.085-.014.433.433,0,0,1,.092.037l.144.059.313-.275-.014-.382.037.043.162.121.522-.053.039.1a1.165,1.165,0,0,0,.567.652.638.638,0,0,0,.654-.108l.034-.094.261.146.073-.487,0,0a.805.805,0,0,0,.359.089.988.988,0,0,0,1.027-.071c.027-.021.055-.046.08-.069l.142.014a1.341,1.341,0,0,0,.613-1,1.9,1.9,0,0,0-.293-1.268,1.2,1.2,0,0,0-1.423-.579l-.089-.183.011-.014a1.242,1.242,0,0,0-1.169-.737",
    transform: "translate(24.718 -5.597)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28939",
    "data-name": "Path 28939",
    d: "M30.521,151.08a.4.4,0,0,0-.5.226l-.057.073-.046.009c.361.62.728,1.242,1.084,1.849l.082-.288-.03-.277-.018-.041a.839.839,0,0,0-.428-.721,1.231,1.231,0,0,0,.144-.435Z",
    transform: "translate(25.89 13.961)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28940",
    "data-name": "Path 28940",
    d: "M25.889,126.566a.569.569,0,0,0,.826.364l.087-.03.135-.423a.788.788,0,0,0-.366-.444.433.433,0,0,0-.249-.039l-.043-.357c-.22-.277-.416-.3-.542-.071l.032.291a.347.347,0,0,1,.064.176l.19.1c-.023.018-.048.032-.071.053Z",
    transform: "translate(20.505 -19.069)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28941",
    "data-name": "Path 28941",
    d: "M23.993,131.006a.532.532,0,0,0,.5-.1l.078-.133a.818.818,0,0,0-.057-.583.638.638,0,0,0-.927-.252l-.078.13a.823.823,0,0,0,.055.579.705.705,0,0,0,.428.355",
    transform: "translate(17.602 -13.378)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28942",
    "data-name": "Path 28942",
    d: "M18.12,127.978l.057-.078-.055-.476a.58.58,0,0,0-.469-.206.522.522,0,0,0-.38.35c-.021.046-.041.1-.062.153l.1.394c.421.41.7.011.808-.137",
    transform: "translate(9.527 -16.742)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28943",
    "data-name": "Path 28943",
    d: "M24.292,131.21a.486.486,0,0,0-.233-.284l-.165.053a.2.2,0,0,1,.108.059l-.4.025-.108.233.009.307a.508.508,0,0,0,.366.327c.281.037.538-.387.426-.721",
    transform: "translate(17.614 -11.964)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28944",
    "data-name": "Path 28944",
    d: "M27.758,124.445h0a1.08,1.08,0,0,0-.025.668.8.8,0,0,0,.256.442l.35-.078.265-.572-.071-.4a.645.645,0,0,0-.492-.277.345.345,0,0,0-.284.222",
    transform: "translate(23.025 -20.597)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28945",
    "data-name": "Path 28945",
    d: "M29.2,117.275l-.053-.467a.742.742,0,0,0-.133-.259l-.382,0a.362.362,0,0,0-.192.128l.048.469a.758.758,0,0,0,.135.259l.382,0a.362.362,0,0,0,.194-.128",
    transform: "translate(23.991 -30.485)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28946",
    "data-name": "Path 28946",
    d: "M32.568,148.158l.307-.146a.863.863,0,0,0,.11-.714.493.493,0,0,0-.329-.3l-.256.41a.132.132,0,0,1,0-.094c-.007.014-.03.043-.043.066a.481.481,0,0,0-.1.439.541.541,0,0,0,.313.339",
    transform: "translate(28.877 8.735)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28947",
    "data-name": "Path 28947",
    d: "M22.077,122.247a.824.824,0,0,0-.089-.579.611.611,0,0,0-.922-.167l-.069.137a.816.816,0,0,0,.089.572.666.666,0,0,0,.439.318.522.522,0,0,0,.483-.142Z",
    transform: "translate(14.381 -24.29)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28948",
    "data-name": "Path 28948",
    d: "M29.851,120.848a.6.6,0,0,0,.149-.275l.13.183c.19.032.316.007.391-.085l.066-.243a.436.436,0,0,0-.35-.382.254.254,0,0,0-.231.117v-.023a.6.6,0,0,0-.593-.474l-.222.231c-.087.734.313.943.439.991Z",
    transform: "translate(24.941 -26.464)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28949",
    "data-name": "Path 28949",
    d: "M25.14,110.078l-.329.2a.513.513,0,0,0-.114.22l.215.432a.6.6,0,0,0,.213.176l.311-.21a.486.486,0,0,0,.112-.227l-.22-.426a.548.548,0,0,0-.188-.162",
    transform: "translate(19.166 -38.814)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28950",
    "data-name": "Path 28950",
    d: "M25.112,127.708l.3-.142.288-.368.108-.4-.041-.549-.108-.265-.311-.387-.43-.256a.943.943,0,0,0-.471-.071l-.384.309-.233.613a1.75,1.75,0,0,0,.165.949l.025.066.373.368.325.137Z",
    transform: "translate(18.036 -19.264)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28951",
    "data-name": "Path 28951",
    d: "M19.766,131.18l-.178-.249a.5.5,0,0,0-.615.782l.336.108a.866.866,0,0,1,.1-.05.493.493,0,0,0,.355-.59",
    transform: "translate(11.601 -12.044)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28952",
    "data-name": "Path 28952",
    d: "M16.866,114.147a.343.343,0,0,0,.359-.076l.069-.364-.016-.039a.683.683,0,0,0-.613-.485l-.165.5a.79.79,0,0,0,.366.464",
    transform: "translate(8.61 -34.814)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28953",
    "data-name": "Path 28953",
    d: "M22.465,107.33l.066-.378-.213-.524-.325-.2a.627.627,0,0,0-.458.4.8.8,0,0,0,.094.636l.281.174a.22.22,0,0,1,.078.009.521.521,0,0,0,.476-.11",
    transform: "translate(15.057 -43.777)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28954",
    "data-name": "Path 28954",
    d: "M28.7,120.492l-.2-.057.055-.281-.048-.48-.2-.522-.268-.366-.286-.215-.382-.119a1,1,0,0,0-.86.627,1.471,1.471,0,0,0,0,1.073,1.078,1.078,0,0,0-.108.4l.085.343a1.289,1.289,0,0,0-.041.483l.048.188-.016,0a1.221,1.221,0,0,0,1.128,1.1c.5-.016,1-.476.913-1.4l0-.048-.023-.039c.027-.037.064-.043.087-.082Z",
    transform: "translate(21.367 -28.031)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28955",
    "data-name": "Path 28955",
    d: "M35.172,115.041a1.319,1.319,0,0,0-1.03-.675l-.286.069a.924.924,0,0,0-.236.208l-.5.192-.1.146a1.141,1.141,0,0,0-.4.885l.24.647.016.016a.866.866,0,0,0-.188.126l-.092-.025-.247.085a2.986,2.986,0,0,0-.16-1.043l-.213-1.007a2.582,2.582,0,0,0-.556-.737.546.546,0,0,0-.055-.323.573.573,0,0,0-.574-.281l-.137.213a1.257,1.257,0,0,0-.67.034l-.146.121a.763.763,0,0,0-.268-.021l-.378.288-.238.517a1.583,1.583,0,0,0-.059.755l.133.348.027.043a3.164,3.164,0,0,0,.32,1.38,3.765,3.765,0,0,0,.4.647l.057.048-.252.355-.057.254.062.547.183.414.357.389.439.215.444,0,.316-.167.272-.384.057-.252-.059-.549-.162-.361a1.325,1.325,0,0,0,.368-.2l.126.4a1.5,1.5,0,0,0,.355.471l.032.011.046.167a1.36,1.36,0,0,0,.828.714.724.724,0,0,0,.851-.32.947.947,0,0,0,.654-.769l.018-.2-.007-.284-.059-.3a2.383,2.383,0,0,0-.288-.464c.03-.009.062-.011.092-.021l.11-.11.046.1.275.135a.359.359,0,0,0,.2-.252.694.694,0,0,0-.064-.359,1.193,1.193,0,0,0,.339-.611,1.763,1.763,0,0,0-.185-1.233",
    transform: "translate(24.552 -34.634)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28956",
    "data-name": "Path 28956",
    d: "M19.59,121.812a.939.939,0,0,0,.217.721l.316.034.11-.1a.738.738,0,0,1,.064-.057.758.758,0,0,1,.089-.014l.142-.018.162-.421-.215-.526-.444-.094a.473.473,0,0,1-.112-.057c-.087-.053-.247-.149-.387-.034a.424.424,0,0,0-.1.4l.329.311a.3.3,0,0,1-.169-.149",
    transform: "translate(12.373 -24.498)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28957",
    "data-name": "Path 28957",
    d: "M18.749,98.034l.144-.1a.154.154,0,0,1-.11-.03l.368-.133.057-.256-.059-.3a.441.441,0,0,0-.4-.236c-.272.034-.437.526-.272.833a.431.431,0,0,0,.27.22",
    transform: "translate(11.074 -55.684)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28958",
    "data-name": "Path 28958",
    d: "M21.158,109.735c.153.078.471.24.625-.08l-.009-.309c-.066-.149-.341-.508-.613-.508-.2,0-.334.178-.334.494l.22.35a.8.8,0,0,1,.112.053",
    transform: "translate(14.182 -40.411)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28959",
    "data-name": "Path 28959",
    d: "M17.258,115.95l.172-.227a.608.608,0,0,0-.275-.615c-.172-.1-.416-.087-.547.272l.137.435c.22.146.38.19.512.135",
    transform: "translate(8.749 -32.404)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28960",
    "data-name": "Path 28960",
    d: "M24.483,124.369l.087-.384-.263-.448c-.394-.174-.625-.041-.634.361l.2.35c.073.034.1.071.169.174Z",
    transform: "translate(17.848 -21.578)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28961",
    "data-name": "Path 28961",
    d: "M27.493,103.516c-.043-.105-.121-.3-.3-.343-.121-.03-.227.027-.309.169l.1.471a.379.379,0,0,1-.057-.236.693.693,0,0,0-.224.638l.245.286.144.03a.824.824,0,0,1,.085.016.79.79,0,0,1,.082.066l.126.105.373-.133.117-.512-.318-.432a.828.828,0,0,1-.059-.126",
    transform: "translate(21.729 -47.717)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28962",
    "data-name": "Path 28962",
    d: "M27.75,118.18l-.041.586.236.7a1.3,1.3,0,0,0,.764.634l.389-.057.272-.185.229-.357.059-.254.007-.318-.043-.275-.112-.318a1.225,1.225,0,0,0-.906-.709.845.845,0,0,0-.853.549",
    transform: "translate(23.046 -29.091)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28963",
    "data-name": "Path 28963",
    d: "M19.064,123.537a.406.406,0,0,0-.151.174l.133.462a.7.7,0,0,0,.156.208l.371-.094a.413.413,0,0,0,.153-.172l-.133-.462a.6.6,0,0,0-.16-.21Z",
    transform: "translate(11.718 -21.601)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28964",
    "data-name": "Path 28964",
    d: "M29.147,118.728l-.549.238c-.011-.039,0-.073-.041-.117-.1.046-.2.089-.307.133,0,.059.03.078.048.114l-.547.238a.908.908,0,0,0,.556.549l.071.165a.629.629,0,0,0,.206.194l.327-.181a.456.456,0,0,0,.128-.215l-.055-.124a.929.929,0,0,0,.162-1",
    transform: "translate(23.101 -27.674)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28965",
    "data-name": "Path 28965",
    d: "M25.072,104.225a.479.479,0,0,0,.423-.284.843.843,0,0,0-.137-.718l-.254-.149c-.2.021-.432.149-.343.721l.009-.037Z",
    transform: "translate(19.224 -47.835)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28966",
    "data-name": "Path 28966",
    d: "M23.177,130.573a.28.28,0,0,0-.3.032l-.041.2a.134.134,0,0,1,.089-.064l-.172.412.1.265.206.206a.325.325,0,0,0,.387-.133.765.765,0,0,0-.277-.917",
    transform: "translate(16.67 -12.455)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28967",
    "data-name": "Path 28967",
    d: "M20.769,122.987a.455.455,0,0,0,.41.055l.112-.4-.254-.654-.3-.213a.493.493,0,0,0-.412.291.6.6,0,0,0,.016.432,1.012,1.012,0,0,0,.428.487",
    transform: "translate(13.495 -23.747)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28968",
    "data-name": "Path 28968",
    d: "M26.014,118.49l.192-.533,0-.309a1.621,1.621,0,0,0-1.057-1.437,1.149,1.149,0,0,0-.371-.037.6.6,0,0,0-.025-.217l-.446-.14a.08.08,0,0,1,.066-.037.363.363,0,0,1-.073-.023.316.316,0,0,0-.378.039.548.548,0,0,0-.062.451l.238.236a1.166,1.166,0,0,0-.307.5l-.027.275.016.247.069.286a1.833,1.833,0,0,0,1.084,1.055.975.975,0,0,0,1.084-.352",
    transform: "translate(17.961 -31.557)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28969",
    "data-name": "Path 28969",
    d: "M16.528,99.1l-.293.455.128.35a1,1,0,0,0,.428.583.423.423,0,0,0,.448-.057l.094-.332a1.309,1.309,0,0,0-.691-.929Z",
    transform: "translate(8.269 -52.954)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28970",
    "data-name": "Path 28970",
    d: "M18.146,107.338a.812.812,0,0,0-.119-.657l-.323-.153-.2.087-.114.4.153.394.327.206a.418.418,0,0,0,.279-.275",
    transform: "translate(9.751 -43.386)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28971",
    "data-name": "Path 28971",
    d: "M15.9,116.683a.423.423,0,0,0,.233.048l.181-.373a.629.629,0,0,0,0-.279l-.332-.272a.409.409,0,0,0-.231-.048l-.181.371a.655.655,0,0,0-.007.277Z",
    transform: "translate(7.399 -31.502)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28972",
    "data-name": "Path 28972",
    d: "M27.887,124.538l-.261-.57-.336-.327-.066-.023a.96.96,0,0,0-1.414-.178l-.233.361-.082.38.043.5.357.92.281.375.293.208.387.108c.762-.105,1.11-.693,1.032-1.753",
    transform: "translate(20.194 -21.901)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28973",
    "data-name": "Path 28973",
    d: "M27.933,115.926a.924.924,0,0,0,.268-1.2l-.517.307c-.014-.039-.007-.073-.05-.112l-.288.172c0,.059.037.073.057.108l-.517.307a.751.751,0,0,0,1.048.421",
    transform: "translate(21.985 -32.829)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28974",
    "data-name": "Path 28974",
    d: "M36.844,133.364l-.169-.043c-.018.009-.034.023-.053.034l-.279-.416-.506-.313a.835.835,0,0,0-.506-.027l-.327.334-.185.563a1.536,1.536,0,0,0,.043.611l.2.286a1.475,1.475,0,0,0,.142.492l.108.156-.011.009a.947.947,0,0,0,1.352.451,1.377,1.377,0,0,0,.332-1.622.351.351,0,0,0,.037-.085.546.546,0,0,0-.176-.428",
    transform: "translate(32.187 -9.847)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28975",
    "data-name": "Path 28975",
    d: "M23.331,127.281a.267.267,0,0,0-.286.069l-.025.2a.15.15,0,0,1,.082-.076l-.133.435.121.254.22.183a.328.328,0,0,0,.366-.181.761.761,0,0,0-.345-.888",
    transform: "translate(16.943 -16.679)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28976",
    "data-name": "Path 28976",
    d: "M20.774,119.962l.078-.412-.3-.629-.309-.176a.512.512,0,0,0-.38.341.616.616,0,0,0,.05.432v0a.957.957,0,0,0,.458.437.429.429,0,0,0,.4,0",
    transform: "translate(12.914 -27.652)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28977",
    "data-name": "Path 28977",
    d: "M30.266,108.562l-.462.178-.286.243a1.967,1.967,0,0,0-.384,1.421,2.508,2.508,0,0,0,.394,1.084l-.014.027-.027.659.1.242a1.518,1.518,0,0,0,.805.824.889.889,0,0,0,.911-.169l.206-.435.014-.16a.471.471,0,0,0,.1.009l.387-.3.238-.556a1.553,1.553,0,0,0-.007-.611l.05-.563c-.357-1.531-1.313-1.979-2.025-1.9",
    transform: "translate(24.868 -40.778)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28978",
    "data-name": "Path 28978",
    d: "M26.362,118.054l.13-.318.053-.32a2.266,2.266,0,0,0-.192-.9l-.988.57.007.034-.066.16Z",
    transform: "translate(19.95 -30.519)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28979",
    "data-name": "Path 28979",
    d: "M14.649,97.817a.425.425,0,0,0,.435-.112l.064-.345a1.245,1.245,0,0,0-.75-.851l-.117-.057-.252.494.156.336a.952.952,0,0,0,.464.535",
    transform: "translate(5.428 -56.365)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28980",
    "data-name": "Path 28980",
    d: "M31.588,116.037a1.886,1.886,0,0,0,.366-1.377l-.323-.366a2.587,2.587,0,0,0-.323-.739L30.3,112.9l-.222-.007-.3.149a1.325,1.325,0,0,0,.016-.268,1.4,1.4,0,0,0-.5-.956.808.808,0,0,0-.577-.178,1.3,1.3,0,0,0-.94-.81l-.492.247-.233.419-.092.359a2.1,2.1,0,0,0-.055.757l.082.4.313.41a1.431,1.431,0,0,0-.172.819l.156.421.215.311.332.265a.76.76,0,0,0,.561-.021,2.87,2.87,0,0,0,.332.842,1.621,1.621,0,0,0,.153.691,1.39,1.39,0,0,0,1.208.858,1.108,1.108,0,0,0,1.187-.645,1.931,1.931,0,0,0,.309-.927",
    transform: "translate(22.003 -37.852)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28981",
    "data-name": "Path 28981",
    d: "M27.9,103.465c.128,0,.307-.066.423-.439l-.146-.421c-.375-.238-.556-.11-.631-.014a.573.573,0,0,0-.016.581.468.468,0,0,0,.371.293",
    transform: "translate(22.72 -48.614)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28982",
    "data-name": "Path 28982",
    d: "M16.529,104.538a.829.829,0,0,0-.169-.645l-.329-.114-.19.112-.08.414.181.377.336.165a.44.44,0,0,0,.252-.309",
    transform: "translate(7.657 -46.928)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28983",
    "data-name": "Path 28983",
    d: "M15.1,114.2a.4.4,0,0,0,.231.021l.146-.4a.665.665,0,0,0-.018-.281l-.345-.231a.371.371,0,0,0-.231-.023l-.146.4a.652.652,0,0,0,.018.279Z",
    transform: "translate(6.328 -34.696)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28984",
    "data-name": "Path 28984",
    d: "M28.917,98.32l-.21.16-.043.064a1.006,1.006,0,0,0-.373-.128.955.955,0,0,0-.808.549l-.142-.2a1.326,1.326,0,0,0-1.558-.183,1.382,1.382,0,0,0-.542,1.361l.071.371.254.412.281.245.144.057-.007.018a1.2,1.2,0,0,0,1.247.334l.215-.151.146-.178.119-.256a1.6,1.6,0,0,0,.032-.2l.027.034a1.049,1.049,0,0,0,1.158.192,1.385,1.385,0,0,0,1.142,1.009l.387-.19.227-.3.048-.19.4.611a2.662,2.662,0,0,0,1.084.51l.018.071-.51.064-.215.1-.435.4a2.425,2.425,0,0,0-.6,1.947,3.8,3.8,0,0,0,.144.75l.366.67.208.236.581.387a1.3,1.3,0,0,0,1.316-.24,1.494,1.494,0,0,0,.4-.618l.032.014,0-.073.016-.057.65.023.361-.288.423-1.2a1.536,1.536,0,0,1-.053.615v0a2.428,2.428,0,0,0,.307-1.167,2.428,2.428,0,0,0,.508-1.6l-1.158-.238,1.158.231-.11-.643-.094-.261-.32-.549a2.068,2.068,0,0,0-.27-.233,2.134,2.134,0,0,0-.185-1.329l-.055.011-.069-.309-.279-.412-.5-.3a1.275,1.275,0,0,0-.991.364,2.034,2.034,0,0,0-.938-.444l-.59.108-.217.126-.416.469-.206.439-.014.233-.117-.16-.071-.053a1.481,1.481,0,0,0-.215-.609,1.089,1.089,0,0,0-.856-.519Z",
    transform: "translate(19.852 -54.117)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28985",
    "data-name": "Path 28985",
    d: "M10.235,92.043l-.144-.263a.344.344,0,0,0-.416-.043.712.712,0,0,0,.023.929.326.326,0,0,0,.3.089l.094-.162a.129.129,0,0,1-.1.023l.277-.3Z",
    transform: "translate(-0.388 -62.504)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28986",
    "data-name": "Path 28986",
    d: "M26.871,90.978l-.348-.03-.275.082-.272.222a1.333,1.333,0,0,0-.183.842l.14.492.334.62a1.5,1.5,0,0,0,.368.4l.375.108.307-.034.32-.194a1.414,1.414,0,0,0,.233-.991,1.953,1.953,0,0,0-1-1.515",
    transform: "translate(20.569 -63.452)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28987",
    "data-name": "Path 28987",
    d: "M22.58,99.345l-.46.108-.4.435a1.5,1.5,0,0,0-.112.9l.007.069.256.48.277.256.382.167.334,0,.384-.2.22-.309.117-.494-.027-.279-.194-.469-.343-.4a1.194,1.194,0,0,0-.437-.263",
    transform: "translate(15.166 -52.637)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28988",
    "data-name": "Path 28988",
    d: "M15.59,102.965a.61.61,0,0,1,.112,0c.156,0,.48.016.512-.366l-.1-.293c-.105-.114-.451-.336-.686-.21-.174.092-.233.327-.135.634Z",
    transform: "translate(6.994 -49.144)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28989",
    "data-name": "Path 28989",
    d: "M14.269,110.78l.08-.3a.536.536,0,0,0-.43-.471c-.176-.018-.382.108-.387.517l.256.355a.475.475,0,0,0,.48-.1",
    transform: "translate(4.788 -38.903)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28990",
    "data-name": "Path 28990",
    d: "M39.655,103.533c.05-.009.1.011.153,0,.027-.009.043-.037.071-.05l.5.172.265,0,.611-.24.121-.117a1.943,1.943,0,0,0,.471-1.457,2.81,2.81,0,0,0-.764-1.709l-.75-.416-.327-.039-.606.263-.339-.128-.2-.014-.453.094a1.586,1.586,0,0,0-.8,1.478,2.438,2.438,0,0,0,.808,1.782,1.194,1.194,0,0,0-.7.178l-.039.236a1.02,1.02,0,0,0-.215.153,2.265,2.265,0,0,0-.478-.817,2.107,2.107,0,0,0-1.4-1.375,2.377,2.377,0,0,0-.622-.9A1.5,1.5,0,0,0,33.3,100.4l-.474.439-.142.252-.172.764.009.2a2.6,2.6,0,0,0,.437,1.183l.041.718.126.378.011.018a1.015,1.015,0,0,0-.51,0l-.316.316-.137.375v.533a1.933,1.933,0,0,0,.229.474l-.034.016a1.833,1.833,0,0,0-.522,1.734l.007.069.288.478c0,.046.007.094.011.14l.011.041-.35-.176-.512.021a1.134,1.134,0,0,0-.149.066l.011-.018a2.542,2.542,0,0,0-.867-1.684,1.826,1.826,0,0,0-1.13-.448c-.972-.016-1.638.879-1.517,2.036l.325.357.387.737a1.858,1.858,0,0,0,1.6.577l.192-.178h.014l.032-.046.581-.549.076.565a1.577,1.577,0,0,0,.281.545l.373.2-.14-.034-.483.174a.921.921,0,0,0-.32.41l-.011.547.21.6a1.429,1.429,0,0,0,.371.442l.464.1.458-.165a.923.923,0,0,0,.334-.419l.011-.551-.2-.579a1.4,1.4,0,0,0-.357-.448l-.162-.039.43-.011a.791.791,0,0,0,.4-.281l.128-.508-.007-.053a2.452,2.452,0,0,0,.38.5,1.694,1.694,0,0,0,1.663.382l.577-.538.151-.32.007-.057a2.279,2.279,0,0,0,.364.757l-.215.025-.6.336a1.79,1.79,0,0,0-.332.858l-.291-.256-.533-.126a1.376,1.376,0,0,0-.872.782,2.2,2.2,0,0,0-.133.368l.023.49.133.391.156.263.375.339a2.319,2.319,0,0,0,.112,1.418.925.925,0,0,0-.261.334l.137.547a1.761,1.761,0,0,0,0,.345l.307.577.2.158.43.121a.666.666,0,0,0,.307-.137l.455-.1a1.308,1.308,0,0,0,.082-.691l.529-.22.023.025a1.558,1.558,0,0,0,.766-1.263l-.151-.542a1.209,1.209,0,0,0,.153.03l.14-.1.151.105c.037-.094.039-.1.078-.135l.059-.178.389-.281.185-.4.007-.663.059.018a.888.888,0,0,0,.6-.078l.206-.22.119-.238.076-.323a1.627,1.627,0,0,0-.1-.554,1.645,1.645,0,0,0,1.2-1.107l-.087-.474.355.114.364-.08.158-.144.021.039a1.018,1.018,0,0,0,.469-.526l.041-.43-.062-.371-.192-.419-.188-.188a1.106,1.106,0,0,0-.256-.144l.041.018.169.073.59-.137.3-.391.064-.753c-.471-1.2-1.057-1.487-1.46-1.524a2.4,2.4,0,0,0-.691-1.4.392.392,0,0,0,.259-.055Z",
    transform: "translate(22.959 -52.211)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28991",
    "data-name": "Path 28991",
    d: "M18.331,85.618l-.3.366a.873.873,0,0,0,.222.561.392.392,0,0,0,.373.087l.169-.288,0-.041a.808.808,0,0,0-.458-.684",
    transform: "translate(10.58 -70.316)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28992",
    "data-name": "Path 28992",
    d: "M28.925,94.96l-.277.22-.208.387a1.365,1.365,0,0,0-.048.535,1.6,1.6,0,0,0,.364.844l.329.227.281.057a.524.524,0,0,0,.046.188.509.509,0,0,0,.343.252l.259-.174.009-.039a.9.9,0,0,0-.009-.375,1.006,1.006,0,0,0,.332-.888l-.215-.515-.03-.037a1.21,1.21,0,0,0-.76-.76Z",
    transform: "translate(23.915 -58.385)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28993",
    "data-name": "Path 28993",
    d: "M22.687,114.889c-.394.014-.554.247-.435.641l.279.247c.073,0,.11.023.2.092l.364-.254-.041-.412Z",
    transform: "translate(15.97 -32.618)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28994",
    "data-name": "Path 28994",
    d: "M34.61,128.582a.556.556,0,0,0-.355-.1l-.19.307.043.41.249.313a.672.672,0,0,0,.57-.227.464.464,0,0,0,.108-.35.533.533,0,0,0-.32-.426Z",
    transform: "translate(31.232 -15.113)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28995",
    "data-name": "Path 28995",
    d: "M25.276,106.826l.359.513a1.214,1.214,0,0,0,.451.291l.03,0,.094.14a1.029,1.029,0,0,0,.933.311.812.812,0,0,0,.634-.7,1.2,1.2,0,0,0,.327-1.043l-.046-.2-.094-.272-.144-.263a2.13,2.13,0,0,0-.659-.533.8.8,0,0,0,.469-.236,1.371,1.371,0,0,0,.313-1.094,1.908,1.908,0,0,0-.073-.247l.023-.236-.08-.444c-.124-.272-.6-1.133-1.5-.778l-.359.352-.144.435.151.094a1.43,1.43,0,0,0-.105.689,1.371,1.371,0,0,0,.135.485l.176.43.224.291.053.039-.119.007-.206.076-.213.162a1.167,1.167,0,0,0-.144.243l-.085.018-.4.41a1.193,1.193,0,0,0-.153.508Z",
    transform: "translate(19.725 -49.294)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28996",
    "data-name": "Path 28996",
    d: "M18.706,95.1l.3.162.135-.037a.459.459,0,0,1,.078-.023.509.509,0,0,1,.089.025l.144.043.277-.3-.057-.549-.4-.272a.512.512,0,0,1-.092-.094c-.071-.082-.2-.236-.366-.194-.114.027-.185.133-.215.307l.231.41a.333.333,0,0,1-.121-.2.844.844,0,0,0,0,.721",
    transform: "translate(11.305 -59.709)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28997",
    "data-name": "Path 28997",
    d: "M24.764,104.4l-.22.307-.119.5.03.272.222.5.286.316.428.215.444.007.384-.2.22-.307.119-.5-.03-.272-.222-.5-.286-.316-.428-.215-.444-.007Z",
    transform: "translate(18.817 -46.387)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28998",
    "data-name": "Path 28998",
    d: "M26.844,118.544a1.169,1.169,0,0,0,.455.279l.453-.1.378-.382a1.191,1.191,0,0,0,.172-.526l-.146-.567-.375-.529a1.121,1.121,0,0,0-.478-.288l-.437.105-.373.38a1.188,1.188,0,0,0-.169.5l.142.586Z",
    transform: "translate(21.26 -30.631)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28999",
    "data-name": "Path 28999",
    d: "M25.36,109.419a.993.993,0,0,0,.853.263l.318-.236.176-.3.089-.453-.03-.272-.089-.311-.124-.247-.2-.254a.837.837,0,0,0-1.5.375,1.879,1.879,0,0,0-.238-.35l-.437-.172-.355.032-.364.249a1.541,1.541,0,0,0-.188.927,1.838,1.838,0,0,0,.11.476l.057.016.053.533.153.233-.092.291a1.354,1.354,0,0,0,.1.3.431.431,0,0,0,.339.277.415.415,0,0,0,.416.339l.229-.108a.423.423,0,0,0,.428-.105l-.03-.492c-.046-.046-.092-.092-.137-.142l-.053-.05a1.425,1.425,0,0,0,.371-1Z",
    transform: "translate(17.329 -42.417)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29000",
    "data-name": "Path 29000",
    d: "M26.486,123.123l-.094-.263a.526.526,0,0,0-.613-.183c-.2.1-.3.336-.213.707l.247.265a.512.512,0,0,0,.673-.526",
    transform: "translate(20.248 -22.64)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29001",
    "data-name": "Path 29001",
    d: "M18.56,118.066l.291-.261a.537.537,0,0,0,.078-.238l-.256-.387a.538.538,0,0,0-.2-.13l-.288.263a.525.525,0,0,0-.078.236l.259.389a.584.584,0,0,0,.2.128",
    transform: "translate(10.674 -29.835)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29002",
    "data-name": "Path 29002",
    d: "M19.821,128.781a.557.557,0,0,0,.082-.254l-.254-.371a.511.511,0,0,0-.215-.135l-.279.263a.531.531,0,0,0-.08.224l.252.394a.519.519,0,0,0,.208.137Z",
    transform: "translate(11.927 -15.705)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29003",
    "data-name": "Path 29003",
    d: "M21.293,107.469a.391.391,0,0,0-.46.275l-.053.078a.464.464,0,0,1-.124.039.5.5,0,0,0-.448.57l.259.327c.906.14,1.062-.519,1.073-.927Z",
    transform: "translate(13.383 -42.188)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29004",
    "data-name": "Path 29004",
    d: "M18.812,123.169a.554.554,0,0,0,.554-.142.681.681,0,0,0,.1-.586l-.281-.284c-.075,0-.112-.025-.194-.092l-.371.174a.465.465,0,0,1-.023.082.867.867,0,0,0-.059.4.958.958,0,0,0,.034.188Z",
    transform: "translate(11.226 -23.375)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29005",
    "data-name": "Path 29005",
    d: "M34.46,113.053l-.579.345-.057.073a1.075,1.075,0,0,0-.11-.039,1.149,1.149,0,0,0-.782.092.56.56,0,0,0-.087-.176,1.491,1.491,0,0,0,.021-.307l-.071-.426-.471-.856-.272-.263-.764-.355-.22-.007-.773.38-.224.3-.245.982.037.41.394.97.261.316.087.053-.048.412.057.547.458,1.023.3.316.375.174.007.025a.5.5,0,0,0,.14.169l.162-.053.2.092a2.167,2.167,0,0,0,.76-.183,1.667,1.667,0,0,0,.32.208,1.442,1.442,0,0,0,1.295-.165l.316.176a1.729,1.729,0,0,0,1.83-1.354l-.165-1.272-.238-.439-.151-.2.016-.011a1.757,1.757,0,0,0-1.771-.961",
    transform: "translate(25.772 -37.452)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29006",
    "data-name": "Path 29006",
    d: "M10.918,109.665a1.775,1.775,0,0,0,.023.176l.249.284c.492.082.519-.455.531-.659l.007-.105-.254-.384a.436.436,0,0,0-.435.128.75.75,0,0,0-.121.561",
    transform: "translate(1.414 -40.248)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29007",
    "data-name": "Path 29007",
    d: "M19.524,116.179a.331.331,0,0,0-.3-.1l-.1.158a.156.156,0,0,1,.1-.021l-.277.293.025.272.142.265a.343.343,0,0,0,.414.05.7.7,0,0,0-.009-.922",
    transform: "translate(11.768 -31.089)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29008",
    "data-name": "Path 29008",
    d: "M26.085,124.478c-.215-.329-.416-.3-.492-.272-.206.076-.277.389-.254.65a.516.516,0,0,0,.263.464c.11.05.265.053.416-.2l-.043-.094a.36.36,0,0,0,.174-.35Z",
    transform: "translate(19.989 -20.639)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29009",
    "data-name": "Path 29009",
    d: "M25.771,113.611l-.146.467.007.156a1.68,1.68,0,0,0,.442,1.018,1.23,1.23,0,0,0,1.05.38l.343-.217.2-.3.105-.464-.039-.412-.213-.5-.281-.32-.423-.22-.448-.018-.366.165Z",
    transform: "translate(20.362 -34.82)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29010",
    "data-name": "Path 29010",
    d: "M30.27,121l-.11.1-.046,0-.1.137-.03.027a1.572,1.572,0,0,0-.856-.5l-.423.112-.279.263-.174.7a1.1,1.1,0,0,0,.032.117.229.229,0,0,0-.126.064l-.018.3a.988.988,0,0,0,.565.515l0,.007a1.211,1.211,0,0,0,1.05.348l.323-.2.135-.188a1.121,1.121,0,0,0,.572.206.935.935,0,0,0,.949-1.119l-.638-.725-.112-.007A.875.875,0,0,0,30.27,121",
    transform: "translate(23.599 -25.045)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29011",
    "data-name": "Path 29011",
    d: "M29.11,107.047l-.284.423-.217-.128a.364.364,0,0,1-.146.018.329.329,0,0,0-.307.137.576.576,0,0,0-.053.382c-.032,0-.062-.007-.092,0a1.645,1.645,0,0,0-1.2,1.867.544.544,0,0,0,.011.059l-.561.213a2.017,2.017,0,0,0,.055,2.448l.371-.464.2.1.092.7a.925.925,0,0,0,.856-.561,1.5,1.5,0,0,0,.117-.75l.707-.05.2.053a1.266,1.266,0,0,0,.643-.318,2.2,2.2,0,0,0,.327.188l.97-.167.3-.272.382-.908a3.938,3.938,0,0,0,.11-1.1l.071,0,.874-.51-.021-.034.167-.174.323-1.078-.025-.27-.464-.981-.085-.172-.027.018-.169-.227-.933-.551-.224-.009-.872.51.021.039-.172.183-.318,1.066.021.227-.286-.053Z",
    transform: "translate(20.694 -45.447)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29012",
    "data-name": "Path 29012",
    d: "M24.765,113.218a2.206,2.206,0,0,0-.121-.487l-.188-.318a1.086,1.086,0,0,0-1.055-.444,1.212,1.212,0,0,0-.819,1l.014.375.082.318.169.339a1.16,1.16,0,0,0,1.352.41,1.117,1.117,0,0,0,.565-1.2",
    transform: "translate(16.443 -36.406)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29013",
    "data-name": "Path 29013",
    d: "M17.712,108.209a.325.325,0,0,0-.3-.1l-.1.156a.123.123,0,0,1,.1-.018l-.281.291.025.275.142.268a.349.349,0,0,0,.414.048.7.7,0,0,0-.009-.922",
    transform: "translate(9.435 -41.354)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29014",
    "data-name": "Path 29014",
    d: "M22.129,111.971l.11.7c.092-.007.1-.007.149.018l.515-.076.309-.286.185-.565a1.866,1.866,0,0,0-.8-1.364l-.172.659c-.021-.016-.032-.043-.055-.057l-.069.272a1.379,1.379,0,0,0-.286-.007l.112.7",
    transform: "translate(15.716 -38.401)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29015",
    "data-name": "Path 29015",
    d: "M24.949,114.489a1.463,1.463,0,0,0,.38.858.935.935,0,0,0,.869.311l.533-.208.16-.281a1.184,1.184,0,0,0,.359-1.034l-.162-.432-.217-.3-.332-.261c-.034-.011-.057,0-.089,0l0-.233a1.556,1.556,0,0,0-.819-1.265l.135-.064a.351.351,0,0,0,.119-.137l-.133-.375a.261.261,0,0,1,.073.071.484.484,0,0,0-.172-.329l-.268.069a.463.463,0,0,1-.037.053.513.513,0,0,0-.137.272,1.035,1.035,0,0,0-.016.137l.121.206-.016,0c-.572-.043-1,.474-.963,1.171l.229.561.313.336.208.094-.011.039c.009.007.039.021.05.03l-.16.275Z",
    transform: "translate(18.7 -37.886)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29016",
    "data-name": "Path 29016",
    d: "M28.811,112.013a1.767,1.767,0,0,0,.087-.2,1.327,1.327,0,0,0,.675.943.792.792,0,0,0,1.007-.4.855.855,0,0,0,.178.037l.114.114.329.162.446,0,.108-.057.1.293.3-.1.284-.27.206-.444.053-.432-.055-.375-.176-.419a1.209,1.209,0,0,0-1.032-.531l-.188-.046-.318-.277-.215-.121a.857.857,0,0,0-.494-.037l-.348.339-.066.194a.808.808,0,0,0-.709.217.865.865,0,0,0-.085.158c0-.039,0-.064,0-.105L29,110.6l-.254-.68-.133-.213-.382-.419a1.317,1.317,0,0,0-1.574-.13A1.834,1.834,0,0,0,26,110.869a2.459,2.459,0,0,0,.721,1.542,1.424,1.424,0,0,0,1.261.4l.581-.412Z",
    transform: "translate(20.828 -40.262)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29017",
    "data-name": "Path 29017",
    d: "M17.341,99.507a.482.482,0,0,0-.108.384v0a1.141,1.141,0,0,0,.279.609.563.563,0,0,0,.384.22l.222-.3-.062-.684-.231-.311a.461.461,0,0,0-.485.08",
    transform: "translate(9.55 -52.571)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29018",
    "data-name": "Path 29018",
    d: "M22.943,95.668c-.078-.069-.22-.192-.38-.124s-.181.293-.188.366l.2.371c.14.1.4.272.6.14a.415.415,0,0,0,.156-.387l-.4-.311a.089.089,0,0,1,.076,0,.459.459,0,0,1-.064-.05",
    transform: "translate(16.178 -57.558)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29019",
    "data-name": "Path 29019",
    d: "M31.184,99.117l.194-.343.082-.428a1.816,1.816,0,0,0-.872-1.4l-.545-.041-.359.217-.263.533.009.254a1.793,1.793,0,0,0,.471,1.117,1.1,1.1,0,0,0,.929.345Z",
    transform: "translate(25.253 -55.786)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29020",
    "data-name": "Path 29020",
    d: "M23.333,100.9l-.119.1.73,1.2.238-.192.167-.238a2.579,2.579,0,0,0,.117-.533l.151-.055a.33.33,0,0,0,.128-.124l-.108-.38a.2.2,0,0,1,.066.078.467.467,0,0,0-.149-.339l-.272.039a.219.219,0,0,1-.041.048.53.53,0,0,0-.153.254.933.933,0,0,0-.023.133l0,.009-.73-.037-.007.034",
    transform: "translate(17.257 -51.254)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29021",
    "data-name": "Path 29021",
    d: "M23.643,130.3l-.247-.389a.555.555,0,0,0-.208-.137l-.286.252a.53.53,0,0,0-.085.236l.249.387a.5.5,0,0,0,.213.14l.279-.249a.5.5,0,0,0,.085-.238",
    transform: "translate(16.746 -13.449)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29022",
    "data-name": "Path 29022",
    d: "M19.028,85.8a.36.36,0,0,0,.35-.121.7.7,0,0,0,.071-.627l-.272-.272-.222-.007-.224.3.037.41Z",
    transform: "translate(11.484 -71.402)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29023",
    "data-name": "Path 29023",
    d: "M14.316,92.573l.245.382a.554.554,0,0,0,.215.142l.281-.252a.544.544,0,0,0,.085-.245l-.247-.378a.509.509,0,0,0-.213-.14l-.281.249a.515.515,0,0,0-.085.24",
    transform: "translate(5.798 -61.99)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29024",
    "data-name": "Path 29024",
    d: "M22.629,105.883a1.07,1.07,0,0,0,.144.016l0,0,.384.078.3-.066.318-.252.053-.1a1.293,1.293,0,0,0,.041-.124,2.16,2.16,0,0,0,.259-.657l-.092-.609-.236-.43-.057-.048a1.161,1.161,0,0,0-1.329-.755l-.329.22-.19.3-.1.458.087.956.169.448.227.309Z",
    transform: "translate(15.438 -48.031)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29025",
    "data-name": "Path 29025",
    d: "M30.818,129.768a.645.645,0,0,0-.112.483l.014.1.256.288a.445.445,0,0,0,.435-.14.651.651,0,0,0,.112-.487l-.011-.1-.259-.291a.449.449,0,0,0-.435.142",
    transform: "translate(26.9 -13.647)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29026",
    "data-name": "Path 29026",
    d: "M19.605,80.306c-.2-.055-.361.078-.416.371l.156.38a.96.96,0,0,1,.1.08c.137.112.421.345.629.089l.046-.288c-.039-.156-.245-.558-.515-.631",
    transform: "translate(12.073 -77.174)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29027",
    "data-name": "Path 29027",
    d: "M14.7,85.7a.615.615,0,0,0-.162-.645.362.362,0,0,0-.59.112l.064.437c.188.194.341.277.478.259Z",
    transform: "translate(5.317 -71.183)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29028",
    "data-name": "Path 29028",
    d: "M29.036,96.013a2.094,2.094,0,0,0,1.025,1.208l.057.016-.078.4.037.389.343.9.169.226.117.5a2.185,2.185,0,0,0,1.032.947.774.774,0,0,0-.08.165.56.56,0,0,0,.032.4.42.42,0,0,0,.421.249l.055-.112.089.165.16.135-.165.249-.069.46.307,1.133a1.915,1.915,0,0,0-.249.529,2.248,2.248,0,0,0-.073.57,1.71,1.71,0,0,0-.082.252,2.269,2.269,0,0,0,.345,1.666,1.721,1.721,0,0,0,.97.7,2.6,2.6,0,0,0,.288.574l.965.593.341.016a1.357,1.357,0,0,0,1.6-.8l.041-.1.014-1.144-.146-.428-.2-.281.048-.032a2.528,2.528,0,0,0-.661-.833l.014,0a.551.551,0,0,0,.144-.437.612.612,0,0,0-.254-.378l.135-.442-.048-.483-.435-1a3.84,3.84,0,0,0-.684-.863l.034-.071.055-1.217-.032,0-.041-.286-.048-.085a2.236,2.236,0,0,0-.039-.75l.018-.011.1-.5-.259-1.261-.272-.414-.245-.153-.105-.16-.124-.069a1.442,1.442,0,0,1,.22.222l-.732-.46a.665.665,0,0,1,.16.037l-.494-.281-.394,0-.32.208a2.2,2.2,0,0,0-.059-1.208,2.03,2.03,0,0,0-1-1.192,1.284,1.284,0,0,0-1.881.659,2.566,2.566,0,0,0-.059,1.888",
    transform: "translate(24.561 -60.454)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29029",
    "data-name": "Path 29029",
    d: "M19.424,94.91l.133.375a.431.431,0,0,1,.137.206l.444.069.156-.334-.181-.483c-.359-.265-.611-.206-.689.167",
    transform: "translate(12.376 -58.775)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29030",
    "data-name": "Path 29030",
    d: "M24.4,113.119a.808.808,0,0,0-.272-.32l-.313.091-.153.334.078.4a.827.827,0,0,0,.615.231.318.318,0,0,0,.261-.183.547.547,0,0,0-.087-.535Z",
    transform: "translate(17.829 -35.31)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29031",
    "data-name": "Path 29031",
    d: "M30.335,110.1l.048-.673-.181-.508-.462-.5a.965.965,0,0,0-1.382-.217l-.169.826.215.57.247.366a1.326,1.326,0,0,0,.913.6.88.88,0,0,0,.771-.467",
    transform: "translate(23.665 -41.494)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29032",
    "data-name": "Path 29032",
    d: "M18.345,113.175a.894.894,0,0,0,.048-.6l-.08-.151a.541.541,0,0,0-.442-.227c-.307.025-.517.51-.407.895l.076.149a.534.534,0,0,0,.442.224.459.459,0,0,0,.364-.293",
    transform: "translate(9.815 -36.082)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29033",
    "data-name": "Path 29033",
    d: "M22.23,99.5l.087.661a1.6,1.6,0,0,0,.277.522l.453.243.2,0a1.4,1.4,0,0,0,.021.176l0-.037.334.432a.5.5,0,0,0,.389-.336.783.783,0,0,0-.082-.469.469.469,0,0,0,.053-.046l.135-.517-.087-.65a1.556,1.556,0,0,0-.3-.545l-.439-.227-.512.018a.8.8,0,0,0-.387.249Z",
    transform: "translate(15.99 -53.468)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29034",
    "data-name": "Path 29034",
    d: "M23.5,94.158l-.378.124L22.9,94.6a1.3,1.3,0,0,0-.062.895,1.373,1.373,0,0,0,.634.835l.574.217.275-.094a.828.828,0,0,0,.805-.51l.057-.43-.053-.375-.174-.423a.979.979,0,0,0-1.009-.455l-.105-.059Z",
    transform: "translate(16.71 -59.318)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29035",
    "data-name": "Path 29035",
    d: "M25.13,92.656l.394.048.3-.1.291-.272.1-.22.064-.291.007-.268-.057-.325a1.353,1.353,0,0,0-.769-.892.81.81,0,0,0-.938.284l-.144.531.108.716a1.454,1.454,0,0,0,.643.787",
    transform: "translate(18.759 -64.302)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29036",
    "data-name": "Path 29036",
    d: "M22.193,122.691l.288-.025a.627.627,0,0,0,.089-.135c.121-.263.023-.526-.293-.785a.755.755,0,0,1-.1-.089.216.216,0,0,1,.027.13l-.458-.3a.685.685,0,0,0-.1.577,1.213,1.213,0,0,0,.545.629",
    transform: "translate(15.208 -24.123)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29037",
    "data-name": "Path 29037",
    d: "M19.692,103.426l.039-.259a.756.756,0,0,0-.462-.561c-.231-.069-.423.041-.524.371l.1.366c.5.5.776.19.849.082",
    transform: "translate(11.502 -48.461)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29038",
    "data-name": "Path 29038",
    d: "M25.713,102.914a.926.926,0,0,0,1.485-.245l-.19-.927-.034-.034a1.815,1.815,0,0,0-.3-.54l-.7-.194a1.157,1.157,0,0,0-.252.2l-.428.089a1.336,1.336,0,0,0-.048.954,1.4,1.4,0,0,0,.467.7",
    transform: "translate(19.791 -50.539)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29039",
    "data-name": "Path 29039",
    d: "M14.924,93.336a.383.383,0,0,0-.181.119l.05.464a.729.729,0,0,0,.117.233l.384.011a.37.37,0,0,0,.178-.121l-.048-.462a.679.679,0,0,0-.119-.236Z",
    transform: "translate(6.347 -60.376)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29040",
    "data-name": "Path 29040",
    d: "M10.521,102.641a.7.7,0,0,0,.121.245l.378.011a.372.372,0,0,0,.192-.13l-.053-.448a.728.728,0,0,0-.128-.247l-.375,0a.36.36,0,0,0-.176.112Z",
    transform: "translate(0.857 -49.132)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29041",
    "data-name": "Path 29041",
    d: "M21.023,88.087l.078.419c.746.734,1.192.359,1.4.069l-.053-.437a.418.418,0,0,0-.542-.121l-.082.023a.821.821,0,0,1-.128-.059c-.146-.075-.485-.249-.668.108",
    transform: "translate(14.436 -67.416)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29042",
    "data-name": "Path 29042",
    d: "M26.117,111.847c-.121-.032-.323,0-.487.3l0,.318a.459.459,0,0,0,.707.249.1.1,0,0,1-.03,0l.217-.437a.747.747,0,0,0-.412-.426",
    transform: "translate(20.369 -36.548)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29043",
    "data-name": "Path 29043",
    d: "M21.032,86.234l.231-.249-.066-.506c-.3-.368-.561-.4-.725-.087l.046.391a.459.459,0,0,1,.087.236Z",
    transform: "translate(13.725 -70.883)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29044",
    "data-name": "Path 29044",
    d: "M21.315,103.815l-.124-.062a.883.883,0,0,0-.2-.389l-.332-.023-.231.249-.016.4a1,1,0,0,0,.558.426.293.293,0,0,0,.3-.078c.05-.053.151-.21.039-.519",
    transform: "translate(13.654 -47.491)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29045",
    "data-name": "Path 29045",
    d: "M21.351,96.56l.343.192a1.29,1.29,0,0,0,.725.831c.492.185,1.1-.021,1.265-.872l.009-.043-.071-.286.023-.57-.22-.615a1.355,1.355,0,0,0-.382-.448l-.446-.085-.16.059-.378-.343-.352-.124,0-.007.021-.089-.151-.366a.49.49,0,0,0-.458-.092.473.473,0,0,0-.263.35l-.021.089.151.368c.023.014.043.016.066.03a1.27,1.27,0,0,0-.249.847,1.93,1.93,0,0,0,.542,1.174",
    transform: "translate(14.156 -59.937)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29046",
    "data-name": "Path 29046",
    d: "M14.762,101.842a.43.43,0,0,0,.43-.142.749.749,0,0,0,.188-.531l-.043-.165a.651.651,0,0,0-.389-.361c-.309-.082-.631.288-.613.677l.043.162a.64.64,0,0,0,.384.359",
    transform: "translate(5.82 -50.98)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29047",
    "data-name": "Path 29047",
    d: "M30.226,126.521l.24.487.442.3.638-.048a1.692,1.692,0,0,0,.121-1.867,1.875,1.875,0,0,0-1.009-.991l-.432.071-.286.224-.133.268a2.676,2.676,0,0,0-.14-.606,2.693,2.693,0,0,1-.094-.3l-.021-.043a1.07,1.07,0,0,0,.245-.485l-.023-.458-.121-.373-.245-.387a.874.874,0,0,0-1.057-.19l-.114-.034-.336.046-.339.231-.137.336a.828.828,0,0,0-.224-.412l-.3-.043a1.064,1.064,0,0,0-.394.97l0,.144.483.245.21-.217a1.227,1.227,0,0,0,.183-.252,1.376,1.376,0,0,0,.119.538c-.021.025-.046.043-.064.069a1.731,1.731,0,0,0-.089,1.6l.174.341.35.3.325.124.149-.007,0,.021a1.032,1.032,0,0,0,1.222-.21l.151-.245.025-.078a1.9,1.9,0,0,0,.162.547,1.739,1.739,0,0,0,.265.4Z",
    transform: "translate(21.5 -23.442)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29048",
    "data-name": "Path 29048",
    d: "M23.006,89.974a.814.814,0,0,0-.444.094l-.27.432-.069.636a1.627,1.627,0,0,0,.156.574l.394.38.519.165a.8.8,0,0,0,.458-.108l.256-.428.064-.622a1.543,1.543,0,0,0-.167-.6l-.384-.361Z",
    transform: "translate(15.982 -64.708)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29049",
    "data-name": "Path 29049",
    d: "M17.056,111.874a.45.45,0,0,0,.119-.094c.183-.2.146-.471-.11-.817a1.359,1.359,0,0,1-.08-.119.186.186,0,0,1,0,.128l-.384-.432a.557.557,0,0,0-.231.492,1.328,1.328,0,0,0,.4.764Z",
    transform: "translate(8.439 -38.219)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29050",
    "data-name": "Path 29050",
    d: "M18.757,93.262l.1-.224a.823.823,0,0,0-.329-.673.4.4,0,0,0-.606.156l.011.371c.382.634.728.442.826.371",
    transform: "translate(10.439 -61.735)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29051",
    "data-name": "Path 29051",
    d: "M16.54,83.29a.347.347,0,0,0,.208-.046l.059-.439a.738.738,0,0,0-.064-.261l-.378-.14a.344.344,0,0,0-.208.046l-.059.444a.75.75,0,0,0,.064.254Z",
    transform: "translate(8.093 -74.456)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29052",
    "data-name": "Path 29052",
    d: "M26.535,105.864l-.277.215a.755.755,0,0,0,.222.744.339.339,0,0,0,.467-.037.5.5,0,0,0,.094-.467.681.681,0,0,0-.506-.455",
    transform: "translate(21.166 -44.241)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29053",
    "data-name": "Path 29053",
    d: "M10.473,89.746l.05-.43a.667.667,0,0,0-.069-.27l-.373-.133a.337.337,0,0,0-.2.039l-.069.437a.718.718,0,0,0,.064.268l.373.142a.373.373,0,0,0,.222-.053",
    transform: "translate(-0.001 -66.075)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29054",
    "data-name": "Path 29054",
    d: "M16.359,83.9l.432.206a.667.667,0,0,0,.176-.54.773.773,0,0,0-.426-.542l-.254.043c-.137.158-.245.426.082.869l-.011-.037",
    transform: "translate(8.166 -73.657)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29055",
    "data-name": "Path 29055",
    d: "M27.187,117.972l.231-.334a1.519,1.519,0,0,0,.039-.41.934.934,0,0,0,.741-.259l.174-.387.041-.382-.087-.48-.24-.5-.291-.334-.3-.181-.384-.073a1.054,1.054,0,0,0-.789.732,1.337,1.337,0,0,0-.016.165,1.132,1.132,0,0,0-.318-.069l-.323.121-.222.2-.181.341a1.436,1.436,0,0,0-.014.261l-.1,0a.7.7,0,0,0-.112.522.869.869,0,0,0,.318.506c.041.032.082.064.13.1l.133-.023.483.476a1.222,1.222,0,0,0,.451.24l.368-.057Z",
    transform: "translate(19.59 -32.947)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29056",
    "data-name": "Path 29056",
    d: "M34.692,106.058a.669.669,0,0,0-.268-.547.322.322,0,0,0-.492.126v.039l-.025-.027a1.421,1.421,0,0,0-.38-.213l-.3-.032a.943.943,0,0,0-.773.746,1.977,1.977,0,0,0,.3,1.5l.259.243.249.135.3.064a1.126,1.126,0,0,0,.888-1.064,1.623,1.623,0,0,0-.089-.728.324.324,0,0,0,.249-.064Z",
    transform: "translate(29.096 -44.834)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29057",
    "data-name": "Path 29057",
    d: "M27.435,109.444l.2.165.243.041a.409.409,0,0,0,.22-.38c0-.329-.366-.7-.62-.622a.305.305,0,0,0-.2.231l.059.2a.205.205,0,0,1,.034-.117Z",
    transform: "translate(22.488 -40.67)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29058",
    "data-name": "Path 29058",
    d: "M21.664,102.568a.69.69,0,0,0-.165.538.593.593,0,0,0,.206.371h0a.666.666,0,0,0,.533.14.425.425,0,0,0,.32-.231l-.1-.428-.485-.4Z",
    transform: "translate(15.04 -48.507)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29059",
    "data-name": "Path 29059",
    d: "M26.165,98.571l-.021-.368-.085-.329a2.064,2.064,0,0,0-.5-.718L25,98.258l.021.03.009.183Z",
    transform: "translate(19.555 -55.458)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29060",
    "data-name": "Path 29060",
    d: "M29.524,94.254a.832.832,0,0,0-.7.529,1.435,1.435,0,0,0,.126,1.382,1.173,1.173,0,0,0,.416.357l-.032.021-.043-.032-.025.055-.023,0-.378,1a1.161,1.161,0,0,0-.229-.217,1.619,1.619,0,0,0-.444-1.222L28.2,96.1a1.082,1.082,0,0,0-.256-1.265l-.2.4a.34.34,0,0,0-.13.13.07.07,0,0,0-.041-.027c-.055.11-.108.217-.16.325.025.053.057.048.085.069l-.137.279-.149.053-.249.2a1.415,1.415,0,0,0-.4.515l-.059.183,0,0-.384-.323-.361-.14-.307,0-.332.156a1.353,1.353,0,0,0-.291.554l-.046,0-.222.181a1.391,1.391,0,0,0-.048,1.576l.254.279.448.288.469.027-.082-.636,0,0,.112.631.38-.373.069.167a.86.86,0,0,0,.863.387.506.506,0,0,1-.261-.149l.275.094a1.339,1.339,0,0,0,.316.2.342.342,0,0,0-.018.119l.291.32a.428.428,0,0,0,.22.085l.217-.311a.543.543,0,0,0,.041-.252l-.007-.007a1.217,1.217,0,0,0,.352-.38,1.048,1.048,0,0,0,.627-.551,1.325,1.325,0,0,0,0-1.052l-.009-.016a1.021,1.021,0,0,0,.984-.082l.288-.471-.92-.7-.041-.075a.871.871,0,0,0,.748.034l.181-.586.144-.174.1-.238L30.4,94.7a1.089,1.089,0,0,0-.876-.451",
    transform: "translate(18.632 -59.196)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29061",
    "data-name": "Path 29061",
    d: "M8.321,85.349l-.114.016,0,.6.254.222a.683.683,0,0,0,.577.224.479.479,0,0,0,.3-.357L9.248,85.7a.886.886,0,0,0-.927-.35",
    transform: "translate(-2.077 -70.691)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29062",
    "data-name": "Path 29062",
    d: "M25.671,94.321l.247.018,0,.007a.963.963,0,0,0,1.56-.236l.05-.512-.1-.43-.275-.46-.48-.4-.375-.14-.311.014-.327.165a1.3,1.3,0,0,0-.272,1.043,1.528,1.528,0,0,0,.121.357.533.533,0,0,0,.158.579",
    transform: "translate(20.04 -61.886)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29063",
    "data-name": "Path 29063",
    d: "M12.809,91.076l-.3.085-.108.217.1.428.291.245.332-.043a.606.606,0,0,0,.078-.432.756.756,0,0,0-.387-.5",
    transform: "translate(3.326 -63.287)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29064",
    "data-name": "Path 29064",
    d: "M15.3,100.6l.039.453a.663.663,0,0,0,.124.247l.366.018a.368.368,0,0,0,.19-.117l-.039-.451a.689.689,0,0,0-.124-.252l-.366-.014a.362.362,0,0,0-.19.114",
    transform: "translate(7.067 -51.164)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29065",
    "data-name": "Path 29065",
    d: "M27.571,100.119l-.394-.059-.059.025c-.343-.108-.821-.062-1.107.805l0,.476.1.352-.117.224.082.6.162.421a1.55,1.55,0,0,0,.766.865.857.857,0,0,0,.876-.158l.2-.6-.041-.357.03-.016a1.8,1.8,0,0,0-.053-2.249Z",
    transform: "translate(20.835 -51.739)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29066",
    "data-name": "Path 29066",
    d: "M19.661,107.082l.243.025a.553.553,0,0,0,.254-.382.678.678,0,0,0-.313-.714l-.334.194a.647.647,0,0,1-.014.085l.215.1-.233,0a.677.677,0,0,0,.183.693",
    transform: "translate(12.413 -44.052)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29067",
    "data-name": "Path 29067",
    d: "M13.4,93.676l-.407,0a.226.226,0,0,1-.046.064.708.708,0,0,0-.167.332,1.13,1.13,0,0,0-.016.181l.169.32a.606.606,0,0,0,.579.1.533.533,0,0,0,.252-.476l-.2-.364a.34.34,0,0,1-.167-.158",
    transform: "translate(3.797 -59.938)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29068",
    "data-name": "Path 29068",
    d: "M25.607,99.262l-.419-.311-.62,0a1.792,1.792,0,0,0-.519,2.26l.332-.206a1.6,1.6,0,0,0,.279.51l-.025.236a1.093,1.093,0,0,0,.371.059,1.086,1.086,0,0,0,.794.176l.3-.229.176-.3.089-.444-.046-.517.609.359-.05.007,0,.49.208.181a.8.8,0,0,0,.293.16.915.915,0,0,0,.782.661.707.707,0,0,0,.686-.853l-.6-.023c0-.039.018-.066-.007-.119l-.336-.014c-.016.053.007.082.014.121l-.137-.007.018-.034-.069-.291a.755.755,0,0,0-.512-.293,1.781,1.781,0,0,0-.126-1.217,1.372,1.372,0,0,0-.8-.689l-.373.041-.265.16.281.579-.162-.128Z",
    transform: "translate(18.074 -53.16)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29069",
    "data-name": "Path 29069",
    d: "M9.139,79.092a.586.586,0,0,0-.27.446,1.591,1.591,0,0,0-.023.165l.165.35c.458.268.629-.2.693-.371l.037-.089L9.6,79.151a.469.469,0,0,0-.458-.059",
    transform: "translate(-1.247 -78.769)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29070",
    "data-name": "Path 29070",
    d: "M28.036,95.924a1.623,1.623,0,0,0-.794,1.153,2.9,2.9,0,0,0-.016.888l.08.014.055.771.194.432.8.789a1.551,1.551,0,0,0,1.066.027l.371.119a.78.78,0,0,0,.464-.117l.247-.421.062-.65a1.935,1.935,0,0,0-.066-.3l-.043-.714a1.932,1.932,0,0,0,.238-.5l-.062-.652-.236-.455-.158-.217a1.166,1.166,0,0,0-.46-.293l-.453.094-.087.082a1.677,1.677,0,0,0-.581-.176l-.371.037Z",
    transform: "translate(22.39 -57.206)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29071",
    "data-name": "Path 29071",
    d: "M14.792,89.051l.066.293a.417.417,0,0,0,.391.208c.263-.043.4-.531.238-.817a.409.409,0,0,0-.268-.206l-.135.1a.165.165,0,0,1,.1.021l-.348.149Z",
    transform: "translate(6.411 -66.567)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29072",
    "data-name": "Path 29072",
    d: "M19.522,98.564c-.048,0-.076.041-.117.059a.364.364,0,0,0,.016-.094L19.1,98.2a.194.194,0,0,1,.105.025.456.456,0,0,0-.329-.245l-.224.281a.356.356,0,0,1-.009.087.907.907,0,0,0,.009.414,1.457,1.457,0,0,0,.057.167l.291.19.1-.021a.559.559,0,0,0,.126.448.322.322,0,0,0,.46-.014l-.018-.1a.277.277,0,0,0,.261-.238l-.009-.2c-.119-.375-.32-.43-.4-.437",
    transform: "translate(11.349 -54.389)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29073",
    "data-name": "Path 29073",
    d: "M21.7,92.625l.043-.151a.306.306,0,0,0,.14-.034.3.3,0,0,0,.462.069l.14-.231a.475.475,0,0,0,.3-.345l-.215-.439c-.055-.014-.11-.032-.165-.05a1.139,1.139,0,0,0-.718-.043,1.666,1.666,0,0,0-.549-.734A1.045,1.045,0,0,0,19.6,90.8l-.1.231-.05.227-.011.279a2.093,2.093,0,0,0,.776,1.364,1.037,1.037,0,0,0,1.151.121Z",
    transform: "translate(12.398 -64.161)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29074",
    "data-name": "Path 29074",
    d: "M24.371,93.188a.533.533,0,0,0,.222.412.5.5,0,0,0,.277.5l.178.023a1.3,1.3,0,0,0-.046.426v0a2.108,2.108,0,0,0-.181.4l-.034.57.03.254.169.583a1.893,1.893,0,0,0,1.7,1.185l0-.071.583-.039.291-.178.483-.757.1-.5-.121-1.011-.172-.382-.634-.728a1.577,1.577,0,0,0-1.5-.14l-.023.021-.009,0c-.014-.03-.027-.059-.039-.092-.165-.394-.41-.991-1.043-.986l-.213.213a1.382,1.382,0,0,0-.014.3",
    transform: "translate(18.743 -61.224)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29075",
    "data-name": "Path 29075",
    d: "M8.044,99.985l.288-.137a.414.414,0,0,0,.146-.169l-.162-.462a.258.258,0,0,1,.089.089A.6.6,0,0,0,8.2,98.9l-.332.082a.315.315,0,0,1-.046.066.648.648,0,0,0-.167.336,1.063,1.063,0,0,0-.018.167l.194.339Z",
    transform: "translate(-2.808 -53.213)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29076",
    "data-name": "Path 29076",
    d: "M23.827,89.278l-.355-.364-.432-.194-.4,0-.291.146-.268.355-.034.14a1.615,1.615,0,0,0,.158,1.075,1.518,1.518,0,0,0,.92.753l.394-.053.272-.185.227-.368.073-.38-.073-.528Z",
    transform: "translate(15.711 -66.325)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29077",
    "data-name": "Path 29077",
    d: "M20.944,95.988l.238-.4a2.515,2.515,0,0,0-.437-2.176l-.718-.092-.364.329-.19.458-.041.231a1.822,1.822,0,0,0,.11,1.206,1.306,1.306,0,0,0,.691.666l.421-.037Z",
    transform: "translate(12.316 -60.391)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29078",
    "data-name": "Path 29078",
    d: "M19.443,87.006l-.087.336,0,.313.073.366a1.417,1.417,0,0,0,1.208.9.9.9,0,0,0,.872-.83,1.833,1.833,0,0,0,.014-.478l-.1-.357a1.32,1.32,0,0,0-.908-.81,1.022,1.022,0,0,0-1.068.558",
    transform: "translate(12.282 -69.27)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29079",
    "data-name": "Path 29079",
    d: "M22.66,82.733l-.352-.112-.423.073a1.2,1.2,0,0,0-.43.744,1.035,1.035,0,0,0-.009.2.422.422,0,0,0-.3.291.613.613,0,0,0,.213.547c.021.016.041.016.062.03l.151.474.533.517c.561.092,1.03-.309,1.165-1a2.161,2.161,0,0,0-.227-1.441Z",
    transform: "translate(14.581 -74.176)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29080",
    "data-name": "Path 29080",
    d: "M15.861,80.978a.4.4,0,0,0-.265-.2l-.135.1a.149.149,0,0,1,.108.025l-.355.144-.048.254.066.293a.419.419,0,0,0,.391.206c.259-.048.4-.529.238-.817",
    transform: "translate(6.891 -76.555)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29081",
    "data-name": "Path 29081",
    d: "M19.82,85.31c-.016-.023-.021-.05-.039-.075l-.142.215a1.506,1.506,0,0,0-.275-.119l-.08.663v0l-.08.661a.29.29,0,0,1,.14.075l.522.14.378-.128.334-.426a1.917,1.917,0,0,0-.414-1.524Z",
    transform: "translate(12.094 -71.376)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29082",
    "data-name": "Path 29082",
    d: "M22.359,88.811l.359-.009.265-.124.254-.284.073-.249a1.563,1.563,0,0,0-.75-1.663.865.865,0,0,0-1.256.647l.075.586.213.421.178.167-.021.03a1.4,1.4,0,0,0,.609.478",
    transform: "translate(14.797 -69.334)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29083",
    "data-name": "Path 29083",
    d: "M15.7,102.818l-.14-.442a.69.69,0,0,0-.165-.206l-.348.11a.4.4,0,0,0-.144.174l.14.442a.6.6,0,0,0,.169.208l.339-.11a.414.414,0,0,0,.149-.176",
    transform: "translate(6.548 -48.998)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29084",
    "data-name": "Path 29084",
    d: "M23.241,106.1a.508.508,0,0,0,.238-.384l.014-.092-.172-.357a.475.475,0,0,0-.462-.05.5.5,0,0,0-.238.382l-.016.094.174.357a.479.479,0,0,0,.462.05",
    transform: "translate(16.473 -45.123)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29085",
    "data-name": "Path 29085",
    d: "M6.087,81.256l-.227-.13a.33.33,0,0,0-.318.247.716.716,0,0,0,.446.8.274.274,0,0,0,.259-.128l-.007-.206a.176.176,0,0,1-.064.089l.057-.453Z",
    transform: "translate(-5.524 -76.102)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29086",
    "data-name": "Path 29086",
    d: "M17.937,79.615l-.087.661a1.736,1.736,0,0,0,.339.867l.037.055.4.245.318.034.352-.119.243-.224.183-.442.016-.419c-.57-.279-1.137-.547-1.707-.8Z",
    transform: "translate(10.349 -78.233)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29087",
    "data-name": "Path 29087",
    d: "M15.076,86.253a.565.565,0,0,0-.59.288.6.6,0,0,0,.2.65l.323,0a.673.673,0,0,1,.082-.078.554.554,0,0,0,.2-.675Z",
    transform: "translate(5.973 -69.508)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29088",
    "data-name": "Path 29088",
    d: "M17.063,94.505c-.135.105-.224.357-.037.721l.348.137a.584.584,0,0,0,.3-.426l-.082-.316a.368.368,0,0,0-.526-.117",
    transform: "translate(9.15 -58.958)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29089",
    "data-name": "Path 29089",
    d: "M22.129,82.518l.146.517.146.22.394.286.35.08.407-.108.323-.3.112-.272q-.868-.577-1.743-1.135l-.119.291Z",
    transform: "translate(15.86 -75.226)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29090",
    "data-name": "Path 29090",
    d: "M26.68,88.11l-.064-.7-.073-.243-.259-.522a1.739,1.739,0,0,0-1.149-.746l0-.137-.146-.458-.146-.22-.21-.21-.2-.133-.259-.089a.817.817,0,0,0-.844.455,1.428,1.428,0,0,0,.025,1.2l.375.414.089.032a1.934,1.934,0,0,0-.128.394,2.4,2.4,0,0,0,.291,1.647,1.772,1.772,0,0,0,.952.782,1.491,1.491,0,0,0,.167.206l.519.4.3.007a.8.8,0,0,0,.92-.185l.158-.375.034-.361-.075-.446a1.478,1.478,0,0,0-.332-.46c.018-.069.041-.121.057-.2l.009-.057",
    transform: "translate(17.244 -71.56)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29091",
    "data-name": "Path 29091",
    d: "M24.591,97.18a1.091,1.091,0,0,0-.654-.43L23.8,96.8l-.043-.021-.137.08-.105.034-.011.034-.426.249a1.45,1.45,0,0,0,.821,1.56.958.958,0,0,0,.169.041l-.023.121a.679.679,0,0,0,.053.261l.366.162a.353.353,0,0,0,.2-.025l.089-.43c0-.03-.021-.094-.03-.144a.856.856,0,0,0,.4-.595L24.7,97.23Z",
    transform: "translate(17.054 -55.979)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29092",
    "data-name": "Path 29092",
    d: "M32.028,108.677a2.413,2.413,0,0,0-.764-1.565,1.665,1.665,0,0,0-.748-.38.384.384,0,0,0-.025-.126l-.355-.151a.361.361,0,0,0-.217.03l-.053.288a1.2,1.2,0,0,0-.24.126l-.046-.082c-.059-.025-.082-.055-.135-.128l-.329,0a.219.219,0,0,1-.039.053.55.55,0,0,0-.135.27.741.741,0,0,0-.014.146l.137.261.009,0a2.119,2.119,0,0,0-.217,1.245,2.782,2.782,0,0,0,.853,1.762,1.425,1.425,0,0,0,1.341.373l.343-.178.222-.2a1.655,1.655,0,0,0,.261-.5l.1.027.117-.121.048-.2a.419.419,0,0,0-.137-.215,3.134,3.134,0,0,0,.025-.739",
    transform: "translate(24.507 -43.486)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29093",
    "data-name": "Path 29093",
    d: "M21.064,87.41a.536.536,0,0,0-.2.558v.105a.728.728,0,0,1-.071.119.685.685,0,0,0-.057.81l.336.11a1.145,1.145,0,0,0,.341-1.556Z",
    transform: "translate(13.919 -68.009)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29094",
    "data-name": "Path 29094",
    d: "M18.314,94.919a.677.677,0,0,0-.27-.728l-.343.158c0,.027-.014.055-.021.082l.21.114-.236-.021a.671.671,0,0,0,.14.7l.243.046a.531.531,0,0,0,.277-.35",
    transform: "translate(10.045 -59.275)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29095",
    "data-name": "Path 29095",
    d: "M12.384,81.529l-.407-.034a.267.267,0,0,1-.05.059.637.637,0,0,0-.188.309.988.988,0,0,0-.027.174l.149.329a.625.625,0,0,0,.572.149.506.506,0,0,0,.284-.442l-.176-.375c-.071-.034-.1-.073-.156-.169",
    transform: "translate(2.443 -75.627)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29096",
    "data-name": "Path 29096",
    d: "M23.906,87.777l-.375,0-.277.13.435,1.055,0,.032a.515.515,0,0,1-.043.167l1.032.718a1.734,1.734,0,0,0-.007-1.359,1.415,1.415,0,0,0-.76-.748",
    transform: "translate(17.309 -67.536)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29097",
    "data-name": "Path 29097",
    d: "M21.934,83.338a1.414,1.414,0,0,0-.355-.474l-.442-.124-.48.126a.858.858,0,0,0-.339.357l-.032.329a1,1,0,0,0-.194.384l-.016.181-.014-.007a1.39,1.39,0,0,0,.714,1.464.918.918,0,0,0,1.32-.732l.011-.043-.055-.284.059-.556Z",
    transform: "translate(13.174 -74.022)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29098",
    "data-name": "Path 29098",
    d: "M17.958,86.537c-.222-.037-.389.192-.451.421a.526.526,0,0,0,.1.517.327.327,0,0,0,.46.032l-.011-.1a.27.27,0,0,0,.277-.208l0-.2c-.094-.378-.293-.451-.375-.464",
    transform: "translate(9.875 -69.138)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29099",
    "data-name": "Path 29099",
    d: "M19.051,80.207a1.116,1.116,0,0,0,.945.279q-.625-.323-1.249-.631a1.814,1.814,0,0,0,.3.352",
    transform: "translate(11.504 -77.739)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29100",
    "data-name": "Path 29100",
    d: "M23.494,83.034l.014.252.133.586a1.973,1.973,0,0,0,1.62,1.32v-.071l.407.011a2.344,2.344,0,0,0,.6,1.245l.744.254.181.124a1.279,1.279,0,0,0,.714-.023,2.514,2.514,0,0,0,.268.3l.991.243.364-.121.046-.048c-1.956-1.519-3.974-3-6.033-4.416Z",
    transform: "translate(17.618 -74.095)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29101",
    "data-name": "Path 29101",
    d: "M7.039,86.544a.612.612,0,0,0-.185-.416l-.336.05c0,.016-.023.032-.05.057a.639.639,0,0,0-.188.313,1.2,1.2,0,0,0-.03.165l.174.348.21.114.3-.108a.392.392,0,0,0,.158-.151l-.133-.467a.294.294,0,0,1,.085.094",
    transform: "translate(-4.591 -69.66)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29102",
    "data-name": "Path 29102",
    d: "M23.352,85.981a1.128,1.128,0,0,0-.627-.483l-.137.032-.041-.023-.142.064-.108.023-.016.034-.439.2a1.383,1.383,0,0,0,.064.86,1.466,1.466,0,0,0,.657.741.807.807,0,0,0,1.265-.478l-.371-.915Z",
    transform: "translate(15.437 -70.471)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29103",
    "data-name": "Path 29103",
    d: "M19.067,81.792l-.384.286-.22.43-.055.224a1.753,1.753,0,0,0,.032,1.187,1.36,1.36,0,0,0,.65.716l.423,0,.3-.16.261-.362a2.451,2.451,0,0,0-.3-2.171Z",
    transform: "translate(10.951 -75.244)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29104",
    "data-name": "Path 29104",
    d: "M14.087,90.673l-.11-.446a.7.7,0,0,0-.151-.215l-.355.073a.386.386,0,0,0-.156.158l.11.444a.689.689,0,0,0,.158.22l.345-.075a.351.351,0,0,0,.158-.158",
    transform: "translate(4.51 -64.657)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29105",
    "data-name": "Path 29105",
    d: "M20.453,90.32a.921.921,0,0,0,.009.41.974.974,0,0,0,.062.178l.265.19a.558.558,0,0,0,.49-.27.731.731,0,0,0,0-.595l-.3-.213a.231.231,0,0,1-.194-.043l-.316.256a.87.87,0,0,1-.009.087",
    transform: "translate(13.677 -64.702)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29106",
    "data-name": "Path 29106",
    d: "M11.764,78.93a.436.436,0,0,0-.382.229.8.8,0,0,0-.025.577,1.716,1.716,0,0,0,.05.167l.275.22c.467-.037.41-.567.387-.769l-.009-.108Z",
    transform: "translate(1.935 -78.93)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29107",
    "data-name": "Path 29107",
    d: "M19.939,84.8l.174.227a.315.315,0,0,0,.391-.046.725.725,0,0,0-.156-.9.289.289,0,0,0-.293-.023l-.062.178a.122.122,0,0,1,.089-.043l-.21.352Z",
    transform: "translate(12.954 -72.375)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29108",
    "data-name": "Path 29108",
    d: "M27.813,90.84l-.089-.178c-.249-.272-.43-.2-.5-.151-.181.121-.194.446-.13.7.078.311.247.38.316.4.108.021.254-.014.352-.3l-.057-.082a.378.378,0,0,0,.105-.382",
    transform: "translate(22.213 -64.074)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29109",
    "data-name": "Path 29109",
    d: "M18.723,83.491l-.252.277a.537.537,0,0,0-.064.224l.261.361a.513.513,0,0,0,.206.117l.259-.275a.552.552,0,0,0,.064-.254l-.263-.339a.449.449,0,0,0-.21-.112",
    transform: "translate(11.066 -73.056)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29110",
    "data-name": "Path 29110",
    d: "M28.7,116.442l.087-.183a.825.825,0,0,0-.268-.567c-.14-.089-.284-.043-.378.14l.046.3c.021.023.041.053.062.08.082.114.249.35.451.231",
    transform: "translate(23.605 -31.641)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29111",
    "data-name": "Path 29111",
    d: "M23.719,118.087l.185-.053a.419.419,0,0,0,0-.483.3.3,0,0,0-.455-.085l-.034.316c.105.183.2.279.309.3",
    transform: "translate(17.51 -29.394)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29112",
    "data-name": "Path 29112",
    d: "M26,138.962l-.249-.023-.174.185-.014.3a.758.758,0,0,0,.414.323.216.216,0,0,0,.224-.055c.039-.039.117-.156.034-.387l-.092-.048a.676.676,0,0,0-.144-.291",
    transform: "translate(20.286 -1.644)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29113",
    "data-name": "Path 29113",
    d: "M37.414,132.821l-.352-.9-.039-.025a1.761,1.761,0,0,0-.391-.474l-.709-.007c-.025.025-.039.053-.062.078l-.087-.22a.858.858,0,0,0,.1-.556.97.97,0,0,0-.224-.478,1.16,1.16,0,0,0-.117-.972L35.151,129l-.327-.011-.222.071a.887.887,0,0,0-.394.242l-.151.208-.025.378a.636.636,0,0,0-.487.183l-.055.124a.949.949,0,0,0-.59-.071l-.087-.156-.165-.231-.208-.2a1.55,1.55,0,0,0-.526-.174c-.03-.073-.082-.13-.119-.2a.836.836,0,0,0,.172-.215,1.646,1.646,0,0,0,.675.341l.135.032.43-.2.183-.352-.027-.6c-.517-.943-1.016-1.023-1.316-.959V127.2l-.053-.336c-.018-.037-.046-.055-.064-.089h.178a.269.269,0,0,0,.135-.089l-.041-.357a.538.538,0,0,0-.1-.181H31.82a.3.3,0,0,0-.133.089l.025.229a.712.712,0,0,0-.384-.181l-.069-.071-.243-.121-.3-.018-.227.158a.814.814,0,0,0-.206.593.519.519,0,0,0,.032.117c-.055.041-.108.046-.165.1l-.144.3a1.614,1.614,0,0,0-.039.421c-.032-.007-.057-.034-.092-.039l.1.734c-.025-.007-.043-.025-.069-.027l.041.3a1.208,1.208,0,0,0-.243.149l.254.448a1.964,1.964,0,0,0,.119.565,1.757,1.757,0,0,0,.238.428l.057-.007.016.043-.183.453a1.557,1.557,0,0,0,.009.558,1.688,1.688,0,0,0-.577-.931,1.09,1.09,0,0,0-.661-.222l-.03-.05.435-.137a.949.949,0,0,0,.336-.384l.037-.57-.206-.643a1.439,1.439,0,0,0-.384-.48l-.464-.112-.492.158c-.014.009-.037.032-.055.043a1,1,0,0,0,.126-.645,1.34,1.34,0,0,0-.805-1.089.648.648,0,0,0-.808.5l.055.519.142.265-.025.016a.958.958,0,0,0,.92.773l.16-.066c-.011.018-.025.025-.037.048l-.043.583.206.654a1.763,1.763,0,0,0,.261.355l-.048.114-.384.2-.453-.057.009.307.112.364.233.359.089.075-.039.252.03.249a2.194,2.194,0,0,0,.4,1.018l-.206-.069a.625.625,0,0,0-.332.066l-.2.318-.055.474a1.187,1.187,0,0,0,.11.43l.293.286.384.128a.588.588,0,0,0,.345-.073l.194-.316.053-.464a1.544,1.544,0,0,0-.066-.3,1.166,1.166,0,0,0,.5.153l.037.474.105.261.348.4.35.192.448.027.4-.188.288-.368.108-.4-.041-.549-.105-.263L31,132.814a.941.941,0,0,0,.151-.506.861.861,0,0,0,.332.034l.025-.018.124.1a.754.754,0,0,0,.515.08.615.615,0,0,0,.151.291.424.424,0,0,0,.38.13l.194-.268a.966.966,0,0,0,.8-.057l.3.769.215.2a1.135,1.135,0,0,0-1.165.966l.574.268.041.265-.48.332a1.379,1.379,0,0,0,.933.789,1.24,1.24,0,0,0,1.128-.524l.126-.128.16-.712-.144-.577-.188-.217a1.137,1.137,0,0,0,.419-.08l.247-.167.146-.162c.027-.041.034-.094.059-.14a.94.94,0,0,0,1.37-.661",
    transform: "translate(21.699 -18.21)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29114",
    "data-name": "Path 29114",
    d: "M24.4,131.41l.075-.165a.618.618,0,0,0-.24-.506.3.3,0,0,0-.455.11l0,.275c.281.476.542.339.615.286",
    transform: "translate(17.986 -12.288)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29115",
    "data-name": "Path 29115",
    d: "M22.487,123.658a.553.553,0,0,0,.046.19l.281.11a.258.258,0,0,0,.156-.032l.048-.327a.542.542,0,0,0-.046-.194l-.281-.108a.276.276,0,0,0-.156.032Z",
    transform: "translate(16.321 -21.791)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29116",
    "data-name": "Path 29116",
    d: "M18.068,128.74a.251.251,0,0,0,.165-.037l.041-.32a.47.47,0,0,0-.05-.2l-.277-.1a.245.245,0,0,0-.149.027l-.055.325a.506.506,0,0,0,.046.2Z",
    transform: "translate(10.211 -15.633)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29117",
    "data-name": "Path 29117",
    d: "M22.481,133.167l-.043.27a1.052,1.052,0,0,0,.1.215.3.3,0,0,0,.281.169.294.294,0,0,0,.348.2l.162-.119a.332.332,0,0,0,.311-.146l-.073-.382c-.039-.03-.08-.059-.119-.092-.243-.188-.606-.474-.97-.117",
    transform: "translate(16.258 -9.297)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29118",
    "data-name": "Path 29118",
    d: "M21.594,126.66a.675.675,0,0,0-.215-.526l-.208-.053c-.146.066-.288.222-.13.643a.1.1,0,0,1,0-.03l.3.291a.428.428,0,0,0,.259-.325",
    transform: "translate(14.368 -18.204)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29119",
    "data-name": "Path 29119",
    d: "M26.931,122.871l-.174-.268-.261-.087a.694.694,0,0,0-.249.467.453.453,0,0,0,.064.307.292.292,0,0,0,.341.13l.037-.108a.355.355,0,0,0,.243-.124Z",
    transform: "translate(21.159 -22.795)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29120",
    "data-name": "Path 29120",
    d: "M27,133.659l.048.524.1.174a1.2,1.2,0,0,0,.263.279c0,.034,0,.064,0,.1l.082.334.423.652.069.055-.043.149.119.249.217.181a.324.324,0,0,0,.368-.176.408.408,0,0,0,.018-.11,1.1,1.1,0,0,0,.961-.439,1.58,1.58,0,0,0,.245-1.128,1.8,1.8,0,0,0-.734-1.238.972.972,0,0,0-1-.076,1.051,1.051,0,0,0-.677-.153l-.332.272Z",
    transform: "translate(22.135 -9.258)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29121",
    "data-name": "Path 29121",
    d: "M28,117.08l-.105.014a.4.4,0,0,0-.215.311.68.68,0,0,0,.114.444.612.612,0,0,0,.355.277l.105-.014a.4.4,0,0,0,.217-.313A.725.725,0,0,0,28,117.08",
    transform: "translate(23.009 -29.796)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29122",
    "data-name": "Path 29122",
    d: "M21.872,118.008a.407.407,0,0,1,.073-.057.1.1,0,0,1-.085-.025l.265-.3c-.114-.236-.247-.293-.334-.311-.188-.039-.341.1-.48.247l-.037.272a1.022,1.022,0,0,0,.066.133c.14.213.318.227.531.039",
    transform: "translate(14.76 -29.5)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29123",
    "data-name": "Path 29123",
    d: "M24.921,127.895a.475.475,0,0,0,.048.46.331.331,0,0,0,.309.174c.1-.016.222-.1.272-.41l-.153-.309c-.307-.133-.43,0-.476.085",
    transform: "translate(19.405 -16.05)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29124",
    "data-name": "Path 29124",
    d: "M24.087,132.275a2.126,2.126,0,0,1-.011-.236l-.066-.3-.11-.231-.178-.231a1.014,1.014,0,0,0-1.206-.082,1.106,1.106,0,0,0-.382,1.082l.066.286.206.311.222.181.114.039,0,.014a.9.9,0,0,0,.97.213l.16-.126.11-.146.085-.2a1.742,1.742,0,0,0,.025-.572",
    transform: "translate(15.846 -11.823)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29125",
    "data-name": "Path 29125",
    d: "M28,137.372l.153-.053.215-.215.135-.339a1.136,1.136,0,0,0,.021-.4l-.2-.391-.375-.307a.759.759,0,0,0-.464-.018,2.736,2.736,0,0,0-.043-.339l-.169-.259.025.011.4-.018a.587.587,0,0,0,.307-.222l.092-.389-.071-.483a1.23,1.23,0,0,0-.2-.384l0,0a1.241,1.241,0,0,0-.121-1.265l-.281-.261-.277-.1-.43.135a.931.931,0,0,0-.236.7,1.425,1.425,0,0,0,.341.794c-.016.016-.027.011-.043.03l-.1.4.071.485a1.461,1.461,0,0,0,.085.2l-.14-.053a.635.635,0,0,0-.375.048l-.227.318-.087.46a1.371,1.371,0,0,0,.08.6l.153.238.16.16.215.13a.628.628,0,0,0,.494-.066l0,.041.1.291.178.24a1.269,1.269,0,0,0-.876-.355.958.958,0,0,0-.618.245,1.452,1.452,0,0,0-.357,1.37l.007.055.236.359c0,.037.007.076.011.112a2.072,2.072,0,0,0,.709,1.313,1.284,1.284,0,0,0,1.293.231l.428-.442.11-.256.059-.725a2.079,2.079,0,0,0-.458-.949,1.794,1.794,0,0,0-.464-.869l.22.144Z",
    transform: "translate(20.2 -10.666)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29126",
    "data-name": "Path 29126",
    d: "M26.531,123.163l.3.176.384.059a1.119,1.119,0,0,0,.757-.6l.911.805.158-.3.08-.309a2.2,2.2,0,0,0-.121-.906l-.943.394a2.492,2.492,0,0,0,.023-.97l-.3-.54-.352-.286,0-.057-.22-.24a.323.323,0,0,1-.114-.027.26.26,0,0,0-.259,0v0a.775.775,0,0,0-.4.023,2.118,2.118,0,0,0-.92-1.5l-.68.206-.24.48-.046.54.025.252a1.962,1.962,0,0,0,.435,1.169,1.064,1.064,0,0,0,.789.38l0,.025.423.881Z",
    transform: "translate(18.974 -27.466)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29127",
    "data-name": "Path 29127",
    d: "M26.536,135.765l.3-.949a1.25,1.25,0,0,1-.025.483v0a1.907,1.907,0,0,0,.2-.922,1.927,1.927,0,0,0,.35-1.268l-.9-.142.9.135-.1-.5-.08-.2-.261-.414a1.652,1.652,0,0,0-1.478-.471l-.563.348-.165.254-.144.805a3.032,3.032,0,0,0,.178.609,1.668,1.668,0,0,0-.35,1.258l.378.8.243.243.32.121-.023.064.183,0,.261.1-.011-.1.519-.009Z",
    transform: "translate(18.763 -11.218)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29128",
    "data-name": "Path 29128",
    d: "M22.754,127.068a1.165,1.165,0,0,0,.3.3l.291.069.238-.041.24-.162a1.141,1.141,0,0,0,.156-.782,1.5,1.5,0,0,0-.812-1.142l-.268-.009-.21.076-.2.183a1.082,1.082,0,0,0-.119.666l.121.375Z",
    transform: "translate(16.145 -19.214)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29129",
    "data-name": "Path 29129",
    d: "M19.368,133.221l.21.364.22.19.3.114.256-.009.291-.172.162-.247.078-.391-.032-.215-.16-.359-.275-.3a.916.916,0,0,0-.345-.185l-.352.1-.3.355a1.2,1.2,0,0,0-.062.707l.007.053",
    transform: "translate(12.269 -10.573)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29130",
    "data-name": "Path 29130",
    d: "M36.744,155.308l-.011.023-.146-.412a.354.354,0,0,0-.378.082.59.59,0,0,0-.03.545l.169.174c.16.043.359.014.4-.412",
    transform: "translate(33.895 18.914)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29131",
    "data-name": "Path 29131",
    d: "M30.014,140.375l.48-.048a1.142,1.142,0,0,0,.162-.133l.037.016a.911.911,0,0,0,.444-.025.942.942,0,0,1,.174-.032l.2-.1.14-.144.112-.222a1.743,1.743,0,0,0-.361-1.373,1.037,1.037,0,0,0-.5-.332l-.21-.609c-.512-.739-1.087-.789-1.483-.609a1.949,1.949,0,0,0-.787-1.08l-.551-.117-.222.039-.453.286c-.016.018-.018.046-.03.066l-.048-.041-.247-.091-.3.007a.822.822,0,0,0-.446.652,1.279,1.279,0,0,0,.2.856,1.032,1.032,0,0,0,.86.506,1.874,1.874,0,0,0,.336.48c.023.025.053.03.076.053l-.071.2a.354.354,0,0,1,.13.119l.519.3.423-.007.073-.05a2.408,2.408,0,0,0,.3.663,2.79,2.79,0,0,0,.364.448l.462.27Z",
    transform: "translate(21.005 -5.988)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29132",
    "data-name": "Path 29132",
    d: "M16.7,122.233l.124-.231,0-.032a.614.614,0,0,0-.371-.515l-.222.3a.649.649,0,0,0,.185.428.3.3,0,0,0,.288.053",
    transform: "translate(8.256 -24.162)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29133",
    "data-name": "Path 29133",
    d: "M21.582,118.96a.242.242,0,0,1,.057.027.447.447,0,0,0,.384.064l.124-.243-.059-.423-.206-.236a.43.43,0,0,0-.426.14.537.537,0,0,0-.055.467Z",
    transform: "translate(14.89 -28.425)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29134",
    "data-name": "Path 29134",
    d: "M23.8,129.588l.21-.38-.73-.51-.034-.062-.025.018-.034-.025-.018.046-.018,0-.32.961a.811.811,0,0,0,.97-.043",
    transform: "translate(16.756 -14.922)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29135",
    "data-name": "Path 29135",
    d: "M24.754,130.256c.073.014.256.014.357-.272l-.016-.041.181.112.4.062a.731.731,0,0,0,.545-.876l-.178-.391-.023-.027a.923.923,0,0,0-.606-.563l-.318.078-.208.181-.151.311c-.009.039-.007.151-.011.233l-.188-.034-.261.22a1.356,1.356,0,0,0,.188.773.454.454,0,0,0,.293.236",
    transform: "translate(18.614 -15.399)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29136",
    "data-name": "Path 29136",
    d: "M33.7,133.7a2.018,2.018,0,0,0-.32-1.1,2.312,2.312,0,0,0-.2-.263l-.3-.169-.263-.032-.19.039-.355.27-.048.128a1,1,0,0,0-.361.835,1.4,1.4,0,0,0-.121-.419l-.162-.105.2-.336a2.114,2.114,0,0,0-.009-.51,1.794,1.794,0,0,0-.746-1.265.322.322,0,0,0-.018-.261.279.279,0,0,0-.245-.156l-.169.24a.181.181,0,0,1,.08-.126.522.522,0,0,0-.217-.03c-.027-.018-.03-.053-.062-.069l-.222.089c-.023.057-.048.073-.112.108v.007l-.259.025-.531.86a1.476,1.476,0,0,0-.634-.334l.039.732c-.025-.007-.043-.027-.069-.032l.018.3a1.262,1.262,0,0,0-.259.117l.3.654v0l.092.194-.119-.027-.361.1-.394.533a1.652,1.652,0,0,0,.135,1.105,1.6,1.6,0,0,0,.931.8l.325-.023a2,2,0,0,0,.032.387l.3.524.526.375-.1.076a1.032,1.032,0,0,0-.048,1.174l.19.21.332.22.252.018-.011.087.092.268c.007.039.025.069.032.108a1.676,1.676,0,0,0-.162.371l.213,1.071a1.2,1.2,0,0,0-.176-.027,1.16,1.16,0,0,0-1.041.762l-.11.572.011.249-.236.114a.8.8,0,0,0-.142.769.439.439,0,0,1,.064-.229l-.027.249c-.007.016-.009.037-.018.055a.306.306,0,0,0-.016.041.566.566,0,0,0-.24.339l.041.222.025.027a1.388,1.388,0,0,0,.114.65l.27-.162a1.281,1.281,0,0,0,.133.172,1.4,1.4,0,0,0,.062.133l-.032.265a.532.532,0,0,0,.178.007,1.2,1.2,0,0,0,.213.238.617.617,0,0,0,.661.1.6.6,0,0,0,.286-.352.641.641,0,0,0,.732-.309l.037-.508-.14-.394-.034-.055a1.375,1.375,0,0,0,.391-.313l.114-.318.247.375a1.038,1.038,0,0,0,1.439-.6,2.084,2.084,0,0,0,.075-1.478l-.213-.284a1.522,1.522,0,0,0,.323-1.208l-.037-.181-.071-.226a1.36,1.36,0,0,0-1.467-.979.826.826,0,0,0-.181.1l-.092-.275-.112-.119.149.027.361-.08.254-.185.215-.339a1.726,1.726,0,0,0-.3-1.462,1.5,1.5,0,0,0,0-1.178,2.019,2.019,0,0,0-.236-.41.9.9,0,0,0,.885.121l-.011-.057.153-.007-.1.309.124.2c.085.128.188.263.327.284a.261.261,0,0,0,.256-.126l.011-.229a.724.724,0,0,0-.531-.451l-.018,0,.233-.183Zm-2.034-.259,0-.021.007.023Z",
    transform: "translate(22.958 -12.699)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29137",
    "data-name": "Path 29137",
    d: "M16.965,128.27a.664.664,0,0,0,.023.561l.233.117.1-.034.059-.021a.317.317,0,0,1,.071.016l.11.027.208-.243-.059-.428-.32-.194A.509.509,0,0,1,17.32,128c-.055-.062-.16-.176-.286-.137-.087.025-.14.11-.158.249l.188.309a.267.267,0,0,1-.1-.151",
    transform: "translate(9.095 -15.92)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29138",
    "data-name": "Path 29138",
    d: "M29.148,135.2a1.268,1.268,0,0,0-1.448-.6l-.474.492-.108.291-.027.279a.944.944,0,0,1,.082-.2l0,1.153.188.393.476.364a.517.517,0,0,0,.009.066.544.544,0,0,0,.4.412.324.324,0,0,0,.366-.19c.007-.014,0-.044.009-.059a1.3,1.3,0,0,0,1.009-.927l-.256-1.185Z",
    transform: "translate(22.251 -7.307)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29139",
    "data-name": "Path 29139",
    d: "M35.35,154.053a.351.351,0,0,0-.279.2l.007.224a.305.305,0,0,0,.352.206c.034-.011.057-.053.085-.085v.2l.078.291.618-.146.1.194.263.233a.681.681,0,0,0,.371.135l.162-.057.119-.087.105-.149a.87.87,0,0,0-.027-.689.883.883,0,0,0-.62-.492l-.039.011A.775.775,0,0,0,36,153.9a.766.766,0,0,0-.432.448.381.381,0,0,0,0-.126Z",
    transform: "translate(32.528 17.602)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29140",
    "data-name": "Path 29140",
    d: "M28.373,142.255a1.154,1.154,0,0,0,.723-.922,2.056,2.056,0,0,0-.078-1.025c-.284-.846-1.009-1.336-1.647-1.114l-.11.316-.313.412a.472.472,0,0,0-.011.055.2.2,0,0,0-.105-.032l-.126.21v.016l-.286-.021-.222.08-.43.416-.08.181-.265.165a1.674,1.674,0,0,0-.229,1.256l0,.009a2.065,2.065,0,0,0,.2,1.437l.721.567.124.021v.023a.985.985,0,0,0,1.311-.323,1.384,1.384,0,0,0,.659-1.691v-.142Z",
    transform: "translate(19.742 -1.384)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29141",
    "data-name": "Path 29141",
    d: "M23.372,133.382l.071.059c.183.144.659.41,1.128-.268l.082-.382-.043-.35-.3-.492a.738.738,0,0,0-.675-.162.882.882,0,0,0-.531.629l0,.352.075.291Z",
    transform: "translate(17.111 -10.889)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29142",
    "data-name": "Path 29142",
    d: "M17.286,126.8a.507.507,0,0,0-.089.391.6.6,0,0,0,.229.368.458.458,0,0,0,.382.105l.085-.059a.5.5,0,0,0,.089-.394.58.58,0,0,0-.611-.469Z",
    transform: "translate(9.497 -17.363)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29143",
    "data-name": "Path 29143",
    d: "M29.052,140.569a1.678,1.678,0,0,0,.117-.462l-.025-.38-.016-.034a2.372,2.372,0,0,0,.025-.373l-.137-.563-.105-.217-.343-.437-.3-.236-.682-.169-.263.066-.076.071c0-.032.021-.037.021-.071l-.24-.345-.345-.1-.279.194a1.345,1.345,0,0,0,.144.787.532.532,0,0,0,.2.22,2.307,2.307,0,0,0-.025,1.361l.323.394a1.589,1.589,0,0,0,.911.821.869.869,0,0,0,1.1-.531",
    transform: "translate(21.342 -3.726)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29144",
    "data-name": "Path 29144",
    d: "M23.8,129.833a.4.4,0,0,0,.3-.378.538.538,0,0,0-.3-.526l-.22.055a.607.607,0,0,0,.048.787Z",
    transform: "translate(17.581 -14.536)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29145",
    "data-name": "Path 29145",
    d: "M23.285,121.252,23,121.243a.28.28,0,0,0-.142.092l.039.352a.55.55,0,0,0,.1.192l.277,0a.3.3,0,0,0,.142-.1l-.043-.35a.5.5,0,0,0-.089-.176",
    transform: "translate(16.798 -24.435)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29146",
    "data-name": "Path 29146",
    d: "M23.061,128.34l-.048.281a.827.827,0,0,1,.032.1c.046.135.137.419.368.41l.142-.119a.8.8,0,0,0-.085-.618.269.269,0,0,0-.41-.053",
    transform: "translate(16.998 -15.386)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29147",
    "data-name": "Path 29147",
    d: "M18.4,127.868a.369.369,0,0,0-.419-.284l-.133.256a.665.665,0,0,0,.206.407l.2.039a.341.341,0,0,0,.149-.419",
    transform: "translate(10.352 -16.275)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29148",
    "data-name": "Path 29148",
    d: "M22.107,134.248l.137-.252a.463.463,0,0,0-.3-.373l-.062-.037a1.069,1.069,0,0,1-.059-.1c-.064-.124-.21-.4-.467-.332l-.112.256c.19.8.622.869.863.84",
    transform: "translate(14.72 -9.113)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29149",
    "data-name": "Path 29149",
    d: "M33.338,153.079l-.082.151a.605.605,0,0,0,.208.5.29.29,0,0,0,.448-.069l.009-.263c-.247-.478-.508-.368-.583-.323",
    transform: "translate(30.189 16.51)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29150",
    "data-name": "Path 29150",
    d: "M18.931,131.995l-.046.22c.073.124.146.249.217.375l.066.027a.241.241,0,0,0,.158-.018l.062-.3a.512.512,0,0,0-.037-.2l-.263-.121a.256.256,0,0,0-.158.018",
    transform: "translate(11.682 -10.617)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29151",
    "data-name": "Path 29151",
    d: "M27.86,145.691l.21-.087.089-.247-.073-.279a.543.543,0,0,0-.435-.117.225.225,0,0,0-.172.146.394.394,0,0,0,.087.373l.089,0a.553.553,0,0,0,.2.206",
    transform: "translate(22.731 6.1)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29152",
    "data-name": "Path 29152",
    d: "M35.012,157.846a.937.937,0,0,0-.316-.515l-.208-.03a.408.408,0,0,0-.078.076c-.117.156-.076.348.121.574a.636.636,0,0,1,.062.08.149.149,0,0,1,0-.094l.291.279a.421.421,0,0,0,.133-.371",
    transform: "translate(31.594 22.005)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29153",
    "data-name": "Path 29153",
    d: "M25.787,91.237l-.027.121.032.458.119.336.231.348a1.034,1.034,0,0,0,1.354.2l.51.06.254-.14a.661.661,0,0,0-.243.16l-.064.146a1.623,1.623,0,0,0-.414.162l-.247.458-.5-.613-.215-.1-.5.021-.011-.011-.869-.027-.3.149-.545.762-.025.114a2.4,2.4,0,0,0,.021,1,.764.764,0,0,0-.188.151l-.142.515.064.618a1.77,1.77,0,0,0,.3.707l.254.215.238.114.286.05a.845.845,0,0,0,.313-.14,1.08,1.08,0,0,0,1.178-.16,1.511,1.511,0,0,0,.549-.7,1.47,1.47,0,0,0,.725-1.068l-.046-.1a.982.982,0,0,0,.739.146.913.913,0,0,0,.41-.3.814.814,0,0,0,.782.124l.053.041.1.837.169.382.638.73a1.314,1.314,0,0,0,1.3.066,1.584,1.584,0,0,0,.741-1.139l.023-.188a.682.682,0,0,0,.611-.146.833.833,0,0,0,.78-.538l.055-.181.041-.265,0-.3a2.714,2.714,0,0,0-.339-.847.948.948,0,0,0,.531.153.931.931,0,0,0,.789-.586,1.484,1.484,0,0,0,.114-.506,2.2,2.2,0,0,0,.121.345,1.854,1.854,0,0,0,1.5.961l.6-.158.215-.158.076-.105a2.191,2.191,0,0,0,.549.824l.361.233.291.11a1.4,1.4,0,0,0,.89-.13,1.038,1.038,0,0,0,.629-.188c-1.444-1.343-2.977-2.727-4.578-4.125l-.4.329a2.278,2.278,0,0,0-.373.746,2.03,2.03,0,0,0-.03.529,1.476,1.476,0,0,0-.833-.794l-.293-.011a.921.921,0,0,0-.647.545,1.065,1.065,0,0,0-.108.451l-.043.439.064.368.03.064-.108-.076-.222-.089-.268-.03a.847.847,0,0,0-.24.08l-.053-.027.261-.391.183-.11.158-.181.055-.835a1.612,1.612,0,0,0-.263-.364l.259,0a.809.809,0,0,0,.476-.8.446.446,0,0,1-.169.227l.13-.268c.014-.014.021-.032.037-.046a.94.94,0,0,0,.261.551l.126.066a.394.394,0,0,0,.407-.14.686.686,0,0,0,.1-.522.979.979,0,0,0-.27-.54l-.128-.066a.417.417,0,0,0-.174.014,1.7,1.7,0,0,0-.238-1.03c0-.03-.011-.06-.014-.089-1.295-1.089-2.627-2.178-3.99-3.253l-.064.039-.08.16-.172.043a1.538,1.538,0,0,0-.867,1.052.345.345,0,0,0-.007.048,1.2,1.2,0,0,0-.345-.208l-.595.361-.149.529.043.538.064.24a1.819,1.819,0,0,0,.588,1.041.9.9,0,0,0,.814.188l.183-.174.327.373a1.866,1.866,0,0,0,.4.13A2.536,2.536,0,0,0,31.225,91.5l.112-.009a1.327,1.327,0,0,0,.087.5,1.258,1.258,0,0,0,.654.686l-.108,0a.8.8,0,0,0-.375.263l-.133.517.011.082-.345.011a1.279,1.279,0,0,0-.293-.6,1.574,1.574,0,0,0-.169-1.3l-.517-.341-.437-.009-.3.1a1.222,1.222,0,0,0-.524.332l-.2.284-.018.286a.853.853,0,0,0-.206.254,1.027,1.027,0,0,0-.146.025l.039-.023.32-.57a1.446,1.446,0,0,0-.13-1.11,1.3,1.3,0,0,0-.105-.119l0-.165-.018-.027a.454.454,0,0,0-.526-.231l0,.023a.883.883,0,0,0-.167-.069l-.3.059-.222.135-.046.059a.861.861,0,0,0-1.38.691",
    transform: "translate(18.288 -71.236)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29154",
    "data-name": "Path 29154",
    d: "M41.3,92.361l-.025.062.007.325-.1.874.174.453A2.043,2.043,0,0,0,42.9,95.6l.16-.053a1.266,1.266,0,0,0,.2.158l.014.211.112.309.394.622A1.848,1.848,0,0,0,45,97.463a2.29,2.29,0,0,0,.487,2.125l1.105.323,0,.027a1,1,0,0,0,.167,0l-.254.673.057.54.364.645-.112.078.027.046a1.729,1.729,0,0,0-.421.666.607.607,0,0,0-.059.071,1.856,1.856,0,0,0-.911,1.162l.462.3v0l-.464-.3-.075.606.018.265.156.613a2.258,2.258,0,0,0,.593.785,1.55,1.55,0,0,0-.149.208,2.061,2.061,0,0,0,.178,1.892l-.153-.043-.391.1a.717.717,0,0,0-.275.291l0,.041a2.438,2.438,0,0,0-.375-1.144c-.03-.046-.062-.089-.094-.13l-.025-.217a2.5,2.5,0,0,0-.316-.384l-.124-.391-.778-.959a1.346,1.346,0,0,0-1.862.149l-.032-.037a1.642,1.642,0,0,0-.162-.313l-.389-.247.05-.05.4-.933c.014-.075.025-.169.039-.259l.007,0,.256.027.286-.1.2-.183.149-.359.011-.343-.119-.419-.121-.183-.291-.226-.352-.1a.677.677,0,0,0-.355.057l-.062.092c-.014-.021-.023-.043-.037-.064.076-.041.172-.055.213-.135a.7.7,0,0,0,.025-.5l-.025-.092-.162-.128a1.156,1.156,0,0,0,.5-.362l.1-.275.094.085a2.75,2.75,0,0,0,.519,1l-.032.064-.053.174-.023.222a1.731,1.731,0,0,0,.558,1.144.88.88,0,0,0,.929.185l.288-.288.08-.213a1.328,1.328,0,0,0,0-.593l.146-.009.268-.233a2.035,2.035,0,0,0,.416-1.823c.009,0,.018,0,.027,0l.151-.2a1.168,1.168,0,0,0-.334-.9l-.073-.089-.213.14c-.055-.089-.1-.178-.167-.27l-.657-.439a2.292,2.292,0,0,0-1.21-1.753h-.151l-.032-.124-.076-.121-.027-.526-.2-.467-.5.256-.11-.032a1.759,1.759,0,0,0-.469-.14l-.469-.451-.069.114c-.007-.053,0-.119-.014-.169a2.217,2.217,0,0,0-.039-1.462l.025-.009a.461.461,0,0,0-.009-.526.322.322,0,0,0-.38-.142,2.207,2.207,0,0,0-.364-.407,1.648,1.648,0,0,0-.853-.366,1.064,1.064,0,0,0-.652.153l-.366-.414.087-.11a2.049,2.049,0,0,0-.906-.673L36.681,91a2.655,2.655,0,0,0-.771-1.064,1.417,1.417,0,0,0-2.313.439l.108.423a1.75,1.75,0,0,0-.448-.416l-.336-.064a.883.883,0,0,0-.755.716,1.891,1.891,0,0,0,.105,1.144,2.913,2.913,0,0,0-.222-.471l-.082-.327-.629-.963a1.48,1.48,0,0,0-1.565-.378,1.783,1.783,0,0,0-.9,1.492l.078.771.105.316.021.034c.009.055.011.126.021.174l.037.172h.007l.1.373.183.416.124.135-.034,0-.524.286-.307.332-.217.657a1.182,1.182,0,0,0-1.444.451l-.208.609-.027.284.071.707a3.269,3.269,0,0,0,.883,1.775l.018.089c-.018.027-.037.037-.05.069l-.046.533.172.606a1.461,1.461,0,0,0,.343.467l.458.144.467-.117a.971.971,0,0,0,.318-.32,1.333,1.333,0,0,0,.579-.078,1.661,1.661,0,0,0,.851-1.254l.048-.348-.172-.89-.011-.021.6-.348.21-.378.066-.961.078.009a2.539,2.539,0,0,0-.464-1.487,1.491,1.491,0,0,0,1.071-.631,1.549,1.549,0,0,0,.11.547l.373.416.524.213a.805.805,0,0,0,.458-.069l.279-.4.094-.595a1.575,1.575,0,0,0-.121-.581l-.368-.4-.515-.206a.761.761,0,0,0-.478.08l-.252.373.089-.581-.114-.483-.094-.233.016,0a1.55,1.55,0,0,0,.345.535.837.837,0,0,0,1.2.048l.153-.5a2.583,2.583,0,0,0,.5.595,2.307,2.307,0,0,0,.517,1.066,2.154,2.154,0,0,0,0,.384l.194.547.158.284.366.448a1.26,1.26,0,0,0,1.821-.082,2.606,2.606,0,0,0,.3.492.9.9,0,0,0-.6.586l-.206.073-.023-.053a1.574,1.574,0,0,0-.654.414,2.069,2.069,0,0,0-.261,2.139l.819.876.339.133a1.886,1.886,0,0,0,.647.236,2.4,2.4,0,0,0,.577.746,1.6,1.6,0,0,0,.606.316l-.284.286-.133.272-.14.744.025.323a2.233,2.233,0,0,0,1.778,2.215l.023-.007c0,.014-.018.027-.021.041l-.3.4a1.536,1.536,0,0,0,.371.867,1.152,1.152,0,0,0,.824.419.776.776,0,0,0,.178-.039l.007.105a2.513,2.513,0,0,0,.364.856,1.373,1.373,0,0,0-.146.137l-.112.375v.366a1.708,1.708,0,0,0,.226.7l-.439.645.059.547.6,1.16.368.3.144.025a2.746,2.746,0,0,0,.256.259l0,.034.213.259a.288.288,0,0,0,.222-.053l.394.265.082.009-.059.494a.221.221,0,0,1,.114.062l.153.041.041.357.018.043a1.394,1.394,0,0,0,.522.979l.233.059a.859.859,0,0,0-.737.453l-.069.275,0,.254.059.3a.531.531,0,0,0,.043.071,1.811,1.811,0,0,0-.329.565l.114,1.3.05.1c0,.03.007.059.007.089a1.95,1.95,0,0,0-.162.842,1.829,1.829,0,0,0-.59.851l.238,1.437.3.453.094.053c-.011.025-.048.03-.057.057a.8.8,0,0,0,.05.54l.041.092.146.078-.117.124-.156.394-.027.375.094.455a1.665,1.665,0,0,0,.355.487l-.439.421a2.3,2.3,0,0,0-.188,1.345c-.069,0-.151-.018-.208-.014l0,.071-.647.043-.316.224-.467.956.007.43a2.548,2.548,0,0,0,.762,1.624.457.457,0,0,0,.023.059l.144.08.1.055a2.165,2.165,0,0,0,1.1.378l.208-.094a.36.36,0,0,0-.089.19l.108.3a.327.327,0,0,1,.11.167l.364.055.124-.27-.146-.394a.491.491,0,0,0-.323-.121l.213-.1a.98.98,0,0,0,.158.1l.215-.018a1.7,1.7,0,0,0,.1.782,1.6,1.6,0,0,0,.213.387l-.176.087a.755.755,0,0,0-.361,0l-.35.334-.19.574,0,.043-.2-.3-.016-.094a.141.141,0,0,1-.041,0l-.034-.05-.041.039-.021-.016-.3.307a1.459,1.459,0,0,0-.423-.4l-.435-.055-.137.053-.332-.263-.336-.105h-.252l-.506.245-.023.039c0-.048.016-.073.014-.124l-.208-.595-.318-.38-.375.474-.05.009a1.505,1.505,0,0,0-.119-.7.346.346,0,0,0,.053-.14l-.066-.256a.3.3,0,0,0-.426-.1.312.312,0,0,0-.1.178,1.332,1.332,0,0,0-.172-.149l-.538-.037-.188.112-.256.384a1.27,1.27,0,0,0-.018.421l-.105.551a1.3,1.3,0,0,0,.629.638.9.9,0,0,0,.323.062l.092.238.27.364.281.213.371.119a1.124,1.124,0,0,0,.256-.053l.025.247.135.357a1.786,1.786,0,0,0,.169.263,1.952,1.952,0,0,0-.046.3l.554,1.277-.016.014c.021.041.046.059.069.1l-.567.368-.156.265,0,0a.8.8,0,0,0-.24-.494l-.378.082c-.021.059-.039.119-.062.176a1.451,1.451,0,0,0,.071,1.348,1.313,1.313,0,0,0-.629-.133,1.1,1.1,0,0,0-.97.945l-.048.361.046.178-.188.293.105.286a.825.825,0,0,0,.345.474.337.337,0,0,0,.288-.014,1.431,1.431,0,0,0,.97.627l.261-.03.2-.089.053-.046a.361.361,0,0,0,.165.055l.181-.245-.021-.24a2.032,2.032,0,0,0,.11-.311,1.94,1.94,0,0,1,.092-.268v0a1.921,1.921,0,0,0,.62.462l1-.142.05-.043a1.928,1.928,0,0,0-.387,1.277l-.041.018-.291.35a1.159,1.159,0,0,0-.053.412l-.153.528a1.566,1.566,0,0,0,.16.275l-.3.732a1.177,1.177,0,0,1,.032-.4,2.861,2.861,0,0,0-.174,1.343,3.294,3.294,0,0,0,.105.547l.476.8.275.256.764.334.238,0,.387.263,0,.016.2.428.35.35-.057.057.233.119.284.286.032-.121.659.336.448-.085.343-.366a.78.78,0,0,0,.254.149.166.166,0,0,0-.087.007l-.03.14a1.9,1.9,0,0,0-.819,1.446l-.3.14-.6.883a2.546,2.546,0,0,0,.478,1.933l.014.057c-.011.041-.023.087-.032.13a2.739,2.739,0,0,0,.3,1.931,2.528,2.528,0,0,0,.435.54.372.372,0,0,0-.174.387l.208.265a.7.7,0,0,0,.68-.183,1.834,1.834,0,0,0,.382.112l.318-.087c-.165-12.341-.027-33.074,1.922-54.711-1.551-1.709-4.207-4.56-7.646-7.948",
    transform: "translate(21.849 -65.283)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29155",
    "data-name": "Path 29155",
    d: "M32.3,90.289a.713.713,0,0,0,.334-.025c-.339-.323-.684-.65-1.034-.977l-.018.5a1.082,1.082,0,0,0,.718.506",
    transform: "translate(28.033 -65.591)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29156",
    "data-name": "Path 29156",
    d: "M50.194,132.7l-.291-.009a.643.643,0,0,0-.389.631.341.341,0,0,1,.137-.178l-.108.213a.927.927,0,0,0-.252,1,1.558,1.558,0,0,0-.572.945,2.855,2.855,0,0,0-.059.414l.009.046-.43.142-.174.185-.222.437-.046.215.014.549a1.949,1.949,0,0,0,.439.885l.032-.027.144.169.089.188.229.233.336.151.345-.014.277-.149.165-.222,0-.021a1.515,1.515,0,0,0,.288-1.281.907.907,0,0,0,.412.032.972.972,0,0,0-.1.224l.048.6.05.11a.856.856,0,0,0-.794.73l.233.524a1.756,1.756,0,0,0,.066.352l.226.288a1.838,1.838,0,0,0-.412.654,2.382,2.382,0,0,0-.128.828,1.311,1.311,0,0,0-1.178.043.909.909,0,0,0-.469.261,1.313,1.313,0,0,0-.316.963l-.021.064-.014.316.037.2-.178-.128a.917.917,0,0,0-1.373.153l-.011.9.311.526.307.307a1.608,1.608,0,0,0,.545.332l.162.382.048.071-.588-.121v.041l-.247.023-.8.606-.087.188-.245-.24-.407-.142-.924.256c-.05-.05-.117-.085-.174-.133a1.593,1.593,0,0,0,.009-.277,1.943,1.943,0,0,0-.291-.753L44,145.32l.011.057a1.068,1.068,0,0,0,.7-.339l.261-.748-.007-.348-.128-.469.034-.011A2.947,2.947,0,0,0,44.7,143a.824.824,0,0,0,.149-.055l.05-.082.078.124a.432.432,0,0,0,.169.112l.233-.21a.454.454,0,0,0,.066-.206l-.162-.24c.435-.021.762-.325.968-1.02l-.053-.046.011-.021.167-.085.169-.229.185-.794-.014-.1a2.162,2.162,0,0,0-.462-1.078l-.1-.341-.169-.226-.32-.249a1.027,1.027,0,0,0,.279-.206.9.9,0,0,0,.2.135l.462-.021.458-.329a1.091,1.091,0,0,0,.226-.506l-.089-.567-.32-.577a1.308,1.308,0,0,0-.437-.361l-.48.021-.048.032-.085-.133-.027-.018-.043-.108.043-.007c-.011-.046-.043-.149-.078-.249a1.317,1.317,0,0,0,.787-1.114,2.359,2.359,0,0,0,.043-.364,1.332,1.332,0,0,0,.11.124l.48.126.446-.142a1.1,1.1,0,0,0,.146.162.64.64,0,0,0,1.048-.178l-.556-.442c.021-.03.05-.037.05-.1l-.275-.22.009-.2-.217-.666a1.384,1.384,0,0,0-.378-.46l-.462-.108-.3.1.027-.025.21-.458.055-.446-.057-.394-.192-.444a1.268,1.268,0,0,0-1.041-.57.877.877,0,0,0-.753.545,1.4,1.4,0,0,0-.117.581l-.348-.071-.2.087-.167.208a1.92,1.92,0,0,0-.368-.355l.018-.007a.422.422,0,0,0,.261-.464l-.3-.224a.355.355,0,0,0-.261.247.5.5,0,0,0,.046.281c-.057-.03-.105-.092-.165-.112a1.3,1.3,0,0,0-.483-.055l.025-.016a.715.715,0,0,0,.382-.064l.245-.556a1.792,1.792,0,0,0-.076-.3l.023-.423a.892.892,0,0,0-.572-.416.59.59,0,0,0-.51.153,1.16,1.16,0,0,0-.117,1.439l.588.185a1.1,1.1,0,0,0-.794.252,1.028,1.028,0,0,0-.7.121l.018.055-.391.247-.156.249-.142.766.059.428.341.737.213.233.62.325a1.347,1.347,0,0,0,.169-.009,2.111,2.111,0,0,0,.828.664,1.266,1.266,0,0,0,.885,0,2.666,2.666,0,0,0,.268.252,1.006,1.006,0,0,0-.391.258,1.536,1.536,0,0,0-.21,1.59l.226.247a1.439,1.439,0,0,0-.043.224l.368.931.256.272.464.172a1.032,1.032,0,0,0-.366.43,1.531,1.531,0,0,0-.19.7,2.046,2.046,0,0,0-.08-.194,1.654,1.654,0,0,0-1.194-1.485l-.224-.128-.533.057-.032-.4-.153-.4-.339-.412-.259-.149c.016-.05.053-.082.064-.137l-.034-.622-.114-.3a1.326,1.326,0,0,0-1.167-.828l.016-.227.059.007a1.816,1.816,0,0,0-.959-1.679l-.455-.087-.185.027-.394.206-.231.245-.142.414a1.894,1.894,0,0,0-.611-.565l-.412-.062-.318.1-.311.284-.368.8-.053.467.066.4.2.442a1.337,1.337,0,0,0,1.117.567l.227.414.194.2.533.288a1.144,1.144,0,0,0,.771-.167c.023.018.041.043.064.062l.325.114h.094a1.5,1.5,0,0,0,.68.4l-.007.016.007.531.05.151a1.6,1.6,0,0,0,.419.606l-.439.135-.14.126-.325.023a1.419,1.419,0,0,0-.261.263l-.025-.027-.691-.332a1.445,1.445,0,0,0-.419.075,1.656,1.656,0,0,0-.652-1.471l-.732.08-.307.43h0l-.117.256c0,.023.011.039.014.059l-.027.085a1.728,1.728,0,0,0,.08,1.233,1.42,1.42,0,0,0,.81.723l.043-.014.124.7.2.332.124.144-.011.011a1.644,1.644,0,0,0,.647.551l-.025.041-.05.444a1.176,1.176,0,0,0,.11.446l.291.286.391.13a.577.577,0,0,0,.35-.082l.188-.309.041-.407a1.076,1.076,0,0,0,.895.165l-.259.32-.087.524.025.4a2.8,2.8,0,0,0,.055.384l-.082-.05a.959.959,0,0,0-.753.275,1.061,1.061,0,0,0-.478-.062,1.133,1.133,0,0,0-.888.769l-.018-.014-.226.178a.309.309,0,0,1-.018.069.665.665,0,0,0-.048.332.934.934,0,0,0,.023.144l.222.21.03,0,.069.19.144.259a1.551,1.551,0,0,0,.8.5l0,.4a1.22,1.22,0,0,0-.059.236l.124.474.117.16.3.2a.516.516,0,0,0,.254-.011l.352.057a.845.845,0,0,0,.21-.595,1.284,1.284,0,0,0-.254-.744,1.017,1.017,0,0,0-.261-.247,1.058,1.058,0,0,0,.453-.478c.032.007.057.025.092.032l.238-.064.174-.144a.863.863,0,0,0,.206-.483,1.544,1.544,0,0,0,.076.339l.265.352.286.22.014,0a.53.53,0,0,0-.19.016l-.243.172-.263.35a.969.969,0,0,0-.121.361l.05.336.112.263.21.259a.753.753,0,0,0,.416.124l-.1.332.089.936.165.3a1.894,1.894,0,0,0,.357.407l-.311.284a1.149,1.149,0,0,0-.57-.206l-.558.281-.018-.018a1.107,1.107,0,0,0-.108.1,1.673,1.673,0,0,0-.961-.542,1.365,1.365,0,0,0-1.423.867c-.016.034-.014.08-.027.119a.91.91,0,0,0-.487.08l-.421.529-.089.3-.03.588a2.462,2.462,0,0,0,.336.927,1.546,1.546,0,0,0,.451.446.626.626,0,0,0,.281.144,1.069,1.069,0,0,0,.254.039c.011,0,.023.009.037,0l0,0a.93.93,0,0,0,.622-.178l.043-.087.707.087.071-.023a1.136,1.136,0,0,0,.256.117,1.237,1.237,0,0,0,1.178-.421l.135-.114.059-.2.421-.092.21-.169.112-.174a1.078,1.078,0,0,0,.19.146.892.892,0,0,0,.27.08,1.136,1.136,0,0,0,.16.188l.119.069.172.066.014,0a1.747,1.747,0,0,0,.114,1.277l.8.593,0,.023a1.343,1.343,0,0,0,.352.135,1.19,1.19,0,0,0,.092.279l.293.284.334.117a2.868,2.868,0,0,0,.988,2.141l.421.1a1.519,1.519,0,0,0,.082.176l.009.014-.071-.016-.021.423h0l-.018.027a1.011,1.011,0,0,0-.993.261,1.254,1.254,0,0,0-.311.615c-.034-.032-.05-.078-.085-.108l-.693-.185-.27.066-.121.119a.866.866,0,0,0,.021-.124.946.946,0,0,1,.016-.119.1.1,0,0,1-.073.055l0-.206a.99.99,0,0,0,.3-.847,1.033,1.033,0,0,0-.4-.68c.023,0,.032.014.055.009l.38-.3.229-.547a1.543,1.543,0,0,0,0-.6l-.3-.506-.494-.366a.881.881,0,0,0-.517-.078l-.231.19a1.429,1.429,0,0,0,.021-.2,1.889,1.889,0,0,0-.75-1.256l-.11-.021a.853.853,0,0,0,.011-.533l-.021-.092-.275-.222a.39.39,0,0,0-.288.259.717.717,0,0,0,.043.5l.018.043-.307.135-.178.142a1.092,1.092,0,0,0-.243.494l.073.5a1.414,1.414,0,0,0-1.091-.778.8.8,0,0,0-.105,0l-.124-.1a1.024,1.024,0,0,0-1,.378,1.266,1.266,0,0,0-.22.453c-.021-.032-.025-.071-.048-.1a1.4,1.4,0,0,0-.97-.57,1.829,1.829,0,0,0-.68-1.286,1.521,1.521,0,0,0-.59-.281l.194-.027.236-.194.323-.776-.021-.339a1.725,1.725,0,0,0-1.721-1.6l-.087.048a.733.733,0,0,0-.782-.13l-.27.258-.112.323.4.256.039.078-.108.54.018.14a1.473,1.473,0,0,0-.284-.343.905.905,0,0,0-1.46.231v.021c-.055,0-.094-.032-.167,0l.021,0-.043.073c-.05-.034-.1-.073-.151-.1l-.2.039a.45.45,0,0,0-.057.1c-.071.194.011.373.243.533a.638.638,0,0,1,.076.057.165.165,0,0,1-.027-.091l.313.172.078.272.151.22-.03.023a1.678,1.678,0,0,0,.538.661l.378.108.309-.037.327-.194.128-.22a1.494,1.494,0,0,0,.105-.753l.105.169.394.391a1.38,1.38,0,0,0,.471.183,1.088,1.088,0,0,0-.563.769l-.174-.119-.112-.075-.009.027-.183-.064-.746.128-.133.119-.16.437-.073-.135c-.032-.1-.064-.19-.094-.277L32.9,153.6l-.249-.16-.663-.092a1.415,1.415,0,0,0-.4.256,1.187,1.187,0,0,0-1.08-.284l-.474.5-.1.3.021.373-.059-.018.069.206.016.3.073-.023.188.588.277.284.826.247a.646.646,0,0,1-.375.016l0,0a1.722,1.722,0,0,0,.476.13,1.613,1.613,0,0,0,.892.92l.721-.14a.712.712,0,0,0,.112.291l.124.048-.039.071a1.47,1.47,0,0,0-.11.444,1,1,0,0,0-.126.117,1.656,1.656,0,0,0-.293.982l-.313.846a.953.953,0,0,1,.016-.318,2.241,2.241,0,0,0-.1,1.055,2.478,2.478,0,0,0,.094.421l.14.22a1.116,1.116,0,0,0-.126-.025,1.044,1.044,0,0,0-1.133-.435l-.224.121-.345.54-.048.22,0,.256-.167-.016-.261.066a1.976,1.976,0,0,0-.2-.567l-.448-.407.021-.023.064-.952-.117-.375-.2-.245.714.126.252-.094.153-.165.025.05a1.209,1.209,0,0,0,.494-.634l0-.824-.108-.325-.249-.387.025-.027a2.044,2.044,0,0,0-.464-.538,1,1,0,0,0-1.38.025l0,.011a1.068,1.068,0,0,0-.563.034l-.037.014-.192.3c-.027.007-.053.016-.08.025a1.2,1.2,0,0,0-.748.92,1.986,1.986,0,0,0,.119,1.064l-.027.039a.982.982,0,0,0-.881.137l-.156.192-.1.2-.041.153a1.172,1.172,0,0,0-.4.556,1.764,1.764,0,0,0,.053,1.178l.59.65.291.121.753-.119a1.769,1.769,0,0,0,.256-.217c.046,0,.089.025.135.016l.206-.133-.1.5c.316,1.162.977,1.453,1.247,1.524l.281-.137.194.467-.117.375a1.5,1.5,0,0,0,.238.76,1.249,1.249,0,0,0,.243.272l.039-.018.231.348.361.165.188-.053-.016.03-.018.535-.1-.025a2.07,2.07,0,0,0,.124.849l-.039.252.037.32a1.01,1.01,0,0,0,.757.661c.016.018.025.041.043.059a1.208,1.208,0,0,0,1.133.339l.124-.059.146-.1a.858.858,0,0,0,.087-.112l.554.137,0,.021a.929.929,0,0,0,1.023-.62,1.5,1.5,0,0,0,.087-.48l.137-.268a.586.586,0,0,0-.194-.206,2.582,2.582,0,0,0-.1-.263l.007,0,.284-.316a.914.914,0,0,0,.114-.426l-.126-.428-.318-.41a.844.844,0,0,0-.368-.192l-.144.046-.046-.021a.721.721,0,0,0-.076.057l-.062.021-.279.313a1.071,1.071,0,0,0-.1.343.834.834,0,0,0-.76.181,1.673,1.673,0,0,0-.984-.863l-.506.231a1.41,1.41,0,0,0-.034-.732c.025-.011.048-.021.073-.034.016.034.032.071.053.108l.293.149a.621.621,0,0,0,.458-.382.762.762,0,0,0-.023-.474.408.408,0,0,0,.08.13l.208-.021a.213.213,0,0,0,.1-.08l0,0,.524.025.231-.114a1.467,1.467,0,0,0,.435-1.7,2.172,2.172,0,0,0-.215-.46l.2.078.183-.007.307.19a1.052,1.052,0,0,0,1.027-.384l0-.007a1.132,1.132,0,0,0,.57-.4c-.046.1-.043.252.119.458l-.009-.023.272.117a.433.433,0,0,0,.1-.343.476.476,0,0,0-.277-.327l-.144.032a1.472,1.472,0,0,0,.208-.43l-.137-1.016-.078-.137.018-.009a2.343,2.343,0,0,0-.247-.5l.327-.432.071-.357-.105-.757c.023-.011.048-.011.066-.032a.355.355,0,0,0,.073-.345.509.509,0,0,0-.373-.346l-.018.014c-.037-.078-.062-.144-.11-.229l.043-.039.254-.689c.014.011.025.032.037.041a1.092,1.092,0,0,0,.853.231,1.932,1.932,0,0,0,.5.961.988.988,0,0,0,1.05.3l-.066.293.149.394a.693.693,0,0,0,.38.1l-.011.018-.162.126-.05.1a1.506,1.506,0,0,0-.064.252l-.233.05.11.426a2.239,2.239,0,0,0,0,.3,1.991,1.991,0,0,0-.162-.178,1.236,1.236,0,0,0-1.062-.284,1.072,1.072,0,0,0-.728.7l.034.931.144.345.661.666a1.184,1.184,0,0,0,1.185.037l.176-.238.041.108a1.709,1.709,0,0,0,1.018.689,1.756,1.756,0,0,0-.089.647l-.069-.151-.169-.217a1.191,1.191,0,0,1,.092.215l-.748-.792-.343-.089-.814.371a2.021,2.021,0,0,0-.192.54l-.206-.128-.3.105-.082.105-.021-.027-.4-.339-.158-.076-.378-.085a1.03,1.03,0,0,0-.959.785,1.922,1.922,0,0,0,.261,1.574,1.448,1.448,0,0,0,.993.689.89.89,0,0,0,.581-.158l.073.1.7.421a1.065,1.065,0,0,0,.384-.055,1.082,1.082,0,0,0,.675-.847l.181-.016a1.007,1.007,0,0,0,.348-.059,2.088,2.088,0,0,0,.325,1.034l-.094.188-.03.325.2.86.053.085,0,0-.144-.13-.375-.066a.5.5,0,0,0-.117.078.421.421,0,0,0-.174-.247.393.393,0,0,0-.382.055l-.069.172a.486.486,0,0,0,.027.1.248.248,0,0,0,.373.149l.034-.011a.535.535,0,0,0-.057.108.938.938,0,0,0,0,.458,2.044,2.044,0,0,0-.119-.284l-.458-.307.014-.059-.014-.288a1.266,1.266,0,0,0-.94-1.084l-.014.048-.188-.119-.32-.011-.345.227a1.64,1.64,0,0,0-.181,1.046,3.233,3.233,0,0,0,.071.332l.2.325.126.108c-.007.016-.016.021-.023.039l0,.556a1.414,1.414,0,0,0-.19.876,1.97,1.97,0,0,0,.657,1.286l.112.073.03.348a2.288,2.288,0,0,0,1.524,1.7l.014-.071.622.151.343-.082.67-.583.213-.46.087-1.027-.094-.428-.512-.915a2.366,2.366,0,0,0-.824-.519,1,1,0,0,0-.094-.135.948.948,0,0,0-.243-.169,2.237,2.237,0,0,0-.087-.437c.021.059.025.114.05.176l.176.213.176.114.245.046.059-.016c.149-.05.485-.247.343-1l-.124-.226a1.709,1.709,0,0,0,.75.595l.229.249.231.1.556.034c.023-.007.062-.032.094-.046.034.069.069.137.1.194l.213.265.176.151a1.1,1.1,0,0,0,1,.181c.037-.011.053-.041.085-.055l-.1.329-.023.885a2.373,2.373,0,0,0,.345.782l-.112-.018-.277.128-.114.181-.105.055-.053.092a.679.679,0,0,1,.153-.137l-.341.542a1.025,1.025,0,0,1,.034-.14l-.174.307a.435.435,0,0,0-.3.3l.034.224a.744.744,0,0,0,.124.128.2.2,0,0,0,.153.053l.039.128-.162-.023-.3.105-.439.451-.1.261-.03.732a2.174,2.174,0,0,0,.545,1.007l.034.085.082.018a.653.653,0,0,0,.059.053c.046.034.1.041.149.071a.343.343,0,0,0,0,.1l.323.423.059.133a1.15,1.15,0,0,0,.387.291c.016.073.027.142.05.215a1.467,1.467,0,0,0-.469.364l.048-.144a.583.583,0,0,0-.018-.231l-.3-.188a.322.322,0,0,0-.188-.011l-.112.343a.577.577,0,0,0,.021.236l.3.183a.79.79,0,0,0,.112,0,2.007,2.007,0,0,0-.124.2,2.714,2.714,0,0,0-.208.863l.082.039-.11.771.112.485.128.2a.751.751,0,0,0-.444-.21l-.279.08-.172.185.252.332.062.378,0,.046c-.039,0-.071-.018-.11-.009l-.316.524.039.471-.117-.092-.636-.181-.252.046-.185.137.009-.149a1.082,1.082,0,0,0,.16-.387l-.149-.766-.087-.133-.27-.2,0-.009L39.525,180l.535-.05.128-.082a.867.867,0,0,0,.4.371H40.8l.16-.076.149-.172.1-.265.014-.252-.046-.215-.121-.236a1.026,1.026,0,0,0-.126-.108l0-.007,0-.009,0,0,.437-.311a1.788,1.788,0,0,0,.249-1.338,1.931,1.931,0,0,0-.238-.611,1.556,1.556,0,0,0,.194-.419l.039-.11-.009-.064a.21.21,0,0,0,.027-.1l-.05-.071-.03-.217-.185-.284-.366-.181a.826.826,0,0,0-.728.686l-.142-.025-.08.018a.677.677,0,0,0-.522.128,1.577,1.577,0,0,0-1.382.073l-.368.352-.126.2-.2.542a3.241,3.241,0,0,0-.023.361.982.982,0,0,0-.817-.117l-.112.323a.99.99,0,0,0-.206.227l-.11-.089-.2-.059-.243.039-.057.046a.705.705,0,0,0-.222.533,1.134,1.134,0,0,0,.275.716l.222.142.2.034.059-.016.22.3,0,.014.444.657.233.172.668.137.071-.023a.817.817,0,0,0,.192-.124l-.007.023-.069.1-.041.032c-.146.13-.446.519-.057,1.35l.261.27.169.078-.032.437.076.368.192.4a1.263,1.263,0,0,0,1.215.551,2.188,2.188,0,0,0,.345.421l.35.2.16.048.375.014a1.037,1.037,0,0,0,.524-.313c.023.009.043.03.069.039a.75.75,0,0,0,.716-.181l.14-.153.146-.508-.007-.229-.066-.215.007-.027a.8.8,0,0,0,.023-.249.61.61,0,0,0,.172-.105l.14-.357,0-.336-.121-.4.526.373.018,0,.08.773a4.017,4.017,0,0,0,.224.49,1.751,1.751,0,0,0-.085.366l.041.43.059.178.222.375a.947.947,0,0,0,.76.334.794.794,0,0,0,.611-.455l.062-.078a1.489,1.489,0,0,0,.8-.247l.247-.192.341-.682.069.222.208.272a.763.763,0,0,0,.217.135,1.48,1.48,0,0,0,.1.172l-.243.027-.133.069-.265.291-.041.1,0,.007a.547.547,0,0,0-.092.037l-.279.666-.014,0a1.279,1.279,0,0,0-.043.3,1.316,1.316,0,0,0-.476-.709l-.371-.105-.181.039a.907.907,0,0,0-.506,1.018l-.146.183-.309.046-.316-.144-.041.208.025.265.112.293.03.041.009.092a.581.581,0,0,0,.11.21h.222l.137.046a.542.542,0,0,0,.487-.455,1.008,1.008,0,0,0,.556.366l.167-.007.14-.041.146-.092a1.177,1.177,0,0,0,.281-.7,1.455,1.455,0,0,0,.146.291.9.9,0,0,0,.922.4l.165-.149a.685.685,0,0,0,.249-.144l.025-.034,0,0,.092.055.339-.034.188-.192.071-.407a1.873,1.873,0,0,0-.126-.286,1.424,1.424,0,0,0-.094-.885,1.131,1.131,0,0,0-.149-.217l.071-.011.222-.135c.014-.016.011-.037.023-.053l.082.142A2.213,2.213,0,0,0,48.508,186a2.186,2.186,0,0,0,1.453,1.313l.666-.025.254-.11.458-.435.19-.018.2-.114a1.083,1.083,0,0,0,0-1.249,2.555,2.555,0,0,0-.7-1.741,1.022,1.022,0,0,0,.545-.149,2.262,2.262,0,0,0,.2.371l.329.3.156.076.064.009-.032.03-.082.167a1.024,1.024,0,0,0,.265,1.039l-.121.348.009.259.069.2-.032,0a1.513,1.513,0,0,0,.066.261l-.009,0-.032.437-.009-.014a.87.87,0,0,0-.92.117,1.153,1.153,0,0,0-.339.851.759.759,0,0,0-.144,0l-.153.092-.178.217-.066.3.318.13-.323-.108.135.4.206.21.332.087.085-.037-.05.133-.247.03-.272.162-.245.332a2.019,2.019,0,0,0-.041.224l-.158.229-.121.357c-.011.039-.025.1-.037.144l-.208.13v-.007l-.069-.181a1.556,1.556,0,0,0-.055-.215v-.126l-.066-.153c.014.048.018.1.027.151a1.576,1.576,0,0,0-.114-.192l-.222-.572a1.22,1.22,0,0,1,.121.167l-.268-.625-.076-.075.014-.009a.586.586,0,0,0,.178-.419l-.256-.361-.574-.11-.259.2a1.245,1.245,0,0,0-.009.2l-.4-.142a1.608,1.608,0,0,0-.3.126.871.871,0,0,0-.725-.217l-.231.126-.08.076c-.057.009-.119-.007-.167.021a1.688,1.688,0,0,0-.226-.531c0-.043.03-.066.03-.117l-.268-.426-.272-.105-.133,0a.962.962,0,0,0-.22-.167.812.812,0,0,0-.881.082l-.076.085-.085.124a1.267,1.267,0,0,0,.025,1.146.834.834,0,0,0-.064.185l0,.018-.057.007a.435.435,0,0,0-.094.341.367.367,0,0,0,.137.226.345.345,0,0,0,.14.062l.069.261a.668.668,0,0,0,.547.142.642.642,0,0,0,.307-.19.963.963,0,0,0,.615.153l.4-.423.011.021-.021.014a1.017,1.017,0,0,0,.178.32,1.389,1.389,0,0,0,.22.327.935.935,0,0,0,0,.114l-.153.371.08.6.146.213a.9.9,0,0,0-.2-.119.727.727,0,0,0-.6.1.473.473,0,0,0-.048-.048l-.08-.018.014-.1.011,0a1.338,1.338,0,0,0-.364-.927l-.455-.22-.2,0-.327.108a1.044,1.044,0,0,0-.361.476,1.3,1.3,0,0,0,.43,1.419l.025.007-.1.137-.05.458a1.535,1.535,0,0,0,.332.913,1.024,1.024,0,0,0,.883.412l.57-.151.188-.268c.034-.025.046-.066.076-.094.039.055.08.1.121.153a.619.619,0,0,0,.016.1.272.272,0,0,0,.371.206.309.309,0,0,1,.066-.011.1.1,0,0,1-.055-.046l0,0a.6.6,0,0,0,.069.018.693.693,0,0,0,0,.545l.156.13a.434.434,0,0,0,.144-.018.209.209,0,0,0,.137-.194c.11,0,.174-.108.169-.24l-.05-.185a.625.625,0,0,0,.009-.128l.114-.151a.327.327,0,0,0,.05.011,1.531,1.531,0,0,0,.712,1.325l.172.034a1.348,1.348,0,0,0,.14.3,1.2,1.2,0,0,0,.343.327l-.176.286a.308.308,0,0,0-.49.14.4.4,0,0,0,.039.272l.121.064a.226.226,0,0,1-.043-.085l.087.071-.032.053.041.309.1.183-.11-.062-.643.059a.509.509,0,0,1,.265-.128h0a.9.9,0,0,0-.583.121,1.05,1.05,0,0,0-.275-.034.83.83,0,0,0,.076-.133,1.229,1.229,0,0,0-.348-1.3l-.329-.105-.016-.037a.692.692,0,0,0-.938.243c-.014-.032-.018-.066-.032-.1l-.6-.709-.307-.192L44.1,194.5c-.08.011-.174.032-.265.053q2.087,3.346,4.045,6.308c.32.174.641.352.961.526a1.193,1.193,0,0,0,.011-.35,1.384,1.384,0,0,0-.178-.51.157.157,0,0,0,.071-.043l-.08-.3a.08.08,0,0,1,.037.037l-.011-.05a.331.331,0,0,0-.135-.231.179.179,0,0,0-.208.034l-.025.167a.713.713,0,0,0-.769-.044l-.046-.265-.229-.348.059-.05c-.011-.018-.043-.059-.064-.089,0-.03.018-.057.021-.087l.247.181.213.05.492-.133a1.336,1.336,0,0,0,.233-.325.814.814,0,0,0,.831-.11l.149-.341a.819.819,0,0,0,.7.224.832.832,0,0,0,.551.018,2.517,2.517,0,0,0,.066.259,2.242,2.242,0,0,0,.3.549l-.22.412a1.583,1.583,0,0,0,.167,1.087l.1.1H51.1a.617.617,0,0,0-.2.11v-.3l-.359-.769c-.668-.522-1.112-.268-1.272-.133l-.21.785.064.275.011.039a.546.546,0,0,0-.252.181l.389.213c1.2.652,2.393,1.293,3.592,1.94a1.46,1.46,0,0,0-.059-1.025,1.356,1.356,0,0,0-.686-.686,1.329,1.329,0,0,0-.167-.277c.018,0,.032-.021.048-.027v.027a.78.78,0,0,0,.558-.062l.094-.135c.027.03.039.062.071.092l.167.08a.493.493,0,0,0,.366-.057l.048.055-.009.009a.957.957,0,0,0,1.018.476l.316-.22.105-.151,0-.007.11-.142.059-.14.057-.419-.009-.094a1.167,1.167,0,0,0-.034-.135.675.675,0,0,0,.224.05l-.007.135.085.309.076.114a1.246,1.246,0,0,0-.08.641l.048.238.133.215c.037.135.078.265.126.394l-.144-.149c-.341-.034-.343.346-.343.487l0,.076.188.256a.3.3,0,0,0,.3-.112.535.535,0,0,0,.066-.4l0-.03c.023.055.05.1.073.156.034-.194.069-.389.105-.583-1.1-23.945-3.631-52.295-5.324-69.726ZM32,163.976l-.133-.064.014-.176a1.4,1.4,0,0,0,.135.126l0,0,.043.252a1.092,1.092,0,0,0-.055-.14",
    transform: "translate(20.4 -15.189)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29157",
    "data-name": "Path 29157",
    d: "M44.791,148.867l.842.133a1.091,1.091,0,0,0,.247-.14,1.71,1.71,0,0,0,.272.224l.233-.021a.441.441,0,0,0,.039-.06c-.872-8.9-1.485-14.544-1.485-14.544s-.19-4.2-.288-11.149l-.112,0a1.62,1.62,0,0,0-.853,1.183,2.365,2.365,0,0,0-.023.423,1.586,1.586,0,0,0-1.7-.879l.046,1.279-.508-1.128-.1.057.275-.378.03.011a2.086,2.086,0,0,0,.183-1.64l-.718-.984,0-.023a1.455,1.455,0,0,0-1.409-.487l-.538.464-.025-.265a3.19,3.19,0,0,0-.172-.332l.062-.8a3.291,3.291,0,0,0,.746.428l.245-.069.016.007.046-.025.5-.142a1.124,1.124,0,0,0,.46.288l.453-.1.151-.151a.427.427,0,0,0,.114.137l.2.023a.47.47,0,0,0,.206-.313.535.535,0,0,0-.153-.462.952.952,0,0,0,.034-.158l-.146-.554-.394-.544a1.176,1.176,0,0,0-.142-.112,1.535,1.535,0,0,0,.615-.853,2.347,2.347,0,0,0-.167-1.64A1.649,1.649,0,0,0,39.8,114.56l-.135.174-.126-.016a1.564,1.564,0,0,0-1,1.133l-.034.57.037.329.023.082a1.394,1.394,0,0,0-.208.21l-.007-.05-.4-.826-.238-.268-.673-.416a1.424,1.424,0,0,0-1.435.414,2.094,2.094,0,0,0-.435,1.6l.057.389.4.814.238.27.007,0-.03.254.092.81.119.311c.027.071.069.108.1.172l-.071.156-.055.313.069.837.069.2a2.286,2.286,0,0,0,1.064,1.256,1.5,1.5,0,0,0,.307.105l-.181.185.021.224.021.037a2.012,2.012,0,0,0-.112.826,3.229,3.229,0,0,0,.229.9l.078-.018.224.641.016.19.126.336.059.078a1.391,1.391,0,0,0-.08.2,2.808,2.808,0,0,0,.286,1.958,1.934,1.934,0,0,0,.153.181.9.9,0,0,0-.437.043l-.24.21-.149.247-.023.082a.8.8,0,0,0-.375.027,1.324,1.324,0,0,0-.6,1.361l.016.137.185.439.22.275.32.229a.959.959,0,0,0,1.167-.359.383.383,0,0,0,.162-.158l.275-.117c.144,1.389.842,1.8,1.16,1.888l.055-.686.2-.05.169.242-.014.043c0,.066,0,.2.007.311a1.445,1.445,0,0,0-.24.27l.032.254a1.589,1.589,0,0,0-.167.277.612.612,0,0,0-.384.181.633.633,0,0,0-.16.277l-.112.286-.018.268.011.053-.069-.082-.149-.119-.192-.092a.7.7,0,0,0-.192-.011l-.055-.055-.41-.128a.557.557,0,0,0-.325.078L38,134.81l0-.188-.1-.259-.7-.78-.126-.135-.021.03-.217-.153-.064-.009.041-.224-.011-.032a.559.559,0,0,0-.5-.4l-.133.4c.023.053.053.114.085.172l-.419-.062-.2.089-.277.384a1.563,1.563,0,0,0-.316-.5,1.665,1.665,0,0,0-.243-.178c-.011-.043,0-.071-.018-.117l-.114.027-.016,0,.13-.032-.288-.6-.162-.222-.4-.361.021-.194.108-.217.018-.094.4-.3.188-.06a1.624,1.624,0,0,0,.428-.659,1.718,1.718,0,0,0,.343,0l.757-.691.153-.426,0-.245.14.037a.363.363,0,0,0,.1-.075c.149-.16.117-.384-.089-.666a.672.672,0,0,1-.066-.1.155.155,0,0,1,0,.108l-.087-.1,0-.048a4.507,4.507,0,0,0-.245-.929l.231-.252.007-.407.309-.547-.03-.023.075-.261-.119-1.219-.121-.249-.75-.7-.135-.119-.016.032-.224-.128-.721-.018a1.969,1.969,0,0,0-1.338-1.274l.156-.65-.05-.547-.394-.968-.261-.316-.782-.471a.625.625,0,0,0-.066,0l-.007,0-.009,0a1.49,1.49,0,0,0-1.318.48,1.839,1.839,0,0,0-.265.5l-.162-.117-.382-.108a.908.908,0,0,0-.755.6,1.541,1.541,0,0,0,.03,1.11,1.763,1.763,0,0,0,.634.814.818.818,0,0,0-.375-.037l-.35.261-.185.341-.076.48a1.618,1.618,0,0,0,.114.558,1.437,1.437,0,0,0,.579.686l.364.082.494-.121a1.158,1.158,0,0,0,.352-1.414l-.345-.421-.037-.023a1.2,1.2,0,0,0-.471-.364.927.927,0,0,0,.863.094l.014-.018.025.041a1.792,1.792,0,0,0,1.176.627,2.994,2.994,0,0,0,.025,2.2,3.79,3.79,0,0,0,.35.684l.522.512.2.114-.011.023.078.318a.6.6,0,0,0,.227.174l-.073.5a1.432,1.432,0,0,0-.458.284,2.176,2.176,0,0,0-.332,2.464,1.655,1.655,0,0,0,.124.194,1.064,1.064,0,0,0-.105.231,1.526,1.526,0,0,0,.1.9c-.158.062-.3.13-.442.2l-.316.421-.293-.007-.366.259-.2.275a1.706,1.706,0,0,0-.3.643l-.048.4.183.508a1.117,1.117,0,0,0-.43.643l.021.444.117.38.245.389a.766.766,0,0,0,.9.162.436.436,0,0,1-.277-.082l.284.023a1.2,1.2,0,0,0,.277.1,2.369,2.369,0,0,0,.069.24l.243.291-.009.11a1.187,1.187,0,0,0,.334.707l.281.14.243.014.263-.105.073-.078a.744.744,0,0,0,.076,0l0,.057.19-.082.034-.011.14,0a2.082,2.082,0,0,0-.506,2.35,2.614,2.614,0,0,0,.188.355,1.672,1.672,0,0,0-.865,1.128,1.168,1.168,0,0,0-.256.657l-.135.071-.176.311-.041.579a1.141,1.141,0,0,0,.419.787.679.679,0,0,0,.721.082l.178-.178.105-.2,0-.027.265.268.021.007a.925.925,0,0,0-.039.725.872.872,0,0,0,.725.558,2.492,2.492,0,0,0,.112,1.483,2.187,2.187,0,0,0,1.1,1.226,1.32,1.32,0,0,0,.666.1.822.822,0,0,0,.391.84l.227-.021a.688.688,0,0,0,.2-.691.672.672,0,0,0-.227-.373l.371-.609.577.142.4-.188.316-.567,0-.387.082-.156,0-.011a1.592,1.592,0,0,0,.309.412l.27.178.215.085a1.174,1.174,0,0,0,1.062-.357,1.406,1.406,0,0,0,.341-1.13c-.007-.062-.039-.11-.05-.169a1.962,1.962,0,0,0,.5.407,1.372,1.372,0,0,0,1.332.011l.11-.185a1.318,1.318,0,0,0,0,.286l0,.039.121.192.128.451.126.162a1.855,1.855,0,0,0,.394,1.007l.293.146.007.1.151.394.636.8Z",
    transform: "translate(24.226 -33.179)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29158",
    "data-name": "Path 29158",
    d: "M32.3,153.911l.043-.309a.658.658,0,0,0,.146-.506l-.348-.334c-.053.011-.108.025-.165.034a.9.9,0,0,0-.885.945c1.087,1.833,2.144,3.59,3.178,5.29l.014-.009.114-.03.158-.108.146-.185a.98.98,0,0,0,.05-.236l.016-.03.039.025.581.062,0-.023.128-.023.419-.382.048-.133-.025-.606-.007-.105-.018,0-.039-.16-.073-.112v-.039a.35.35,0,0,0-.05-.153l-.092-.023-.16-.24v0l0-.046a2.66,2.66,0,0,0-.043-.48.846.846,0,0,0,.284,0l.432-.437.076-.258.016-.14.014,0a1.5,1.5,0,0,0-.339-1.293l-.368-.247-.181-.048v.007l-.176-.057-.142,0-.341.112-.059.05a.977.977,0,0,0-.265.41l-.03.089,0,0-.014.053-.165-.1c-.046-.018-.092-.027-.137-.041a.265.265,0,0,0,.039-.13.48.48,0,0,0-.208-.384l-.094.016-.037-.135c-.2-.158-.307-.1-.355-.055a.312.312,0,0,0-.037.318.279.279,0,0,0,.194.185.214.214,0,0,0,.053-.011.281.281,0,0,0,.039.112,1.332,1.332,0,0,0-.835.2,1.944,1.944,0,0,0-.542.581l.062.085-.094.13a1.3,1.3,0,0,0-.082-.622L32,154.121l-.041-.032a.282.282,0,0,0,.343-.178",
    transform: "translate(27.4 16.159)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29159",
    "data-name": "Path 29159",
    d: "M33.772,156.448l-.21-.165-.448-.087a1.261,1.261,0,0,0-.407-.567l-.027-.021-.144-.014q.861,1.414,1.7,2.764l.158.023a.465.465,0,0,0,.142-.059.725.725,0,0,0,.194.162l.323-.121a.814.814,0,0,0,.153-.7.53.53,0,0,0-.316-.329l-.176.24-.053-.114-.016-.021a.672.672,0,0,0-.442-.41l-.092.023-.023-.039.011.041-.027.007-.188-.368a.746.746,0,0,1,.075.085Z",
    transform: "translate(29.261 19.807)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29160",
    "data-name": "Path 29160",
    d: "M34.409,155.575l-.162-.261a.631.631,0,0,0-.776.105l-.08.059.169.5.247.075a.473.473,0,0,0,.485-.057.538.538,0,0,0,.117-.423",
    transform: "translate(30.364 19.335)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29161",
    "data-name": "Path 29161",
    d: "M27.659,130.554l-.169-.165a.263.263,0,0,0-.316.114.627.627,0,0,0,.24.748.22.22,0,0,0,.24-.034l.032-.165a.113.113,0,0,1-.071.055l.13-.341Z",
    transform: "translate(22.296 -12.672)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29162",
    "data-name": "Path 29162",
    d: "M35.364,129.4a.392.392,0,0,0-.334.236.484.484,0,0,0,.011.352.824.824,0,0,0,.348.4.37.37,0,0,0,.334.044l.092-.323-.208-.533Z",
    transform: "translate(32.439 -13.931)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29163",
    "data-name": "Path 29163",
    d: "M26.37,104.976a.577.577,0,0,0,.018.755.261.261,0,0,0,.245.073l.076-.13a.1.1,0,0,1-.082.018l.222-.245-.023-.22-.117-.215a.281.281,0,0,0-.339-.037",
    transform: "translate(21.152 -45.438)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29164",
    "data-name": "Path 29164",
    d: "M28.033,119.392l.007-.087-.206-.313a.359.359,0,0,0-.355.105.608.608,0,0,0-.1.455c0,.046.009.094.018.144l.2.231c.4.066.421-.371.43-.535",
    transform: "translate(22.617 -27.345)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29165",
    "data-name": "Path 29165",
    d: "M34.443,95.685c-.162-.043-.3.064-.339.3l.126.309a.9.9,0,0,1,.082.064c.112.092.343.281.512.073l.037-.233c-.032-.128-.2-.455-.419-.515",
    transform: "translate(31.283 -57.363)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29166",
    "data-name": "Path 29166",
    d: "M30.279,100.2l.172-.133a.5.5,0,0,0-.133-.524.293.293,0,0,0-.478.089l.05.357c.153.158.277.224.389.21",
    transform: "translate(25.791 -52.494)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29167",
    "data-name": "Path 29167",
    d: "M27.463,114.051a.292.292,0,0,0,.156-.105l-.043-.366a.593.593,0,0,0-.1-.2l-.307,0a.3.3,0,0,0-.142.092l.032.375a.623.623,0,0,0,.1.2Z",
    transform: "translate(22.164 -34.567)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29168",
    "data-name": "Path 29168",
    d: "M27.018,103.36l.041-.35a.541.541,0,0,0-.057-.22l-.3-.108a.278.278,0,0,0-.162.032l-.055.355a.57.57,0,0,0,.05.217l.307.114a.284.284,0,0,0,.178-.041",
    transform: "translate(21.467 -48.34)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29169",
    "data-name": "Path 29169",
    d: "M29.8,88.854c-.185.041-.284.247-.368.455l.043.291a.9.9,0,0,0,.1.105c.188.156.355.094.5-.185a.687.687,0,0,1,.05-.089.09.09,0,0,1-.085.011l.158-.414c-.172-.188-.311-.192-.394-.174",
    transform: "translate(25.26 -66.158)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29170",
    "data-name": "Path 29170",
    d: "M29.169,105.2a.5.5,0,0,0,.064-.352.618.618,0,0,0-.316-.4l-.247.069-.087.176.08.348.236.2Z",
    transform: "translate(24.172 -46.074)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29171",
    "data-name": "Path 29171",
    d: "M23.453,96.46l-.183-.108a.265.265,0,0,0-.259.2.581.581,0,0,0,.364.652.216.216,0,0,0,.208-.105l-.007-.167a.123.123,0,0,1-.05.073l.046-.368Z",
    transform: "translate(16.977 -56.492)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29172",
    "data-name": "Path 29172",
    d: "M29.561,93.856l.236-.05.064-.1.037-.06a.3.3,0,0,1,.062-.032l.1-.048.05-.371-.243-.361-.339.034a.3.3,0,0,1-.089-.016.232.232,0,0,0-.286.066.371.371,0,0,0-.009.341l.288.162a.192.192,0,0,1-.146-.075.714.714,0,0,0,.275.512",
    transform: "translate(24.849 -61.031)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29173",
    "data-name": "Path 29173",
    d: "M32.971,107.81l.2.039a.441.441,0,0,0,.227-.286.554.554,0,0,0-.22-.59l-.279.128-.016.066.169.094-.19-.016a.537.537,0,0,0,.112.565",
    transform: "translate(29.634 -42.813)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29174",
    "data-name": "Path 29174",
    d: "M26.3,85.267l.034-.069-.094-.362a.4.4,0,0,0-.371-.085.449.449,0,0,0-.24.334c-.011.041-.021.082-.03.13l.117.291c.359.247.522-.108.583-.24",
    transform: "translate(20.324 -71.453)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29175",
    "data-name": "Path 29175",
    d: "M29.941,93.1l.039.238a.351.351,0,0,0,.307.194c.217-.014.357-.391.236-.631a.35.35,0,0,0-.206-.183l-.114.071a.14.14,0,0,1,.082.025l-.291.092Z",
    transform: "translate(25.921 -61.167)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29176",
    "data-name": "Path 29176",
    d: "M28,95.536c.38-.03.332-.462.313-.627l-.007-.085-.24-.259a.35.35,0,0,0-.309.188.638.638,0,0,0-.021.469,1.269,1.269,0,0,0,.041.135Z",
    transform: "translate(23.041 -58.792)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29177",
    "data-name": "Path 29177",
    d: "M32.475,90.13l-.206-.2.108.144c.021.014.064.034.1.053",
    transform: "translate(28.919 -64.759)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29178",
    "data-name": "Path 29178",
    d: "M25.793,85.863l-.032-.165a.139.139,0,0,1-.037.085l-.011-.375-.14-.151-.19-.064a.3.3,0,0,0-.213.261c-.03.252.231.588.442.561a.231.231,0,0,0,.181-.151",
    transform: "translate(19.774 -70.864)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29179",
    "data-name": "Path 29179",
    d: "M26.941,133.469l-.1-.162a.211.211,0,0,0-.261-.014.454.454,0,0,0,.034.588.2.2,0,0,0,.19.048l.055-.105a.085.085,0,0,1-.064.016l.165-.2Z",
    transform: "translate(21.478 -8.966)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29180",
    "data-name": "Path 29180",
    d: "M31.876,129.138l-.181.24a.547.547,0,0,0,.151.348.238.238,0,0,0,.233.043l.1-.188,0-.025a.5.5,0,0,0-.3-.419",
    transform: "translate(28.18 -14.267)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29181",
    "data-name": "Path 29181",
    d: "M33.737,156.45a.328.328,0,0,0,.046-.162l-.167-.229a.328.328,0,0,0-.137-.078l-.169.176a.34.34,0,0,0-.046.144l.167.243a.331.331,0,0,0,.133.08Z",
    transform: "translate(30.2 20.305)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29182",
    "data-name": "Path 29182",
    d: "M30.922,137.915l-.121.213a.4.4,0,0,0-.011.151l.194.185a.244.244,0,0,0,.133.034l.119-.211a.363.363,0,0,0,.014-.156l-.2-.181a.261.261,0,0,0-.13-.037",
    transform: "translate(27.01 -2.963)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29183",
    "data-name": "Path 29183",
    d: "M38.671,161.323l-.144.014-.007,0-.027.009-.508.053-.085.142-.055.016c.519.281,1.036.558,1.556.837l-.018-.252a1.478,1.478,0,0,0-.712-.814",
    transform: "translate(36.101 27.185)",
    fill: "#ea9e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29184",
    "data-name": "Path 29184",
    d: "M32.337,148.334c-.025-.057-.073-.162-.174-.185a.185.185,0,0,0-.185.105l.023.236c.053.091.151.258.288.265a.171.171,0,0,0,.172-.124l-.142-.277a.067.067,0,0,1,.041.025l-.023-.046",
    transform: "translate(28.545 10.214)",
    fill: "#ea9e7c"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2321",
    "data-name": "Rectangle 2321",
    width: 146.701,
    height: 228.995,
    transform: "translate(80.674 329.688)",
    fill: "#ea9e7c"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29185",
    "data-name": "Path 29185",
    d: "M19.11,43.385h0a3.549,3.549,0,0,1-3.549-3.549V19.558a3.549,3.549,0,0,1,7.1,0V39.836a3.549,3.549,0,0,1-3.549,3.549",
    transform: "translate(20.041 20.622)",
    fill: "#0d1a38"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29186",
    "data-name": "Path 29186",
    d: "M19.11,56.811h0a3.549,3.549,0,0,1-3.549-3.549V32.985a3.549,3.549,0,1,1,7.1,0V53.262a3.549,3.549,0,0,1-3.549,3.549",
    transform: "translate(20.041 37.911)",
    fill: "#0d1a38"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29187",
    "data-name": "Path 29187",
    d: "M184.9,367.658H36.4a19.194,19.194,0,0,1-19.193-19.193V19.193A19.194,19.194,0,0,1,36.4,0H184.9A19.194,19.194,0,0,1,204.1,19.193V348.465A19.194,19.194,0,0,1,184.9,367.658",
    transform: "translate(22.16)",
    fill: "#0d1a38"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10331",
    "data-name": "Group 10331",
    transform: "translate(47.444 19.619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10330",
    "data-name": "Group 10330",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2323",
    "data-name": "Rectangle 2323",
    width: 170.735,
    height: 307.783,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10354",
    "data-name": "Group 10354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10353",
    "data-name": "Group 10353",
    clipPath: "url(#clip-path)"
  }, _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29189",
    "data-name": "Path 29189",
    d: "M100.3,12.922a326.75,326.75,0,0,1-.355,49.4c-2.576,30.091-9.5,57.548-20.58,81.61a185.585,185.585,0,0,1-41.75,58.278h9.779a192.975,192.975,0,0,0,38.174-55.42c11.412-24.783,18.539-53,21.181-83.886a333.542,333.542,0,0,0,.364-50.361c-2.258.206-4.535.323-6.813.382",
    transform: "translate(48.443 16.15)",
    fill: "#fff"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29190",
    "data-name": "Path 29190",
    d: "M104.327,13.17a327.1,327.1,0,0,1,.4,50.348c-2.167,30.091-8.712,57.612-19.454,81.8A185.585,185.585,0,0,1,44.741,203.73h9.625A192.991,192.991,0,0,0,91.558,147.98c11.062-24.943,17.786-53.263,19.992-84.177a334.3,334.3,0,0,0-.531-52.446,45.9,45.9,0,0,1-6.692,1.812",
    transform: "translate(57.622 14.628)",
    fill: "#fff"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29191",
    "data-name": "Path 29191",
    d: "M136.734,117.081H124.67L108.858,103.74a7.091,7.091,0,0,0-4.569-1.67h-38.5a7.035,7.035,0,0,0-5.008,2.075L47.849,117.081H41.674a8.155,8.155,0,0,0-8.145,8.147v7.96a6.781,6.781,0,0,0,6.775,6.775H50.16a11.35,11.35,0,0,0,22.577,0h33.037a11.348,11.348,0,0,0,22.575,0h8.385a7.83,7.83,0,0,0,7.822-7.82V124.9a7.83,7.83,0,0,0-7.822-7.82m-100.1,16.107v-7.96a5.05,5.05,0,0,1,5.043-5.045h7.459l13.844-13.846a3.966,3.966,0,0,1,2.816-1.167H85.3v31.692H72.622a11.336,11.336,0,0,0-22.348,0H40.3a3.678,3.678,0,0,1-3.672-3.674m24.817,13.846a8.248,8.248,0,1,1,8.248-8.248,8.257,8.257,0,0,1-8.248,8.248m55.614,0a8.248,8.248,0,1,1,8.01-10.172h-.24a10.447,10.447,0,0,1,.243,3.1h.14a8.252,8.252,0,0,1-8.152,7.072m24.391-14.892a4.725,4.725,0,0,1-4.72,4.72h-8.5a11.335,11.335,0,0,0-22.346,0H88.4V105.17h15.885a3.98,3.98,0,0,1,2.567.94l16.679,14.073h13.2a4.723,4.723,0,0,1,4.72,4.718Z",
    transform: "translate(43.182 131.457)",
    fill: "#fbab41"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29192",
    "data-name": "Path 29192",
    d: "M178.388,97.945H25a1.289,1.289,0,0,1,0-2.578H178.388a1.289,1.289,0,0,1,0,2.578",
    transform: "translate(30.532 122.824)",
    fill: "#fff"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29193",
    "data-name": "Path 29193",
    d: "M21.383,22.7,187.218,57.536l.766,35.437V50.716L21.383,15.723Z",
    transform: "translate(27.54 20.249)",
    fill: "#fff"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29194",
    "data-name": "Path 29194",
    d: "M187.985,78.817,21.645,69.325l-.261-11.716V76.152l166.6,9.506Z",
    transform: "translate(27.541 74.194)",
    fill: "#fff"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29195",
    "data-name": "Path 29195",
    d: "M187.985,84.229v-7L21.384,39.94v7Z",
    transform: "translate(27.541 51.439)",
    fill: "#fff"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29196",
    "data-name": "Path 29196",
    d: "M187.985,89.746V82.892l-166.6,13.84v6.852Z",
    transform: "translate(27.541 106.757)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2324",
    "data-name": "Rectangle 2324",
    width: 53.647,
    height: 4.27,
    transform: "translate(76.249 99.766) rotate(-76.805)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2325",
    "data-name": "Rectangle 2325",
    width: 28.778,
    height: 4.269,
    transform: "translate(176.918 154.194) rotate(-76.232)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2326",
    "data-name": "Rectangle 2326",
    width: 53.531,
    height: 4.269,
    transform: "translate(76.101 202.058) rotate(-77.148)",
    fill: "#fff"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29197",
    "data-name": "Path 29197",
    d: "M129.965,19.133H44.694a9.379,9.379,0,1,1,0-18.759h85.27a9.379,9.379,0,1,1,0,18.759",
    transform: "translate(45.481 0.482)",
    fill: "#252d3f"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10334",
    "data-name": "Group 10334",
    transform: "translate(48.263 291.324)",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10333",
    "data-name": "Group 10333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10332",
    "data-name": "Group 10332",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29198",
    "data-name": "Path 29198",
    d: "M55.113,144.34A17.009,17.009,0,1,0,38.1,161.349,17.007,17.007,0,0,0,55.113,144.34",
    transform: "translate(-21.095 -127.332)",
    fill: "#fff"
  }))))), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29199",
    "data-name": "Path 29199",
    d: "M24.566,142.337l4.189-2.967,4.878,4.866L39.5,130.388l4.008,2.537-9.472,17.5Z",
    transform: "translate(31.639 167.927)",
    fill: "#fbab41"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10337",
    "data-name": "Group 10337",
    transform: "translate(92.62 291.324)",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10336",
    "data-name": "Group 10336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10335",
    "data-name": "Group 10335",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29200",
    "data-name": "Path 29200",
    d: "M74.5,144.34a17.008,17.008,0,1,0-17.008,17.008A17.007,17.007,0,0,0,74.5,144.34",
    transform: "translate(-40.481 -127.332)",
    fill: "#fff"
  }))))), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29201",
    "data-name": "Path 29201",
    d: "M43.954,142.337l4.189-2.967,4.878,4.866,5.866-13.849,4.008,2.537-9.472,17.5Z",
    transform: "translate(56.608 167.927)",
    fill: "#fbab41"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29202",
    "data-name": "Path 29202",
    d: "M43.954,142.337l4.189-2.967,4.878,4.866,5.866-13.849,4.008,2.537-9.472,17.5Z",
    transform: "translate(56.608 167.927)",
    fill: "#fbab41"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10340",
    "data-name": "Group 10340",
    transform: "translate(136.977 291.324)",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10339",
    "data-name": "Group 10339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10338",
    "data-name": "Group 10338",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29203",
    "data-name": "Path 29203",
    d: "M93.888,144.34a17.008,17.008,0,1,0-17.008,17.008A17.007,17.007,0,0,0,93.888,144.34",
    transform: "translate(-59.869 -127.332)",
    fill: "#fff"
  }))))), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29204",
    "data-name": "Path 29204",
    d: "M63.341,142.337l4.189-2.967,4.878,4.866,5.866-13.849,4.008,2.537-9.472,17.5Z",
    transform: "translate(81.578 167.927)",
    fill: "#fbab41"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10343",
    "data-name": "Group 10343",
    transform: "translate(181.335 291.324)",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10342",
    "data-name": "Group 10342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10341",
    "data-name": "Group 10341",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29205",
    "data-name": "Path 29205",
    d: "M113.275,144.34a17.008,17.008,0,1,0-17.008,17.008,17.007,17.007,0,0,0,17.008-17.008",
    transform: "translate(-79.258 -127.332)",
    fill: "#fff"
  }))))), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29206",
    "data-name": "Path 29206",
    d: "M82.729,142.337l4.189-2.967,4.878,4.866,5.866-13.849,4.006,2.537-9.47,17.5Z",
    transform: "translate(106.548 167.927)",
    fill: "#fbab41"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29207",
    "data-name": "Path 29207",
    d: "M38.058,188.709a1.861,1.861,0,0,1-1.869-1.563,1.814,1.814,0,0,1,1.631-2.009l36.794-4.514c1.668-2.983,7.639-13.606,13.954-24.151,15.441-25.782,17.752-26,19.28-26.146,1.666-.158,6.875-.053,15.235.13,9.419.208,24.778.545,28.473-.007.057-.19.121-.4.192-.641,5.594-18.573,5.695-23.474,5.425-24.748C148,103.034,41.853,80.578,40.753,80.344a1.887,1.887,0,0,1-1.187-.794,1.722,1.722,0,0,1-.243-1.359L52.183,25.11,37.38,22.7a1.8,1.8,0,0,1-1.542-2.071,1.885,1.885,0,0,1,2.178-1.464L54.787,21.9a1.909,1.909,0,0,1,1.254.773,1.728,1.728,0,0,1,.268,1.4L43.427,77.237c15.21,3.217,111.764,23.65,115.2,24.467a2.712,2.712,0,0,1,1.723,1.274c1.126,1.853,1.414,6.605-4.976,27.816-.22.732-.368,1.229-.421,1.421-.439,1.672-1.684,2.1-12.073,2.121-5.862.023-13.318-.151-19.889-.3-6.548-.144-12.751-.284-14.572-.162-3.379,2.043-18.3,26.5-30.928,49.24a1.892,1.892,0,0,1-1.428.943L38.3,188.693a1.78,1.78,0,0,1-.245.016",
    transform: "translate(46.121 24.655)",
    fill: "#fbab41"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29208",
    "data-name": "Path 29208",
    d: "M49.535,96.635a8.16,8.16,0,1,0-8.159,8.161,8.159,8.159,0,0,0,8.159-8.161",
    transform: "translate(42.778 113.949)",
    fill: "#02d7e6"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29209",
    "data-name": "Path 29209",
    d: "M39.659,11.023A6.863,6.863,0,0,0,32.8,17.887c0,3.791,5.763,15.141,6.864,15.141,1.162,0,6.864-11.35,6.864-15.141a6.863,6.863,0,0,0-6.864-6.864m0,10.332a3.468,3.468,0,1,1,3.468-3.468,3.469,3.469,0,0,1-3.468,3.468",
    transform: "translate(42.237 14.197)",
    fill: "#fc6da2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10346",
    "data-name": "Group 10346",
    transform: "translate(183.035 185.79)",
    opacity: 0.26,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10345",
    "data-name": "Group 10345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10344",
    "data-name": "Group 10344",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29210",
    "data-name": "Path 29210",
    d: "M81.741,129.553c4.972,10.845,19.072,13.9,31.5,6.832l9.955-5.665V81.205L95.235,97.115c-12.423,7.07-18.466,21.593-13.494,32.438",
    transform: "translate(-80.002 -81.205)",
    fill: "#fbab41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29211",
    "data-name": "Path 29211",
    d: "M116,155.289V104.184L98.715,115.912c-11.895,8.069-16.567,22.817-10.437,32.939,5.306,8.765,16.969,11.183,27.725,6.438",
    transform: "translate(-72.814 -51.61)",
    fill: "#fbab41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29212",
    "data-name": "Path 29212",
    d: "M112.087,174.688V127.951l-6.132,2.892c-12.826,6.047-20.136,20.23-16.324,31.676,3.052,9.163,12.3,13.789,22.456,12.169",
    transform: "translate(-68.898 -21)",
    fill: "#fbab41"
  }))))), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29213",
    "data-name": "Path 29213",
    d: "M147.906,119.738,113.5,133.5A22.987,22.987,0,0,1,96.422,90.822l34.408-13.766a22.986,22.986,0,1,1,17.077,42.683",
    transform: "translate(105.569 97.114)",
    fill: "#ea9e7c"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29214",
    "data-name": "Path 29214",
    d: "M146.015,140.8l-25.231,13a22.987,22.987,0,0,1-21.058-40.867l25.231-13A22.987,22.987,0,1,1,146.015,140.8",
    transform: "translate(112.388 125.413)",
    fill: "#ea9e7c"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29215",
    "data-name": "Path 29215",
    d: "M130.266,168.241l-10.579,3.144a22.986,22.986,0,1,1-13.094-44.067l10.579-3.144a22.986,22.986,0,1,1,13.094,44.067",
    transform: "translate(116.102 158.69)",
    fill: "#ea9e7c"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29216",
    "data-name": "Path 29216",
    d: "M111.175,118.172a18.4,18.4,0,0,1-7.141,1.517,18.667,18.667,0,0,1-12.9-32.241,18.334,18.334,0,0,1,6.216-3.828l.318.8a18.093,18.093,0,0,0-9.454,9.6,17.682,17.682,0,0,0,9.172,22.92,18.1,18.1,0,0,0,13.467.435Z",
    transform: "translate(109.866 107.695)",
    fill: "#ea8b60"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29217",
    "data-name": "Path 29217",
    d: "M116.465,139.928a18.377,18.377,0,0,1-7.141,1.517,18.67,18.67,0,0,1-12.9-32.241,18.356,18.356,0,0,1,6.216-3.828l.318.8a18.1,18.1,0,0,0-9.451,9.6,17.678,17.678,0,0,0,9.17,22.92,18.1,18.1,0,0,0,13.469.435Z",
    transform: "translate(116.682 135.715)",
    fill: "#ea8b60"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29218",
    "data-name": "Path 29218",
    d: "M117.142,159.495a17.185,17.185,0,0,1-6.692,1.421,17.5,17.5,0,0,1-12.092-30.221,17.217,17.217,0,0,1,5.825-3.587l.3.746a16.971,16.971,0,0,0-8.859,9.005,16.563,16.563,0,0,0,8.593,21.481,16.959,16.959,0,0,0,12.625.41Z",
    transform: "translate(119.641 163.702)",
    fill: "#ea8b60"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29219",
    "data-name": "Path 29219",
    d: "M207.8,304.985H28.381v-68.8a19.2,19.2,0,0,1,19.2-19.2H188.606a19.2,19.2,0,0,1,19.2,19.2Z",
    transform: "translate(36.552 279.459)",
    fill: "#005bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10349",
    "data-name": "Group 10349",
    transform: "translate(64.932 496.446)",
    opacity: 0.27,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10348",
    "data-name": "Group 10348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10347",
    "data-name": "Group 10347",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29220",
    "data-name": "Path 29220",
    d: "M84.951,223.195c0,.128,0,.256,0,.384a.383.383,0,0,1,.046.089.821.821,0,0,0,.462.476c.156-.032.313-.062.471-.091.146-.153.291-.309.437-.462,0-.05,0-.1,0-.151l.519-.105a.383.383,0,0,1-.153.126.833.833,0,0,0,.666-.245c-.021-.194-.039-.389-.059-.586a.4.4,0,0,1-.087-.094,1.116,1.116,0,0,0-.48-.375,1.607,1.607,0,0,0-.254-.078l-.558.24-.192.341c.018.064.039.13.057.2a.79.79,0,0,0-.229-.041.834.834,0,0,0-.647.375",
    transform: "translate(44.477 -210.424)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29221",
    "data-name": "Path 29221",
    d: "M98.537,224.079a1.06,1.06,0,0,0-1.38.409.5.5,0,0,0,.073.485l.309.076a.252.252,0,0,1-.105-.146c.215.1.428.194.643.291.13-.05.259-.1.389-.153l.3-.323a.574.574,0,0,0-.224-.638",
    transform: "translate(60.156 -208.002)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29222",
    "data-name": "Path 29222",
    d: "M60.654,222.739a.456.456,0,0,1-.055-.112,1,1,0,0,0-.336-.471,1.274,1.274,0,0,0-.213-.133l-.583.1c-.094.091-.183.185-.277.279,0,.178-.007.359-.009.538a.661.661,0,0,0,.126.336l.728.03a.4.4,0,0,1-.178.085.8.8,0,0,0,.684-.076c.039-.19.075-.382.114-.572",
    transform: "translate(11.288 -210.501)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29223",
    "data-name": "Path 29223",
    d: "M34.8,224.566c-.474-.124-1.123.336-1.087.78a.533.533,0,0,0,.275.41l.313-.027a.282.282,0,0,1-.156-.1c.236.021.474.041.709.064l.291-.254c.043-.126.087-.249.133-.375a.643.643,0,0,0-.478-.5",
    transform: "translate(-21.517 -207.252)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29224",
    "data-name": "Path 29224",
    d: "M40.639,223.743a.5.5,0,0,0-.114.464l.24.165a.216.216,0,0,1-.037-.165l.448.467c.133,0,.265-.009.4-.016.126-.066.252-.135.375-.2a.565.565,0,0,0,.041-.652.975.975,0,0,0-1.35-.062",
    transform: "translate(-12.761 -208.597)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29225",
    "data-name": "Path 29225",
    d: "M96.965,226.154l.213-.156a.319.319,0,0,1-.167,0c.183-.091.366-.183.551-.272.023-.1.048-.2.071-.3-.034-.1-.069-.208-.105-.311a.651.651,0,0,0-.615-.126A.683.683,0,0,0,96.546,226a.534.534,0,0,0,.419.153",
    transform: "translate(59.262 -206.713)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29226",
    "data-name": "Path 29226",
    d: "M105.025,221.755c-.066.023-.135.048-.211.08-.075.133-.153.263-.229.4.146.643.835.524,1.094.48l.137-.021c.117-.144.236-.286.352-.43a.69.69,0,0,0-.382-.513,1.016,1.016,0,0,0-.762.007",
    transform: "translate(69.765 -210.946)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29227",
    "data-name": "Path 29227",
    d: "M106.85,221.336c-.142.059-.284.121-.423.181a.9.9,0,0,0-.19.787.715.715,0,0,0,.572.43c.16-.071.32-.142.48-.215a.322.322,0,0,1,.032-.041c-.071-.371-.162-.734-.263-1.091a1.07,1.07,0,0,0-.208-.05",
    transform: "translate(71.851 -211.386)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29228",
    "data-name": "Path 29228",
    d: "M96.371,223.019a.544.544,0,0,0-.2-.236c-.19.034-.382.071-.574.108a.721.721,0,0,0-.284.2c.03.162.057.325.087.49a.566.566,0,0,0,.2.236l.574-.1a.85.85,0,0,0,.281-.19c-.03-.167-.057-.334-.087-.5",
    transform: "translate(57.827 -209.522)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29229",
    "data-name": "Path 29229",
    d: "M99.683,223.843l-.334.4a.731.731,0,0,0,.336.588l.407.032a.573.573,0,0,0,.4-.652c-.055-.229-.3-.462-.812-.373",
    transform: "translate(63.021 -208.182)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29230",
    "data-name": "Path 29230",
    d: "M100.728,225.7a.96.96,0,0,1,.066.137.662.662,0,0,0,.741.5l.3-.224a.85.85,0,0,0-.14-.9.686.686,0,0,0-.851.048c-.039.149-.078.3-.119.442",
    transform: "translate(64.797 -206.56)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29231",
    "data-name": "Path 29231",
    d: "M90.825,226.6a.553.553,0,0,0,.341-.673c-.073-.22-.341-.432-.847-.311l-.3.423a.748.748,0,0,0,.394.556l.407,0",
    transform: "translate(51.011 -205.922)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29232",
    "data-name": "Path 29232",
    d: "M92.838,220.6a1.785,1.785,0,0,0-.217.007l-.364.3c-.133.647.524.762.769.805.046.009.089.018.133.025l.487-.286a.648.648,0,0,0-.13-.6.891.891,0,0,0-.677-.243",
    transform: "translate(53.864 -212.339)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29233",
    "data-name": "Path 29233",
    d: "M102.327,228.928c.151-.121.462-.551.332-.885-.094-.247-.378-.361-.762-.277l-.323.359a1.236,1.236,0,0,1-.014.151c-.023.208-.071.641.394.744.124-.032.249-.062.373-.092",
    transform: "translate(65.852 -203.141)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29234",
    "data-name": "Path 29234",
    d: "M92.17,225.056c.117.053.233.105.35.16a.637.637,0,0,0,.625-.49c.043-.231-.08-.528-.579-.606l-.462.277a.7.7,0,0,0,.066.659",
    transform: "translate(53.63 -207.8)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29235",
    "data-name": "Path 29235",
    d: "M83.621,223.2c-.38.249-.764.5-1.146.741a.8.8,0,0,0,.329.3c.167-.032.336-.062.506-.094a.465.465,0,0,1,.259-.144c.069-.178.135-.355.2-.531a.386.386,0,0,1-.05-.089,1.113,1.113,0,0,0-.1-.178",
    transform: "translate(41.289 -208.981)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29236",
    "data-name": "Path 29236",
    d: "M101.242,225.4c.03.03.057.057.087.085l.572-.007a.749.749,0,0,0,.281-.581.713.713,0,0,0-.387-.54,1.608,1.608,0,0,0-.178-.1l-.476.076c-.519.494-.069.911.1,1.068",
    transform: "translate(65.017 -207.625)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29237",
    "data-name": "Path 29237",
    d: "M86.037,224.491l.508.032a.486.486,0,0,1,.291-.078l.355-.467a.4.4,0,0,1-.018-.1.772.772,0,0,0-.158-.43.9.9,0,0,0-.149-.146l-.442-.034a1.059,1.059,0,0,0-.6.593.627.627,0,0,0,.213.629",
    transform: "translate(45.578 -208.896)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29238",
    "data-name": "Path 29238",
    d: "M76.744,226.832l-.211.1a.6.6,0,0,0-.222.432l.11.05a.379.379,0,0,0-.023.471c.062.046.124.089.188.135a.683.683,0,0,0,.76-.137.649.649,0,0,0-.043-.819.541.541,0,0,0-.558-.233",
    transform: "translate(33.351 -204.321)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29239",
    "data-name": "Path 29239",
    d: "M56.7,221.344l-.554.066a.705.705,0,0,0-.277.165c.021.162.041.327.059.492a.616.616,0,0,0,.194.245l.535-.082a.709.709,0,0,0,.277-.174c-.023-.162-.048-.325-.071-.487a.569.569,0,0,0-.165-.224",
    transform: "translate(7.025 -211.376)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29240",
    "data-name": "Path 29240",
    d: "M35.968,225.539c-.062.027-.121.057-.188.094l-.158.389c.236.593.869.428,1.107.362.043-.009.087-.018.128-.03.092-.144.181-.288.27-.435a.721.721,0,0,0-.437-.448.965.965,0,0,0-.723.069",
    transform: "translate(-19.053 -206.117)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29241",
    "data-name": "Path 29241",
    d: "M58.114,223.522l.249-.435a.516.516,0,0,0,.007-.3c-.162-.069-.323-.14-.485-.208a.739.739,0,0,0-.332.007c-.085.146-.169.291-.254.435a.532.532,0,0,0,0,.3c.16.069.323.137.485.208a.757.757,0,0,0,.334-.009",
    transform: "translate(8.834 -209.802)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29242",
    "data-name": "Path 29242",
    d: "M34.838,227.3c-.059.03-.119.057-.176.087a.632.632,0,0,0-.261.547.677.677,0,0,0,.359.508,1.049,1.049,0,0,0,.721.126c.059-.027.119-.057.181-.087a.653.653,0,0,0,.261-.554.928.928,0,0,0-1.084-.627",
    transform: "translate(-20.629 -203.731)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29243",
    "data-name": "Path 29243",
    d: "M57.26,225.963a.538.538,0,0,0,.16.24c.183-.011.368-.025.554-.039a.728.728,0,0,0,.277-.144l-.021-.5a.558.558,0,0,0-.158-.24l-.558.041a.758.758,0,0,0-.272.142c.007.165.011.332.018.5",
    transform: "translate(8.791 -206.301)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29244",
    "data-name": "Path 29244",
    d: "M47.318,219.173l-.549.016a.729.729,0,0,0-.286.14c0,.165.007.327.009.492a.59.59,0,0,0,.165.261l.533-.037a.717.717,0,0,0,.288-.149c-.007-.16-.014-.323-.018-.485a.553.553,0,0,0-.142-.238",
    transform: "translate(-5.066 -214.172)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29245",
    "data-name": "Path 29245",
    d: "M52.852,222.82l-.259.368a.936.936,0,0,1,.009.144c0,.2.016.615.471.682l.341-.117a.868.868,0,0,0,.2-.867.606.606,0,0,0-.762-.21",
    transform: "translate(2.803 -209.534)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29246",
    "data-name": "Path 29246",
    d: "M43.52,220.018l-.4.3a.689.689,0,0,0,.149.627c.117.041.236.082.352.126a.571.571,0,0,0,.533-.515c.011-.224-.146-.5-.629-.538",
    transform: "translate(-9.419 -213.083)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29247",
    "data-name": "Path 29247",
    d: "M63.444,227.582a.964.964,0,0,0-.865-.018c-.055.126-.112.249-.167.375.018.06.039.117.057.174a.51.51,0,0,1,.034.1.681.681,0,0,1-.021.114c-.014.059-.025.121-.039.181.128.124.256.245.387.368l.654-.055c.1-.172.192-.341.286-.512a.78.78,0,0,1,.108-.114c.092-.087.263-.247.2-.462a.454.454,0,0,0-.391-.286l-.469.281a.361.361,0,0,1,.229-.149",
    transform: "translate(15.449 -203.513)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29248",
    "data-name": "Path 29248",
    d: "M35.513,225.265c-.151.1-.3.2-.453.293a.664.664,0,0,0-.146.245l.32.4a.648.648,0,0,0,.281.126c.151-.1.3-.194.451-.293a.588.588,0,0,0,.149-.247l-.32-.4a.65.65,0,0,0-.281-.124",
    transform: "translate(-19.966 -206.326)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29249",
    "data-name": "Path 29249",
    d: "M36.329,223.351a.474.474,0,0,0-.1.524.779.779,0,0,0,1.071.167.415.415,0,0,0,.144-.366l-.172-.153a.184.184,0,0,1,.009.137l-.309-.419-.323-.021-.325.13",
    transform: "translate(-18.322 -208.958)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29250",
    "data-name": "Path 29250",
    d: "M47.347,226.015l.382-.245a.654.654,0,0,0-.057-.638.593.593,0,0,0-.442-.206,1.2,1.2,0,0,0-.734.256.682.682,0,0,0-.291.458c.112.114.224.227.336.339.268.014.538.025.805.037",
    transform: "translate(-5.424 -206.763)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29251",
    "data-name": "Path 29251",
    d: "M55.773,222.338c-.153.087-.307.174-.46.259a.612.612,0,0,0-.176.256c.092.133.185.268.279.4a.625.625,0,0,0,.279.146c.153-.089.3-.176.458-.263a.6.6,0,0,0,.176-.252l-.279-.4a.633.633,0,0,0-.277-.144",
    transform: "translate(6.08 -210.095)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29252",
    "data-name": "Path 29252",
    d: "M36.528,228.4c.064.092.13.181.194.272a.636.636,0,0,0,.252.519c.192-.03.382-.059.572-.087.041-.062.082-.124.128-.185.259-.378.659-.947.085-1.569l-.41-.094a1.408,1.408,0,0,0-.32.149.447.447,0,0,0-.227.446.43.43,0,0,0-.275.549",
    transform: "translate(-17.917 -203.767)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29253",
    "data-name": "Path 29253",
    d: "M47.4,226.339a.875.875,0,0,0,.769-.323c.016-.112.034-.224.053-.336-.117-.238-.371-.478-.988-.245a.211.211,0,0,1,.043,0c-.133.156-.265.311-.4.467a.767.767,0,0,0,.524.437",
    transform: "translate(-4.556 -206.229)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29254",
    "data-name": "Path 29254",
    d: "M61.556,226.969c.027-.309-.21-.556-.458-.783-.14-.021-.279-.041-.419-.064a.955.955,0,0,0-.192.108c-.3.22-.288.51.032.858a1,1,0,0,1,.1.121.159.159,0,0,1,.025-.137l.5.435a.68.68,0,0,0,.416-.538",
    transform: "translate(12.693 -205.222)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29255",
    "data-name": "Path 29255",
    d: "M40.8,218.042c.011-.14.021-.279.032-.419-.064-.073-.128-.149-.19-.224-.169-.016-.336-.034-.5-.053l-.38.263-.089.432a.641.641,0,0,0,.435.279.826.826,0,0,0,.7-.279",
    transform: "translate(-13.838 -216.525)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29256",
    "data-name": "Path 29256",
    d: "M47.27,217.867,46.9,217.7a1.067,1.067,0,0,0-.737.357.628.628,0,0,0-.043.643l.43.185a.435.435,0,0,1,.281.021c.16-.108.32-.215.48-.32a.4.4,0,0,1,.021-.1.774.774,0,0,0,.018-.442.88.88,0,0,0-.078-.181",
    transform: "translate(-5.624 -216.069)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29257",
    "data-name": "Path 29257",
    d: "M29.172,223.028a1.738,1.738,0,0,0,1.327.064l.435-.313c.08-.117.162-.233.243-.348q-.566-.309-1.133-.613l-.011-.037a.535.535,0,0,1-.05-.188l-1.4.162c-.037.169-.069.341-.1.515a1.412,1.412,0,0,0,.691.757",
    transform: "translate(-28.251 -211.054)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29258",
    "data-name": "Path 29258",
    d: "M35.964,223.129a1.439,1.439,0,0,0-1.084,1.773l.011.048c.078.073.158.144.236.215.089.188.178.373.268.558.194.142.389.281.586.419a1.525,1.525,0,0,0,.7.137c.2-.085.391-.172.588-.256.16-.174.32-.345.478-.519a1.182,1.182,0,0,0,.176-.611l-.165-.327a1.06,1.06,0,0,0-.007-.515c-.03-.059-.062-.119-.092-.178l.021-.007a1.391,1.391,0,0,0-1.714-.737",
    transform: "translate(-20.077 -209.157)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29259",
    "data-name": "Path 29259",
    d: "M47.516,224.326c-.08-.073-.16-.146-.238-.22a.635.635,0,0,0-.583.108.593.593,0,0,0,.156.949.557.557,0,0,0,.432-.016c.037-.069.073-.135.108-.2a.266.266,0,0,1-.135.059c.112-.135.224-.272.339-.41-.027-.089-.053-.178-.078-.27",
    transform: "translate(-5.017 -207.853)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29260",
    "data-name": "Path 29260",
    d: "M36.492,218.88c.039.059.076.121.114.181a.615.615,0,0,0,.709.108.668.668,0,0,0,.261-.764.477.477,0,0,0-.426-.389.563.563,0,0,0-.545.359l.076.082a.4.4,0,0,0-.19.423",
    transform: "translate(-17.943 -215.665)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29261",
    "data-name": "Path 29261",
    d: "M40.467,228.267a1.861,1.861,0,0,0,1.787-1.293c0-.1,0-.194,0-.293-.021-.085-.039-.167-.059-.252-.043-.089-.089-.181-.135-.272a2.089,2.089,0,0,0-1.663-.693,1.882,1.882,0,0,0-1.462.76c-.066.208-.13.416-.194.622l.048.32a1.594,1.594,0,0,0,1.677,1.1",
    transform: "translate(-15.036 -206.072)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29262",
    "data-name": "Path 29262",
    d: "M33.737,222.568a1.739,1.739,0,0,0-1.206-.137c-.837.183-1.348.824-1.181,1.489l.979.533.158-.032a1.51,1.51,0,0,0,1.016-.078c.048-.048.094-.1.142-.142l.062-.014c.041-.059.085-.119.126-.178.037-.037.073-.073.11-.112l0-.043c.13-.183.261-.366.389-.549a1.179,1.179,0,0,0-.593-.737",
    transform: "translate(-24.595 -210.038)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29263",
    "data-name": "Path 29263",
    d: "M29,223.7a1.19,1.19,0,0,0,.082,1.521,1.682,1.682,0,0,0,.423.332l.4.13a1.683,1.683,0,0,0,1.444-.471,1.5,1.5,0,0,0,.313-1.558l-.238-.32-.281-.213-.391-.162A1.865,1.865,0,0,0,29,223.7",
    transform: "translate(-27.886 -209.324)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29264",
    "data-name": "Path 29264",
    d: "M40.366,224.913c0-.192-.009-.384-.011-.574-.025-.085-.048-.169-.071-.252a1.664,1.664,0,0,0-.563-.908c.03-.021.071-.016.1-.041,0-.073.009-.144.011-.217a.22.22,0,0,1-.105.1c.046-.162.092-.325.135-.49l-.2-.22c-.108-.039-.213-.078-.32-.114a.588.588,0,0,0-.483.3.463.463,0,0,0,.018.373,1.782,1.782,0,0,0-.545.053c-.162.119-.327.236-.49.355-.085.133-.167.265-.252.4-.027.183-.053.368-.08.551a2.173,2.173,0,0,0,1.567,1.686.42.42,0,0,0,.11.135.539.539,0,0,0,.419.059l.149-.176a.28.28,0,0,1-.144.034c.137-.114.277-.226.414-.339,0-.032,0-.064,0-.1l.078-.039.268-.586",
    transform: "translate(-16.621 -210.273)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29265",
    "data-name": "Path 29265",
    d: "M28.925,226.9a1.531,1.531,0,0,0-.545-.245v2.391l.464-.178.35-.3.254-.5.007-.16a1.266,1.266,0,0,0-.531-1.009",
    transform: "translate(-28.381 -204.537)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29266",
    "data-name": "Path 29266",
    d: "M28.716,225.456l-.336-.176v1.961a1.228,1.228,0,0,0,.336-1.785",
    transform: "translate(-28.381 -206.306)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29267",
    "data-name": "Path 29267",
    d: "M39.733,218.314c.176-.076.355-.151.533-.229A.373.373,0,0,1,40.3,218a.768.768,0,0,0,.112-.428.708.708,0,0,0-.034-.19l-.323-.231a1.1,1.1,0,0,0-.789.22.642.642,0,0,0-.181.62l.375.259a.414.414,0,0,1,.268.069",
    transform: "translate(-14.608 -216.781)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29268",
    "data-name": "Path 29268",
    d: "M30.626,223.988c-.108.19-.215.382-.323.574-.009.105-.016.213-.025.318a1.484,1.484,0,0,0,1.368,1.373,2.04,2.04,0,0,0,.515,0,2.053,2.053,0,0,0,1.08.144c-.046-.165-.092-.327-.14-.49a1.588,1.588,0,0,0,.549-.595c.023-.1.043-.192.064-.288v-.254l-.069-.291a1.95,1.95,0,0,0-1.446-.972,1.917,1.917,0,0,0-1.574.483",
    transform: "translate(-25.936 -208.616)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29269",
    "data-name": "Path 29269",
    d: "M31.95,220.654a1.517,1.517,0,0,0-1.116-.311l-.547.259-.329.343c-.066.174-.13.35-.2.524a2.016,2.016,0,0,0,1.229,1.981l.982-.288c.128-.174.259-.348.387-.524.039-.188.076-.375.114-.563l-.014-.259a1.444,1.444,0,0,0-.508-1.162",
    transform: "translate(-26.604 -212.674)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29270",
    "data-name": "Path 29270",
    d: "M39.051,226.9a.726.726,0,0,0-.515-.336.874.874,0,0,0-.636.19.819.819,0,0,0-.329.57c.016.055.03.112.046.167a.719.719,0,0,0,.517.339.924.924,0,0,0,.961-.764c-.016-.055-.03-.11-.043-.165",
    transform: "translate(-16.544 -204.665)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29271",
    "data-name": "Path 29271",
    d: "M36.271,216.987h-.021l.009.009.011-.009",
    transform: "translate(-18.244 -216.987)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29272",
    "data-name": "Path 29272",
    d: "M34.8,225.363l-.469.114a.529.529,0,0,0-.11.467c.039.13.162.332.551.437.144-.05.288-.1.432-.156l.151-.247c-.048-.142-.1-.284-.142-.426-.14-.064-.277-.126-.414-.19",
    transform: "translate(-20.883 -206.199)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29273",
    "data-name": "Path 29273",
    d: "M29.4,224.593a.438.438,0,0,0-.124.542c.057.018.112.039.169.057a.677.677,0,0,0,.231.387l.474,0c.121-.094.24-.185.361-.277.018-.1.034-.2.053-.293.1.03.2.062.307.094a.714.714,0,0,0,.316-.037c.062-.144.124-.293.185-.437a.485.485,0,0,0-.037-.279c-.162-.053-.323-.1-.485-.153a.727.727,0,0,0-.32.037c-.059.146-.121.293-.183.439l0,.03a1.275,1.275,0,0,0-.51-.213.589.589,0,0,0-.442.1",
    transform: "translate(-27.275 -207.703)",
    fill: "#02d7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29274",
    "data-name": "Path 29274",
    d: "M29.133,226.968c.021.126.039.252.059.378l.034.027a.86.86,0,0,0,.933.078c0-.185,0-.373,0-.561a.8.8,0,0,0-.62-.21.6.6,0,0,0-.41.288",
    transform: "translate(-27.411 -204.515)",
    fill: "#02d7e6"
  }))))), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29275",
    "data-name": "Path 29275",
    d: "M308.584,109.919c-1.231,0-31.649,5.489-56.118,8.715,5.569,5.848,1.716,25.252,8.117,29.706s18.653,10.3,18.653,10.3,21.435-1.67,21.712-5.569,4.734-20.879,4.734-20.879L307.63,120.5Z",
    transform: "translate(325.153 141.566)",
    fill: "#f0995b"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29276",
    "data-name": "Path 29276",
    d: "M279.7,177.66s15.647,15.5,8.646,33.779S275.4,267.03,262.2,281.982c1.782,12.638-.153,29.974-5.624,48.964S243.014,371,242.065,374.832a60.2,60.2,0,0,1-8.429-2.958l13.86-196.8s12.023-4.15,12.979-3.96S279.7,177.66,279.7,177.66",
    transform: "translate(300.902 220.374)",
    fill: "#de9266"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29277",
    "data-name": "Path 29277",
    d: "M289.433,194.34c.055-.393.082-.782.117-1.171a10.692,10.692,0,0,1-7.509-4.539c1.32,1.805-.448.069-1.35-.412-.833-.448-1.684-.869-2.542-1.267-1.878-.872-3.828-1.576-5.763-2.311q-1.5-.566-3-1.149c-9.438-.643-18.887-1.1-28.336-1.535L268.879,363h9.108c.057-3.9,7.793-29.413,8.817-48.9.448-8.529-1.457-17.31-4.132-25.492a87.954,87.954,0,0,1-1.158-51.565c4.219-14.734,6.28-31.031,7.918-42.695",
    transform: "translate(310.454 234.343)",
    fill: "#f3a97e"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29278",
    "data-name": "Path 29278",
    d: "M255.182,255.8l-2.1,14.684,2.807.485,6.566-2.942,1.906-9.973Z",
    transform: "translate(325.946 329.452)",
    fill: "#f3a97e"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29279",
    "data-name": "Path 29279",
    d: "M254.283,269.221c-.673.336-5.04,4.031-5.377,5.04s7.882.581,9.408,0c1.448-.551,10.92-7.9,11.424-8.568s-.334-3.864-1.51-4.535-13.945,8.063-13.945,8.063",
    transform: "translate(320.556 336.301)",
    fill: "#452d66"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29280",
    "data-name": "Path 29280",
    d: "M264.857,261.133c-2.478.5-13.54,8.074-13.54,8.074a.761.761,0,0,0-.117.069,3.223,3.223,0,0,0,2.972.771c2.46-.309,10.829-3.97,10.685-8.914",
    transform: "translate(323.523 336.315)",
    fill: "#f3a97e"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29281",
    "data-name": "Path 29281",
    d: "M254.8,262.9s-.458,4-2.883,5.681a3.254,3.254,0,0,0,2.32.426l4.217-2.35,1.766-1.97,3.72-3.157-1.435-.641-.572-.062h-.316l-3.69.4-1.036,2.389Z",
    transform: "translate(324.442 335.92)",
    fill: "#f3a97e"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29282",
    "data-name": "Path 29282",
    d: "M259.158,262.8s-.709,8.223,0,8.934c-1.094.021-1.931.034-1.931.034s.341-7.468,0-8.287c.039-.716,1.931-.682,1.931-.682",
    transform: "translate(331.285 338.457)",
    fill: "#452d66"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29283",
    "data-name": "Path 29283",
    d: "M274.992,147.559c5.461-22.378-.49-43.054-13.293-46.179s-27.608,12.485-33.069,34.863.487,43.054,13.29,46.179,27.61-12.485,33.072-34.863",
    transform: "translate(291.842 130.056)",
    fill: "#192541"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29284",
    "data-name": "Path 29284",
    d: "M291.051,138.645c7.433-21.8,3.349-42.926-9.124-47.179s-28.61,9.973-36.046,31.777-3.35,42.926,9.124,47.179,28.61-9.975,36.046-31.777",
    transform: "translate(311.893 116.832)",
    fill: "#192541"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29285",
    "data-name": "Path 29285",
    d: "M303.247,94.515c-10.806-15.871-34.138-18.813-52.116-6.575s-23.8,35.028-12.991,50.9,34.138,18.816,52.116,6.575,23.8-35.028,12.991-50.9",
    transform: "translate(299.706 103.529)",
    fill: "#192541"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29286",
    "data-name": "Path 29286",
    d: "M244.235,142.509s2.741,30.793-13.458,66.713c-.647,4.072.451,6.823,3.45,8.152,2.318-2.119,25.881-24.4,26.078-73.646-1.972-6.5-7.763-7.138-7.93-6.386s-8.14,5.166-8.14,5.166",
    transform: "translate(296.99 176.563)",
    fill: "#f3a97e"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29287",
    "data-name": "Path 29287",
    d: "M236.91,166s13.517,2.624,16.07,1.219c.419-.7,2.343-24.973,2.082-27.176s-9.591-22.316-10.49-21.147-10.836,6.459-7.662,47.1",
    transform: "translate(304.316 153.069)",
    fill: "#f3a97e"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29288",
    "data-name": "Path 29288",
    d: "M247.83,214.688s.258-19.877-1.29-35.367-2.773-17.761-5.811-22.621-4.292-7.072-4.381-7.843a37.072,37.072,0,0,1,4.381-18.827c4.917-9.117,11.174-15.642,19.218-15.642s19.845.089,25.387,7.6,5.9,27.979.984,38.348-15.912,31.823-3.933,53.276c-6.079,2.86-20.481,6.267-34.554,1.078",
    transform: "translate(304.328 147.321)",
    fill: "#68cede"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29289",
    "data-name": "Path 29289",
    d: "M247.83,214.688s.258-19.877-1.29-35.367-2.773-17.761-5.811-22.621-4.292-7.072-4.381-7.843a37.072,37.072,0,0,1,4.381-18.827c4.917-9.117,11.174-15.642,19.218-15.642s19.845.089,25.387,7.6,5.9,27.979.984,38.348-15.912,31.823-3.933,53.276c-6.079,2.86-20.481,6.267-34.554,1.078",
    transform: "translate(304.328 147.321)",
    fill: "#f3a97e"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29290",
    "data-name": "Path 29290",
    d: "M265.751,104.25s-4.379,15.434.668,28.166c.8,9.774-18.148,33.053-22.625,33.31-1.908-5.271-1.009-20.706,4.137-30.738,2.83-13.631-2.745-28.281-2.851-28.544s9.152-5.28,10.568-5.152,10.1,2.958,10.1,2.958",
    transform: "translate(312.797 130.451)",
    fill: "#f3a97e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10352",
    "data-name": "Group 10352",
    transform: "translate(557.875 231.74)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10351",
    "data-name": "Group 10351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10350",
    "data-name": "Group 10350",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29291",
    "data-name": "Path 29291",
    d: "M254.4,101.291c1.414.128,10.1,2.958,10.1,2.958s-3.791,13.38-.24,25.5c-7.562.448-13.281-4.448-17.221-9.79a63.453,63.453,0,0,0-3.21-13.517c-.108-.265,9.154-5.28,10.568-5.152",
    transform: "translate(-243.837 -101.289)",
    fill: "#f3b896"
  }))))), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29292",
    "data-name": "Path 29292",
    d: "M243.387,129.327s8.175,22.055,25.206,16.434,9.794-53.137-.51-61.142-24.27,28.613-24.27,28.613Z",
    transform: "translate(313.46 107.508)",
    fill: "#f3a97e"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29293",
    "data-name": "Path 29293",
    d: "M252.77,105.2c0-3.324-2.432-6.019-5.431-6.019s-5.431,2.7-5.431,6.019,2.432,6.019,5.431,6.019,5.431-2.7,5.431-6.019",
    transform: "translate(311.554 127.74)",
    fill: "#f3a97e"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10356",
    "data-name": "Group 10356",
    transform: "translate(555.987 236.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10355",
    "data-name": "Group 10355",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2335",
    "data-name": "Rectangle 2335",
    width: 3.905,
    height: 5.862,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10361",
    "data-name": "Group 10361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10360",
    "data-name": "Group 10360",
    clipPath: "url(#clip-path)"
  }, _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29295",
    "data-name": "Path 29295",
    d: "M251.323,122.954c24.092,0,27.148-15.052,25.325-16.267-.618-.412.824-41.594-22.239-18.944s-15.853,38.3-15.853,38.3Z",
    transform: "translate(305.865 104.251)",
    fill: "#192541"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29296",
    "data-name": "Path 29296",
    d: "M253.663,103.219c.206.618,11.119,30.063,30.269,14.826C285.167,104.66,289.7,71.92,254.9,84.687c-14.208,22.856-1.236,18.532-1.236,18.532",
    transform: "translate(319.719 105.335)",
    fill: "#192541"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29297",
    "data-name": "Path 29297",
    d: "M240.728,156.28c-3.038-4.859-4.292-7.072-4.381-7.843a35.465,35.465,0,0,1,1.606-12.133c4.127-6.338,11.625-16.8,13.627-19.758a16.485,16.485,0,0,1,3.8-1.833c-.872,1.467-15.073,25.451-11.337,25.808,3.855.366,26.064,2.2,27.9,1.652,1.656-.5,10.2-18.8,11.838-22.346a12.43,12.43,0,0,1,2.766,3.752c-1.437,4.489-4.967,15.571-6.642,21.312-.069,3.093,3.112,11.3,5.484,16.979-5.2,10.952-14.272,31.134-3,51.32-6.079,2.862-20.481,6.267-34.554,1.078,0,0,.258-19.877-1.29-35.366s-2.773-17.761-5.811-22.621",
    transform: "translate(304.328 147.74)",
    fill: "#ff5ecf"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29298",
    "data-name": "Path 29298",
    d: "M291.278,157.389s6.207,30.086,2.908,30.294c-.824-.414-36.2-43.2-37.286-45.472s-4.368-27.318-2.8-26.746,15.535,1.112,37.176,41.924",
    transform: "translate(326.722 148.697)",
    fill: "#f3a97e"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29299",
    "data-name": "Path 29299",
    d: "M262.477,116.832a3.747,3.747,0,0,1,2.219.686,6.037,6.037,0,0,1,1.386,1.965c-1.144,3.574-5.878,17.722-7.68,23.632-2.334-.625-3.427-6.344-5.5-6.937,3.18-5.544,8.346-16.7,9.573-19.347",
    transform: "translate(325.717 150.469)",
    fill: "#ff5ecf"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29300",
    "data-name": "Path 29300",
    d: "M243.281,176.057c1.638-4.034,1.3-8.131-2.734-9.769a7.88,7.88,0,0,0-10.27,4.333c-1.64,4.034-1.622,13.364,2.409,15s8.957-5.534,10.6-9.568",
    transform: "translate(295.258 213.412)",
    fill: "#f3a97e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10359",
    "data-name": "Group 10359",
    transform: "translate(585.043 291.777)",
    opacity: 0.37,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10358",
    "data-name": "Group 10358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10357",
    "data-name": "Group 10357",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29301",
    "data-name": "Path 29301",
    d: "M263.223,138.082s-7.513-10.906-7.513-10.543,1.213,25.81,1.213,25.81,6.18-12.966,6.3-15.267",
    transform: "translate(-255.712 -127.53)",
    fill: "#f3a97e"
  }))))), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29302",
    "data-name": "Path 29302",
    d: "M293.161,239.272l-54.921-2.414c3.086-27.107,7.086-64.572,7.086-64.572l14.178-19.01,1.03-5.967,3.487,2.176a167.8,167.8,0,0,1,15.18,20.429c16.576,15.3,14.654,28.327,14.654,32.337,0,1.844-.277,22.776-.693,37.021",
    transform: "translate(306.831 189.722)",
    fill: "#ff5ecf"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29303",
    "data-name": "Path 29303",
    d: "M239.225,120.4a9.289,9.289,0,1,1,9.289,9.289,9.29,9.29,0,0,1-9.289-9.289",
    transform: "translate(308.1 143.1)",
    fill: "#f3b896"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29304",
    "data-name": "Path 29304",
    d: "M235.338,255.586l-2.1,14.684,2.81.485,6.566-2.942,2.663-9.879Z",
    transform: "translate(300.385 329.171)",
    fill: "#de9266"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29305",
    "data-name": "Path 29305",
    d: "M234.437,269c-.673.336-5.04,4.031-5.377,5.04s7.882.581,9.408,0c1.448-.551,10.92-7.9,11.424-8.568s-.334-3.864-1.51-4.537S234.437,269,234.437,269",
    transform: "translate(294.996 336.019)",
    fill: "#452d66"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29306",
    "data-name": "Path 29306",
    d: "M245.012,260.915c-2.478.5-13.54,8.074-13.54,8.074a.755.755,0,0,0-.117.069,3.223,3.223,0,0,0,2.972.771c2.46-.309,10.829-3.97,10.685-8.914",
    transform: "translate(297.964 336.035)",
    fill: "#de9266"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29307",
    "data-name": "Path 29307",
    d: "M234.953,262.682s-.46,4-2.885,5.679a3.255,3.255,0,0,0,2.322.428l4.214-2.35,1.766-1.97,3.722-3.157-1.435-.641-.572-.064h-.316l-3.693.407-1.036,2.389Z",
    transform: "translate(298.882 335.638)",
    fill: "#de9266"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29308",
    "data-name": "Path 29308",
    d: "M239.313,262.578s-.712,8.223,0,8.934c-1.094.021-1.931.034-1.931.034s.341-7.47,0-8.289c.039-.714,1.931-.679,1.931-.679",
    transform: "translate(305.726 338.176)",
    fill: "#452d66"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29309",
    "data-name": "Path 29309",
    d: "M290.365,166.077l6.077.055a9.647,9.647,0,0,0,2.091,1.531c7.507,4.1,16,4.045,24.318,4.32,7.431.245,14.665.2,21.634-2.112-1.29,7.278-4.7,24.888-8.932,33.991-5.418,11.655-27.757,49.95-28.576,70.669s-44.44,115.72-44.44,115.72l-10.861-.394Z",
    transform: "translate(324.136 213.892)",
    fill: "#1e2c4f"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29310",
    "data-name": "Path 29310",
    d: "M277.269,263.776s-29.914.3-32.5,1.505-4.322,6.523-4.322,6.523,33.712-.652,35.275-1.3,1.549-6.724,1.549-6.724",
    transform: "translate(309.671 339.719)",
    fill: "#0e1424"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29311",
    "data-name": "Path 29311",
    d: "M272.708,169.2l40.505,220.531,11,.391s10.483-95.74,3.924-116.459-.849-58.275.421-69.93S327.1,166.47,327.1,166.47l-29.137-.293Z",
    transform: "translate(351.223 214.021)",
    fill: "#253761"
  }))), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29376",
    "data-name": "Path 29376",
    d: "M136.494,99.325c-4.464,0-16.473-24.926-17.829-27.768-3.159-6.634-13.473-29.139-13.473-40.256a31.3,31.3,0,1,1,62.6,0c0,11.191-10.233,33.641-13.368,40.256-1.348,2.842-13.3,27.768-17.933,27.768",
    transform: "translate(344.739 97.352)",
    fill: "#fc6da2"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29377",
    "data-name": "Path 29377",
    d: "M135.471,16.938A12.735,12.735,0,1,1,122.736,4.2a12.737,12.737,0,0,1,12.735,12.735",
    transform: "translate(358.497 109.379)",
    fill: "#fff"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10363",
    "data-name": "Group 10363",
    transform: "translate(613.342 251.368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10362",
    "data-name": "Group 10362",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2338",
    "data-name": "Rectangle 2338",
    width: 72.364,
    height: 138.334,
    transform: "translate(-0.086 0)",
    fill: "url(#linear-gradient-3)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10368",
    "data-name": "Group 10368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10367",
    "data-name": "Group 10367",
    clipPath: "url(#clip-path)"
  }, _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29313",
    "data-name": "Path 29313",
    d: "M276.994,109.983q1.17-.113,2.379-.114h28.359c.1.343.2.675.3.97-8.682,14.336-20.836,12.275-26.794,10.1a5.891,5.891,0,0,1-3.825-5.052Z",
    transform: "translate(356.743 141.501)",
    fill: "#fff"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29314",
    "data-name": "Path 29314",
    d: "M279.01,101.508l-.949,28.059a6.639,6.639,0,0,0,4.775,6.69c5.642,1.6,15.169,1.858,23.43-9.767-1.654-6.749-.165-28.361-.165-28.361l-6.317-1.167h-9.511Z",
    transform: "translate(358.111 124.878)",
    fill: "#f3b896"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10366",
    "data-name": "Group 10366",
    transform: "translate(636.249 222.652)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10365",
    "data-name": "Group 10365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10364",
    "data-name": "Group 10364",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29315",
    "data-name": "Path 29315",
    d: "M280.124,112.465c7.546-2.144,15.6-3.507,21.014-9.964a16.461,16.461,0,0,0,3-5.184l1.917.355s-.746,10.84-.595,19.564a16.584,16.584,0,0,1-14.954,9.657H279.687a13.54,13.54,0,0,1-1.595-.094l.476-14.027a10.688,10.688,0,0,0,1.556-.307",
    transform: "translate(-278.092 -97.317)",
    fill: "#f3b896"
  }))))), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29316",
    "data-name": "Path 29316",
    d: "M314.358,263.776s-29.807.3-31.964,1.505-2,6.523-2,6.523,33.481-.652,34.811-1.3-.844-6.724-.844-6.724",
    transform: "translate(361.115 339.719)",
    fill: "#0e1424"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29317",
    "data-name": "Path 29317",
    d: "M317.282,168.85l14.846-4.063v3.4l-15.91,4.647a64.227,64.227,0,0,1-47.589-4.647l.188-2.924a72.746,72.746,0,0,0,48.465,3.583",
    transform: "translate(345.971 212.231)",
    fill: "#fff"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29318",
    "data-name": "Path 29318",
    d: "M278.966,108.488c-.329-2.476-9.914-10.179-5.766-27.922,13.272,1.238,12.014,5.914,12.137,6.326s2.251,6.6,2.251,6.6Z",
    transform: "translate(350.518 103.762)",
    fill: "#192541"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29319",
    "data-name": "Path 29319",
    d: "M287.466,137.9h9.483a16.406,16.406,0,0,0,16.276-15.743l1.565-41.038H289.609a15.413,15.413,0,0,0-15.292,14.791l-1.1,27.244A14.16,14.16,0,0,0,287.466,137.9",
    transform: "translate(351.87 104.479)",
    fill: "#f3b896"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29320",
    "data-name": "Path 29320",
    d: "M291.8,108.374s-8.58-6.921-2.343-22.648c4.427,9.763,4.519,8.859,4.427,9.763s1.176,12.652,1.176,12.652Z",
    transform: "translate(369.874 110.407)",
    fill: "#192541"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29321",
    "data-name": "Path 29321",
    d: "M319.546,123.347s11.417-18.29,10.57-23.533-6.358-12.405-14.963-11.382c-1.668-3.583-29.068-32.937-40.99-9.5s5.665,25.359,8.339,25.741,18.12-6.395,23.346-2.045,9.1,22.126,9.1,22.126Z",
    transform: "translate(347.814 90.072)",
    fill: "#192541"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29322",
    "data-name": "Path 29322",
    d: "M290.719,93.672s7.244-3.78,9.884,1.128-2.4,11.261-5.578,11.085-6.077-6.289-6.09-8.5a5.284,5.284,0,0,1,1.785-3.709",
    transform: "translate(372.121 118.852)",
    fill: "#f3b896"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29323",
    "data-name": "Path 29323",
    d: "M280.431,160.8c7.2-16.871,9.6-28.139,9.6-28.139s13.739-2.894,14.327-3.928,8.829,2.521,8.792,12.993c-3.416,10.968-2.457,10.067-6.674,18.834-.357-.2-19.28,3.384-26.041.24",
    transform: "translate(361.169 165.58)",
    fill: "#f3b896"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29324",
    "data-name": "Path 29324",
    d: "M305.789,173.987c5.647,4.4,14.29-6.555,16.086-11.577a244.091,244.091,0,0,1-39.432-33.435c-5.413-3.331-9.975-3.393-13.641.085,1.1,3.05,4.537,19.63,36.986,44.928",
    transform: "translate(346.194 162.873)",
    fill: "#f3b896"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29325",
    "data-name": "Path 29325",
    d: "M264.629,112.846l7.74,30.436a2.553,2.553,0,0,0,2.961,1.856l11.856-2.066a1.842,1.842,0,0,0,1.494-2.219l-7.742-30.436a2.556,2.556,0,0,0-2.963-1.855l-11.856,2.066a1.837,1.837,0,0,0-1.489,2.219",
    transform: "translate(340.749 139.764)",
    fill: "#2b1a12"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29326",
    "data-name": "Path 29326",
    d: "M264.093,112.9l7.742,30.436a2.553,2.553,0,0,0,2.961,1.856l11.854-2.066a1.844,1.844,0,0,0,1.494-2.219L280.4,110.47a2.552,2.552,0,0,0-2.961-1.855l-11.856,2.066a1.84,1.84,0,0,0-1.492,2.219",
    transform: "translate(340.061 139.832)",
    fill: "#4a2b1e"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29327",
    "data-name": "Path 29327",
    d: "M264.529,110.939l1.538,6.04a.5.5,0,0,0,.586.366l2.352-.41a.366.366,0,0,0,.3-.439l-1.537-6.04a.505.505,0,0,0-.586-.368l-2.354.41a.367.367,0,0,0-.3.442",
    transform: "translate(340.676 141.772)",
    fill: "#140c09"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29328",
    "data-name": "Path 29328",
    d: "M267.149,111.736a.949.949,0,0,1-1.05,1.126,1.581,1.581,0,0,1-1.315-1.375.95.95,0,0,1,1.05-1.128,1.581,1.581,0,0,1,1.316,1.377",
    transform: "translate(341.007 142.124)",
    fill: "#807976"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29329",
    "data-name": "Path 29329",
    d: "M267.2,113.193a.8.8,0,0,1-.881.954,1.332,1.332,0,0,1-1.1-1.165.8.8,0,0,1,.881-.952,1.325,1.325,0,0,1,1.1,1.162",
    transform: "translate(341.577 144.279)",
    fill: "#807976"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29330",
    "data-name": "Path 29330",
    d: "M266.279,137.948c-3.764-10.485-2.565-20.511,2.679-22.394s12.545,5.093,16.308,15.581,2.563,20.511-2.679,22.394-12.545-5.1-16.308-15.581",
    transform: "translate(340.118 148.429)",
    fill: "#f3b896"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10370",
    "data-name": "Group 10370",
    transform: "translate(649.347 252.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10369",
    "data-name": "Group 10369",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2341",
    "data-name": "Rectangle 2341",
    width: 68.892,
    height: 49.863,
    transform: "translate(-9.653 60.065) rotate(-81.135)",
    fill: "url(#linear-gradient-4)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10390",
    "data-name": "Group 10390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10389",
    "data-name": "Group 10389",
    clipPath: "url(#clip-path)"
  }, _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29332",
    "data-name": "Path 29332",
    d: "M283.867,132.7s-.7,1.567-.474,1.718,18.727,10.6,24.311,8.751c.446-.783.835-1.595.835-1.595s-15.295-3.164-24.673-8.875",
    transform: "translate(364.925 170.9)",
    fill: "#fff"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29333",
    "data-name": "Path 29333",
    d: "M283.116,129.437a6.549,6.549,0,1,0-8.445,3.8,6.55,6.55,0,0,0,8.445-3.8",
    transform: "translate(348.301 155.278)",
    fill: "#f3b896"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29334",
    "data-name": "Path 29334",
    d: "M251.271,106.961c-.069-3.118,2.839.185,6.335.108s6.255-3.51,6.326-.391-2.711,5.711-6.207,5.788-6.386-2.386-6.454-5.5",
    transform: "translate(323.612 135.706)",
    fill: "#fff"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29335",
    "data-name": "Path 29335",
    d: "M274.528,99.461c.078-4.018,3.645.389,8.149.474s8.241-4.185,8.163-.165-3.791,7.207-8.3,7.12-8.095-3.411-8.017-7.429",
    transform: "translate(353.565 125.923)",
    fill: "#fff"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29336",
    "data-name": "Path 29336",
    d: "M289.847,160.717a9.289,9.289,0,1,1,9.289,9.289,9.29,9.29,0,0,1-9.289-9.289",
    transform: "translate(373.296 195.025)",
    fill: "#f3a97e"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2342",
    "data-name": "Rectangle 2342",
    width: 417.699,
    height: 13.611,
    transform: "translate(233.49 606.559)",
    fill: "#0d1a38"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29337",
    "data-name": "Path 29337",
    d: "M208.645,330.972c14.913,0-17.951-.055-18.724-.069-14.263-.254-115.7,2.521-117.6-3.3-2-6.136-32.026-51.416-12.831-62.245s44.3-28.054,44.3-28.054l58.076-16.734,46.264,39.867,1.968,29.038-2.46,23.625Z",
    transform: "translate(68.393 284.073)",
    fill: "#0d1a38"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29338",
    "data-name": "Path 29338",
    d: "M70.186,287.884a49.111,49.111,0,1,1,49.11,49.11,49.111,49.111,0,0,1-49.11-49.11",
    transform: "translate(90.393 307.519)",
    fill: "#0d1a38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10373",
    "data-name": "Group 10373",
    transform: "translate(155.051 536.234)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10372",
    "data-name": "Group 10372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10371",
    "data-name": "Group 10371",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29339",
    "data-name": "Path 29339",
    d: "M122.043,255.371c27.86,0,43.338,16.045,51.924,33.106-4.667-21.673-17.448-54.1-52.153-54.1-37.565,0-49.712,33.719-54.045,54.594,8.472-17.075,24.263-33.6,54.274-33.6",
    transform: "translate(-67.77 -234.378)",
    fill: "#b5a6fe"
  }))))), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29340",
    "data-name": "Path 29340",
    d: "M77.227,278.816a33,33,0,1,1,33,33,33,33,0,0,1-33-33",
    transform: "translate(99.461 316.587)",
    fill: "#abebff"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29341",
    "data-name": "Path 29341",
    d: "M110.228,297.526a32.994,32.994,0,0,0,32.108-40.615c-10.531,11.179-33.495,19.992-50.943,7.326a35.256,35.256,0,0,0-13.535-6.143,33.007,33.007,0,0,0,32.369,39.432",
    transform: "translate(99.461 330.878)",
    fill: "#f2edff"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29342",
    "data-name": "Path 29342",
    d: "M258.695,330.141c1.581-.156,134.147-3.292,134.147-3.292l9.671-23.44,2.954-30.024s-12.3-31.5-37.4-44.3-85.147-2.46-85.147-2.46l-8.859-5.415-31.008,24.117Z",
    transform: "translate(313.024 284.903)",
    fill: "#0d1a38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10376",
    "data-name": "Group 10376",
    transform: "translate(560.968 522.753)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10375",
    "data-name": "Group 10375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10374",
    "data-name": "Group 10374",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29343",
    "data-name": "Path 29343",
    d: "M325.947,259.724c41.455,0,64.485,23.874,77.26,49.261-6.944-32.25-25.961-80.5-77.6-80.5-55.894,0-73.97,50.172-80.415,81.234,12.6-25.407,36.1-50,80.759-50",
    transform: "translate(-245.188 -228.485)",
    fill: "#b5a6fe"
  }))))), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29344",
    "data-name": "Path 29344",
    d: "M655.191,394.272c5.045,0,76.265-2.533,78.786-5.054s-.4-41.143-2.926-45.461-5.9-5.054-6.527-6.106-1.894-22.639-2.844-24.428-40.116-41.592-176.158-60.334c-29.212-15.775-74.33-50.087-132.541-69.635-25.716-8.637-53.99-14.391-84.577-14.391-99.819,0-174.787,26.956-248.073,75.391-4.212,10.108-20.216,31.523-23.584,37.874s-17.692,74.018-18.674,76.126-3.51,8.985-3.51,11.09,3.089,3.37,3.089,3.37-3.652,6.6,3.089,10.25,53.581,11.09,64.251,11.231c1.544-6.6-3.391-72.023,59.785-72.023s57.616,75.391,57.616,75.391l310.085,0s-13.91-74.808,62.112-74.808,60.6,71.515,60.6,71.515",
    transform: "translate(44.515 217.48)",
    fill: "#fbab41"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29345",
    "data-name": "Path 29345",
    d: "M55.96,278.437c4.972-4.972,11.6-59.1,11.6-59.1l-13.757-2c-.57.917-1.041,1.716-1.38,2.354-2.3,4.34-9.721,37.323-14.5,58.442,6.5,1.725,15.089,3.251,18.038.3",
    transform: "translate(48.84 279.915)",
    fill: "#fc6da2"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29346",
    "data-name": "Path 29346",
    d: "M361.187,244c-.279-.156-28.221-15.466-53.96-19.617-4.8-.773-9.2-1.366-13.453-1.94-18.6-2.5-30.887-4.157-36.138-16.233l.771-.336c5.061,11.641,17.162,13.27,35.479,15.736,4.262.572,8.667,1.167,13.476,1.942,25.885,4.173,53.951,19.555,54.233,19.708Z",
    transform: "translate(331.812 265.146)",
    fill: "#cf8d35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10379",
    "data-name": "Group 10379",
    transform: "translate(494.202 465.121)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10378",
    "data-name": "Group 10378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10377",
    "data-name": "Group 10377",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29347",
    "data-name": "Path 29347",
    d: "M216.006,215.3s8.344,19.978,29.576,16.947,32.536-11.03,30.882-11.858-38.6-17.1-38.6-17.1Z",
    transform: "translate(-216.006 -203.295)",
    fill: "#fbab41"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10382",
    "data-name": "Group 10382",
    transform: "translate(215.477 483.01)",
    opacity: 0.28,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10381",
    "data-name": "Group 10381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10380",
    "data-name": "Group 10380",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29348",
    "data-name": "Path 29348",
    d: "M94.181,211.114c3.441,8.811,16.635,28.791,27.176,46.669,13.638,16.807,22.559,33.06,32.468,43.96,53.791,4.4,244.676,17.656,296.852,21.033,1.2-13.38,3.414-31.758,18.523-42.868-63.423-11.179-361.524-65.482-375.018-68.793",
    transform: "translate(-94.181 -211.114)",
    fill: "#fbab41"
  }))))), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29349",
    "data-name": "Path 29349",
    d: "M301.848,221.86c25.885-2.514,75.595,23.33,75.595,23.33.949,1.789,2.212,23.376,2.844,24.428-29.121-9.289-77.434-43.486-78.439-47.758",
    transform: "translate(388.753 285.514)",
    fill: "#abebff"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29350",
    "data-name": "Path 29350",
    d: "M324.982,249.855c11.131,6.319,22.488,11.89,31.859,14.878-.631-1.052-1.9-22.637-2.844-24.428a325.366,325.366,0,0,0-33.946-14.826c1.462,7.335,3.194,15.956,4.93,24.375",
    transform: "translate(412.198 290.398)",
    fill: "#f2edff"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29351",
    "data-name": "Path 29351",
    d: "M446.044,257.719S328.352,241.137,264.958,239.8s-135.346-2.139-179.214-13.107c6.152-4.814,54.834-52.157,170.655-52.157,0,0,60.719-3.478,105.923,18.99s83.721,64.2,83.721,64.2",
    transform: "translate(110.43 224.533)",
    fill: "#b5d8ff"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29352",
    "data-name": "Path 29352",
    d: "M256.4,197.792s60.719-3.478,105.923,18.992c20.68,10.277,39.956,24.586,54.791,37.087,17.564,2.247,28.931,3.848,28.931,3.848s-38.517-41.727-83.721-64.194S256.4,174.533,256.4,174.533c-115.821,0-164.5,47.344-170.653,52.157,7.749,1.938,16.391,3.553,25.693,4.914,25.853-15.093,72.129-33.813,144.96-33.813",
    transform: "translate(110.432 224.533)",
    fill: "#9ab8d9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10385",
    "data-name": "Group 10385",
    transform: "translate(198.939 414.718)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10384",
    "data-name": "Group 10384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10383",
    "data-name": "Group 10383",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29353",
    "data-name": "Path 29353",
    d: "M86.952,218.428c27.62,6.475,65.517,9.211,105.255,10.671a629.65,629.65,0,0,1-41.873-47.833c-34.314,11.584-54.018,26.471-62.24,33.246q-.6,1.953-1.142,3.917",
    transform: "translate(-86.953 -181.264)",
    fill: "#b5d8ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10388",
    "data-name": "Group 10388",
    transform: "translate(362.851 398.872)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10387",
    "data-name": "Group 10387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10386",
    "data-name": "Group 10386",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29354",
    "data-name": "Path 29354",
    d: "M189.645,174.909a251.13,251.13,0,0,0-27.071-.378c-1.295,0-2.581.009-3.862.021-.554,21.689.945,43.358,2.18,65.034l10.241.213c23.545.5,54.576,3.1,84.289,6.168-26.1-21.8-48.931-48.867-65.777-71.058",
    transform: "translate(-158.596 -174.34)",
    fill: "#b5d8ff"
  }))))), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29355",
    "data-name": "Path 29355",
    d: "M265.57,174.339v4.919c17.136,0,60.657,1.819,94.562,18.672,30.338,15.077,57.918,39.325,72.154,52.963-33.506-4.436-117.431-14.961-167.226-16.011q-5.9-.124-11.883-.245C198.793,233.527,137.71,232.28,96.7,224.1c7.632-5.88,20.589-14.652,40.187-22.968,33.9-14.386,74.115-21.68,119.511-21.68h.14l.14-.009c.034,0,3.352-.185,8.891-.185Zm0,0c-5.777,0-9.17.194-9.17.194-115.821,0-164.5,47.344-170.653,52.16,43.866,10.966,115.819,11.769,179.212,13.105S446.043,257.72,446.043,257.72s-38.517-41.727-83.721-64.194c-34.522-17.159-78.089-19.186-96.753-19.186",
    transform: "translate(110.432 224.533)",
    fill: "#cf8d35"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29356",
    "data-name": "Path 29356",
    d: "M53.321,236.918a55.72,55.72,0,0,0,2.855-5.658c33.4-22.076,67.162-39.672,103.455-52.306A39.109,39.109,0,0,1,143.78,196.3c-15.5,9.083-60.492,46.9-90.459,40.615",
    transform: "translate(68.673 230.476)",
    fill: "#ded1fd"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29357",
    "data-name": "Path 29357",
    d: "M53.321,236.918a55.72,55.72,0,0,0,2.855-5.658c33.4-22.076,67.162-39.672,103.455-52.306A39.109,39.109,0,0,1,143.78,196.3c-15.5,9.083-60.492,46.9-90.459,40.615",
    transform: "translate(68.673 230.476)",
    fill: "#b5d8ff"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29358",
    "data-name": "Path 29358",
    d: "M143.422,194.93c-2.961,1.734-7.051,4.5-11.79,7.708-20.054,13.563-53.114,35.918-76.393,33.147-.76,1.428-1.638,2.967-2.606,4.58a37.423,37.423,0,0,0,6.58.57c24.574,0,55.781-21.106,75.174-34.223,4.667-3.157,8.7-5.885,11.522-7.539,9.7-5.688,16.249-15.713,18.589-20.742l-.126-.059q-3.422,1.15-6.809,2.366c-2.949,4.571-7.829,10.492-14.142,14.192",
    transform: "translate(67.786 229.727)",
    fill: "#cf8d35"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29359",
    "data-name": "Path 29359",
    d: "M288.516,234.473c-29.905-24.849-69.5-43.8-79.182-48.856-4.061-2.121-7.159-6.312-9.387-10.467,57.493,19.3,102.215,52.993,131.461,69.029l.2.561h.826l.014.007c-1.048,3.491-25.2,1.512-43.93-10.273",
    transform: "translate(257.512 225.577)",
    fill: "#b5d8ff"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29360",
    "data-name": "Path 29360",
    d: "M173.881,174.348c3.853,14.1,13.288,48.748,17.66,65.976-5.232-.254-10.243-.439-14.952-.538-5.743-.121-11.561-.24-17.42-.359l-4.811-64.675q6.678-.223,13.673-.233s2.116-.121,5.85-.172",
    transform: "translate(198.799 224.544)",
    fill: "#cf8d35"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29361",
    "data-name": "Path 29361",
    d: "M368.455,362.267c-20.374,0-43.58-.176-66.839-.547-37.6-.6-125.878-2.588-133.566-8.017-6.692-4.722-26.105-30.631-41.825-53.782-15.645-23.035-32.218-50.1-31.825-56.98.75-13.117.938-13.542,10.085-22.689,8.376-8.376,17.988-20.026,17.988-35.925h.844c0,16.208-9.747,28.029-18.235,36.52-9.1,9.1-9.11,9.342-9.843,22.142-.712,12.453,60.412,100.931,73.3,110.026,5.2,3.672,54.956,6.612,133.095,7.861,61.709.988,125.341.565,132.186-.863,22.79-54.894.368-114.361.142-114.956l.785-.3c.231.6,22.829,60.515-.233,115.784l-.078.192-.2.053c-3.7.956-30.479,1.485-65.777,1.485",
    transform: "translate(121.57 237.396)",
    fill: "#cf8d35"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29362",
    "data-name": "Path 29362",
    d: "M171.558,372.919l-.831-.144c15.807-91.093-12.128-197.064-12.412-198.124l.812-.217c.284,1.062,28.267,107.211,12.43,198.485",
    transform: "translate(203.897 224.655)",
    fill: "#cf8d35"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29363",
    "data-name": "Path 29363",
    d: "M209.876,219.877a7.392,7.392,0,0,0-7.392-7.392h-26.99a7.394,7.394,0,0,0-7.392,7.392Z",
    transform: "translate(216.499 273.661)",
    fill: "#946526"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29364",
    "data-name": "Path 29364",
    d: "M144.095,219.877a7.392,7.392,0,0,0-7.392-7.392h-26.99a7.394,7.394,0,0,0-7.392,7.392Z",
    transform: "translate(131.779 273.661)",
    fill: "#946526"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29365",
    "data-name": "Path 29365",
    d: "M332.76,244.869c-.819-.442-1.656-.906-2.5-1.377-6.848.81-25.4-1.174-40.354-10.538-26.888-22.316-60.879-39.574-75.4-46.948-1.645-.835-3-1.524-4.022-2.057-1.986-1.034-3.844-4.052-5.4-7.038q-2.636-.933-5.308-1.821c.082.167.16.323.243.492,2.146,4.391,4.814,9.856,8.646,11.856,1.032.538,2.4,1.233,4.061,2.075,14.425,7.326,48.211,24.476,74.773,46.55l.21.153c12.9,8.12,29.258,11.325,39.093,11.325a21.375,21.375,0,0,0,6.992-.881,4.35,4.35,0,0,0,1.963-1.368c-1-.142-1.981-.284-2.988-.423",
    transform: "translate(257.28 225.5)",
    fill: "#cf8d35"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29366",
    "data-name": "Path 29366",
    d: "M259.012,224.108s-10.989-1.547-28.047-3.734a180.582,180.582,0,0,1,3.139-19.937,341.605,341.605,0,0,1,24.908,23.671",
    transform: "translate(297.462 258.145)",
    fill: "#c78733"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29367",
    "data-name": "Path 29367",
    d: "M255.209,226.282s-3.766,1.592-15.787,1.3a119.279,119.279,0,0,1-23.03-3.043s-4.924-25.492,11.588-28.1,27.228,11.3,27.228,11.3Z",
    transform: "translate(277.809 252.584)",
    fill: "#cf8d35"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29368",
    "data-name": "Path 29368",
    d: "M257.357,287.884a49.11,49.11,0,1,1,49.11,49.11,49.109,49.109,0,0,1-49.11-49.11",
    transform: "translate(331.452 307.519)",
    fill: "#0d1a38"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29369",
    "data-name": "Path 29369",
    d: "M264.4,278.816a33,33,0,1,1,33,33,33,33,0,0,1-33-33",
    transform: "translate(340.52 316.587)",
    fill: "#abebff"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29370",
    "data-name": "Path 29370",
    d: "M297.265,297.526a32.993,32.993,0,0,0,32.109-40.615c-10.531,11.179-33.495,19.992-50.943,7.326a35.241,35.241,0,0,0-13.535-6.143,33.007,33.007,0,0,0,32.369,39.432",
    transform: "translate(340.348 330.878)",
    fill: "#f2edff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2349",
    "data-name": "Rectangle 2349",
    width: 12.867,
    height: 12.867,
    transform: "translate(477.921 499.441)",
    fill: "#4c4c4c"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2350",
    "data-name": "Rectangle 2350",
    width: 12.867,
    height: 12.867,
    transform: "translate(452.187 499.441)",
    fill: "#4c4c4c"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2351",
    "data-name": "Rectangle 2351",
    width: 12.867,
    height: 12.867,
    transform: "translate(465.054 512.309)",
    fill: "#4c4c4c"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2352",
    "data-name": "Rectangle 2352",
    width: 12.867,
    height: 12.867,
    transform: "translate(439.32 512.309)",
    fill: "#4c4c4c"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2353",
    "data-name": "Rectangle 2353",
    width: 12.867,
    height: 12.867,
    transform: "translate(426.455 499.441)",
    fill: "#4c4c4c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerImg3);
export default __webpack_public_path__ + "static/media/banner_img3.bd1e2e08a02d5dd37eb0a9ad8bb49231.svg";
export { ForwardRef as ReactComponent };